import type { Dict } from "../types";

export const zhCN: Dict = {
  "collab.contentUpdate.available": "其他设备有更新",
  "collab.contentUpdate.updating": "正在同步…",
  "collab.contentUpdate.askAgain": "恢复更新提示",
  "collab.contentUpdate.title": "其他设备有更新",
  "collab.contentUpdate.description": "是否同步其他设备的最新内容到本机？同步将覆盖本机项目内容。页面可从本地历史版本恢复，图片等其他文件可能无法恢复。",
  "collab.contentUpdate.dontPrompt": "24 小时内本项目不再提示",
  "collab.contentUpdate.later": "暂不同步",
  "collab.contentUpdate.replace": "同步并覆盖",
  "collab.contentUpdate.failed": "更新失败，请重试。",
  "collab.contentUpdate.busy": "项目正在生成或上传，请完成后再更新。",
  "collab.contentUpdate.unsupported": "导入文件夹暂不支持云端覆盖。",
  "fileViewer.versions.sourceSync": "云端同步",
  'billing.wallet': '钱包余额',
  'billing.codingPlanDesignPlan': 'Design Plan',
  'billing.codingPlanPeriodHours': '{count} 小时',
  'billing.codingPlanPeriodDays': '{count} 天',
  'billing.codingPlanRemainingPercent': '剩余 {percent}%',
  "campaign.testReplay": "重新查看测试活动",
  'invite.header.eyebrow': "团队邀请",
  'invite.loading': "正在加载邀请…",
  'invite.landing.title': "加入团队",
  'invite.landing.subtitle': "你被邀请加入 OpenDesign 一起协作。",
  'invite.landing.roleLabel': "角色",
  'invite.landing.invitedEmail': "受邀邮箱",
  'invite.landing.expires': "有效期至",
  'invite.role.admin': "管理员",
  'invite.role.member': "成员",
  'invite.role.admin.desc': "可管理成员、席位以及全部项目设置。",
  'invite.role.member.desc': "可创建自己的项目，并查看和评论团队共享项目。",
  'invite.accept.cta': "接受邀请",
  'invite.accountMismatch.title': "当前登录的是其他账号",
  'invite.accountMismatch.body': "该邀请发送至另一个邮箱。你可以继续使用当前账号，或切换账号。",
  'invite.accountMismatch.continue': "继续使用当前账号",
  'invite.accountMismatch.switch': "切换账号",
  'invite.accepting.title': "正在加入团队…",
  'invite.accepting.body': "正在为你创建成员身份。",
  'invite.success.title': "已加入",
  'invite.success.body': "正在打开 OpenDesign，开始协作。",
  'invite.success.roleReceipt': "加入身份",
  'invite.success.enter': "进入工作空间",
  'invite.open.cta': "打开 OpenDesign",
  'invite.open.opening': "正在打开 OpenDesign…",
  'invite.open.retry': "已安装？再次尝试打开",
  'invite.notInstalled.title': "没有自动打开？",
  'invite.notInstalled.body': "你的设备可能还没有安装 OpenDesign。安装后重新打开此链接即可完成加入。",
  'invite.notInstalled.download': "下载 OpenDesign",
  'invite.error.title': "无法接受此邀请",
  'invite.error.invite_expired': "该邀请已过期。请让管理员重新发送。",
  'invite.error.invite_consumed': "该邀请已被使用。",
  'invite.error.workspace_seat_limit_reached': "团队席位已满。请让管理员释放或增加席位。",
  'invite.error.workspace_subscription_locked': "团队订阅未生效，暂时无法加入新成员。",
  'invite.error.workspace_not_found': "该工作空间已不存在。",
  'invite.error.workspace_forbidden': "你的账号无权接受此邀请。",
  'invite.error.invite_unavailable': "该邀请已不可用。",
  'invite.error.generic': "出了点问题，请重试。",
  'invite.error.retry': "重试",
  "workspaceInvite.dialogAria": "邀请成员",
  "workspaceInvite.title": "邀请成员加入你的团队",
  "workspaceInvite.freePlanBody": "免费版含 1 个席位，邀请同事后将引导你升级到团队版。",
  "workspaceInvite.teamPlanBody": "邀请同事加入团队，一起共享项目、设计系统与插件。",
  "workspaceInvite.seatsExhaustedBody": "当前工作空间的席位已用完，先增加席位后即可邀请同事。",
  "workspaceInvite.seatsExhaustedAction": "查看席位与套餐",
  "workspaceInvite.emailLabel": "通过电子邮件邀请成员",
  "workspaceInvite.roleLabel": "分配角色",
  "workspaceInvite.defaultRoleLabel": "默认身份",
  "workspaceInvite.emailPlaceholder": "输入电子邮件地址……",
  "workspaceInvite.removeRow": "移除",
  "workspaceInvite.addMember": "添加成员",
  "workspaceInvite.visibilityQuestion": "团队成员会看到我的设计吗?",
  "workspaceInvite.visibilityAnswer": "团队成员可以看到你共享到团队空间的设计；保存在「个人项目」中的私人设计不会对其他人可见。",
  "workspaceInvite.sent": "已发送邀请",
  "workspaceInvite.sending": "邀请中……",
  "workspaceInvite.confirm": "确认并邀请",
  "workspaceInvite.submitFailed": "邀请发送失败，请稍后重试。",
  "workspaceInvite.errorAlreadyMember": "该邮箱已是团队成员。",
  "workspaceInvite.errorPendingInvite": "该邮箱已有待接受的邀请。",
  "workspaceInvite.errorNoSession": "请先登录你的 Vela 账号再邀请成员。",
  "workspaceInvite.errorNoWorkspace": "当前还没有可邀请成员的团队空间。",
  "workspaceInvite.errorUnreachable": "邀请未能送达，请稍后重试。",
  "chat.amrCard.switchTitle": "模型调用失败，当前任务已暂停",
  "chat.amrCard.switchBody":
    "可切换到 OpenDesign Cloud 官方模型服务，无需配置 API Key。完成登录、授权和充值后，将自动重试当前任务。",
  "chat.amrCard.chipOfficial": "官方托管",
  "chat.amrCard.chipNoKey": "无需 API Key",
  "chat.amrCard.chipAutoRetry": "授权后自动重试",
  "chat.amrCard.switchCta": "切换到 OpenDesign Cloud",
  "chat.amrCard.switchedResend": "已切换到 OpenDesign Cloud，请重新发送任务。",
  "chat.amrError.authMessage":
    "OpenDesign Cloud 账号尚未授权。完成授权后将自动重试当前任务。",
  "chat.amrError.balanceMessage":
    "OpenDesign Cloud 额度不足。充值后可继续运行当前任务。",
  "chat.amrError.authorizeCta": "授权并重试",
  "chat.amrError.rechargeCta": "充值",
  "chat.amrBalanceGate.title": "可用额度不足",
  "chat.amrBalanceGate.message": "当前额度不足，请充值或升级套餐后再试。",
  "chat.amrBalanceGate.benefitsTitle": "OpenDesign Cloud 为你提供",
  "chat.amrBalanceGate.benefit1": "无需 API Key，海量模型任选",
  "chat.amrBalanceGate.benefit2": "自带 SOTA Design Agent，零配置",
  "chat.amrBalanceGate.benefit3": "官方服务，稳定有保障",
  "chat.amrBalanceGate.benefit4": "持续升级：一键部署、多模态、团队版等",
  "chat.amrBalanceGate.laterCta": "暂不需要",
  "chat.amrBalanceGate.plansCta": "升级套餐",
  "chat.amrBalanceGate.signedOutTitle": "Open Design 尚未登录",
  "chat.amrBalanceGate.signedOutMessage": "请先登录，以便查看项目和继续对话。",
  "chat.amrBalanceGate.signInCta": "立即登录",
  "chat.amrBalanceGate.watchingWallet": "额度更新后将自动继续。",
  "chat.amrArtifactUpgrade.title": "用更强模型继续完善作品",
  "chat.amrArtifactUpgrade.message": "解锁高阶模型、更多任务并发和更高每月积分。",
  "chat.amrArtifactUpgrade.benefit1": "更多高阶模型，如 Fable 5、GPT-5.6",
  "chat.amrArtifactUpgrade.benefit2": "任务并发最高提升 10 倍",
  "chat.amrArtifactUpgrade.benefit3": "月度积分最高提升 300 倍",
  "chat.amrArtifactUpgrade.benefit4": "高峰期优先排队，生成更快",
  "chat.amrArtifactUpgrade.promoBanner": "订阅套餐限时低至 3.3 折",
  "chat.amrArtifactUpgrade.countdownLabel": "优惠倒计时",
  "chat.amrArtifactUpgrade.plansCta": "立即升级套餐，低至 3.3 折",
  "chat.amrArtifactUpgrade.homePlansCta": "3.3 折升级",
  "chat.amrArtifactUpgrade.laterCta": "继续使用 Free 并发送",
  "chat.amrArtifactUpgrade.homeTitle": "作品已生成，让下一次创作更进一步",
  "chat.amrArtifactUpgrade.homeMessage": "升级即可解锁高阶模型、更多并发和更高每月积分。",
  "chat.amrArtifactUpgrade.homeArtifactCta": "查看作品",
  "chat.antigravityError.launchTerminalCta": "在终端中登录",
  "chat.antigravityError.launchSwitchModelCta": "在终端中切换模型",
  "chat.connectionDropped":
    "请确认网络连接正常后再试。",
  "chat.runError.title.authRequired": "需要授权",
  "chat.runError.title.balance": "额度不足",
  "chat.runError.title.connectionDropped": "当前网络中断",
  "chat.runError.title.signInRequired.other": "{agent} 尚未登录",
  "chat.runError.title.signInRequired.amr": "Open Design 尚未登录",
  "chat.runError.title.rateLimited": "模型服务请求繁忙",
  "chat.runError.title.modelWindowLimit": "高峰期繁忙",
  "chat.runError.title.membershipConcurrencyLimit": "并发任务已达上限",
  "chat.runError.title.strategyTaskHalted": "任务已被质量门拦下",
  "chat.runError.title.agentReplyIncomplete": "任务未能完成",
  "chat.runError.title.noDeliverable": "这一轮没有产出文件",
  "chat.runError.title.clarificationRepeated": "智能体又问了一个问题",
  "chat.runError.title.regionNotSupported": "当前地区暂不支持此服务",
  "chat.runError.title.clientEnvironment": "网络环境不对",
  "chat.runError.title.certificateFailure": "无法安全连接服务",
  "chat.runError.certificateFailureMessage": "连接服务时未通过安全验证，请尝试更换网络。",
  "chat.runError.title.proxyConfiguration": "无法连接代理",
  "chat.runError.proxyConfigurationMessage": "当前设置的代理无法连接，请确认代理已开启、设置正确后再试。",
  "chat.runError.title.networkConfiguration": "无法连接服务",
  "chat.runError.networkConfigurationMessage": "暂时无法访问服务，请检查网络连接后再试。",
  "chat.runError.title.hostPolicyBlock": "程序启动受限",
  "chat.runError.hostPolicyBlockMessage": "Windows 阻止了程序启动，请检查系统的安全设置。",
  "chat.runError.title.localStorageFailure": "无法保存文件",
  "chat.runError.localStorageFailureMessage": "文件无法写入磁盘。请确认有足够的剩余空间后，再重新尝试。",
  "chat.runError.title.tierUpgradeRequired": "当前套餐不支持此任务",
  "chat.runError.tierUpgradeRequiredMessage": "当前套餐无法继续此任务，请升级套餐后重试。",
  "chat.runError.title.generic": "任务未能完成",
  "chat.runError.title.artifactMissing": "暂无可预览的文件",
  "chat.runError.artifactMissingMessage": "本次任务没有可预览的文件，请补充需要生成的内容后再试。",
  "chat.runError.signInMessage.amr":
    "请先登录，以便查看项目和继续对话。",
  "chat.runError.signInMessage.other":
    "请先完成 {agent} 的登录，再重新尝试。",
  "chat.runError.agentFallback": "智能体",
  "chat.runError.sourceLabel": "查看错误详情",
  "chat.runError.sourceExpandAria": "展开报错源码",
  "chat.runError.sourceCollapseAria": "收起报错源码",
  "chat.runError.title.cliMissing": "未检测到 {agent}",
  "chat.runError.title.promptTooLarge": "对话内容过长",
  "chat.runError.title.modelUnavailable": "当前模型不可用",
  "chat.runError.title.modelCapabilityUnsupported": "当前模型不支持此任务",
  "chat.runError.title.upstreamUnavailable": "模型服务暂不可用",
  "chat.runError.title.toolLoop": "任务无法继续",
  "chat.runError.title.outputInvalid": "未能生成有效回复",
  "chat.runError.title.runtimeConfig": "Open Design 运行异常",
  "chat.runError.title.apiKeyInvalid": "模型设置不完整",
  "chat.runError.cliMissingMessage": "请确认这台电脑已安装 {agent}，安装完成后再试。",
  "chat.runError.promptTooLargeMessage": "当前上下文已超出模型可处理的长度，请新建对话后再试。",
  "chat.runError.modelUnavailableMessage": "请选择其他可用模型后再试。",
  "chat.runError.modelCapabilityUnsupportedMessage": "该模型不支持任务所需的功能，请更换模型后再试。",
  "chat.runError.rateLimitedMessage": "当前使用该模型服务的请求较多，已达到供应商的请求频率上限，请稍后再试，或尝试切换其他模型。",
  "chat.runError.modelWindowLimitMessage": "高峰期繁忙，请在 {retryAt} 后尝试（本次请求未扣费）",
  "chat.runError.modelWindowLimitMessageNoTime": "高峰期繁忙，请稍后再试（本次请求未扣费）",
  "chat.runError.membershipConcurrencyLimitMessage": "当前会员的并发任务已满。请等到 {retryAt} 后重试，或切换到其他智能体；立即重复尝试不会恢复。",
  "chat.runError.membershipConcurrencyLimitMessageNoTime": "当前会员的并发任务已满。请等待其他任务结束后重试，或切换到其他智能体；立即重复尝试不会恢复。",
  "chat.runError.upstreamUnavailableMessage": "当前模型暂不可用，请稍后再试，或更换模型。",
  "chat.runError.toolLoopMessage": "AI 在处理任务时卡在了同一个步骤，多次尝试后仍无法继续。请重试，或更换模型后再试。",
  "chat.runError.outputInvalidMessage": "请尝试重新生成，或更换模型后重试。如果问题持续出现，请联系支持。",
  "chat.runError.runtimeConfigMessage": "请尝试重新生成，或更换模型后重试。如果问题持续出现，请联系支持。",
  "chat.runError.apiKeyInvalidMessage": "API key 配置错误，请重新填写后重试。",
  "chat.runError.title.quotaExhausted": "额度已用尽",
  "chat.runError.title.timedOut": "等待回复超时",
  "chat.runError.title.emptyOutput": "未能生成内容",
  "chat.runError.title.sessionExpired": "无法继续上一次任务",
  "chat.runError.title.gitBashMissing": "缺少 Git Bash",
  "chat.runError.title.cpuUnsupported": "当前设备无法运行此程序",
  "chat.runError.title.osUnsupported": "Windows 版本过旧",
  "chat.runError.title.cliSessionRefused": "智能体版本不兼容",
  "chat.runError.quotaExhaustedMessage": "所用模型服务的额度或账单上限已用尽，重试也无法恢复。请前往对应服务充值，或切换到其他模型/服务。",
  "chat.runError.workspaceCreditsMessage": "工作区额度已用尽。请充值（或联系工作区管理员补充），或切换到其他模型/服务。",
  "chat.runError.timedOutMessage": "长时间未收到 AI 的新回复，本次运行已停止，请稍后再试。",
  "chat.runError.inactivityTimeoutMessage": "长时间未收到 AI 的新回复，本次运行已停止，请稍后再试。",
  "chat.runError.emptyOutputMessage": "AI 未能生成内容，请重新发起任务，或更换模型后再试。",
  "chat.runError.sessionExpiredMessage": "上一次任务已无法继续运行，请重新发起任务。",
  "chat.runError.gitBashMissingMessage": "在 Windows 上运行该智能体需要 Git Bash，但未找到。请安装 Git for Windows 后重试。",
  "chat.runError.cpuUnsupportedMessage": "这台电脑的处理器不支持程序所需的功能，请使用符合运行要求的设备。",
  "chat.runError.osUnsupportedMessage": "当前 Windows 版本过旧，无法运行 AMR 运行时。请升级到 Windows 10 1809（版本号 17763）或更高版本后再试。",
  "chat.runError.title.agentCrashed": "任务意外中断",
  "chat.runError.agentCrashedMessage": "请尝试重新生成，或更换模型后重试。如果问题持续出现，请联系支持。",
  "chat.runError.title.accountSuspended": "账号已停用",
  "chat.runError.accountSuspendedMessage": "如需了解原因或申请恢复，请联系支持。",
  "chat.runError.fallbackMessage": "本次任务运行失败，请重试。如果再次失败，请联系支持。",
  "chat.runError.cliSessionRefusedMessage": "Open Design 暂不支持当前智能体版本，请更换为支持的版本后再试。",
  "chat.runError.strategyTaskStateMismatchMessage": "该任务已被策略质量门拦下，本轮表单无法继续提交。请重试请求或重新发起一次任务。",
  "chat.runError.agentReplyIncompleteMessage": "本次任务运行失败，请重试。如果再次失败，请联系支持。",
  "chat.runError.noDeliverableMessage": "智能体跑完了，但项目里还没有可以打开的成品，任务因此没能记成已交付。你提交的内容没有丢失——直接重试，或者补一句你想要什么再发一次。",
  "chat.runError.clarificationRepeatedMessage": "智能体还想再确认一些信息，于是又问了一次；但一个任务只允许一轮提问，所以停在了这里。你的回答仍然保留在对话里——重试会把请求重新跑一遍，把要补充的信息一起写进去，通常一轮就能问清楚。",
  "chat.runError.regionNotSupportedMessage": "服务商暂不向你所在的地区提供服务，当前任务无法继续。",
  "chat.runError.clientEnvironmentMessage": "看起来走了代理或公司网络，{agent} 拒绝了请求（{cause}）。换一个网络出口，或在设置里调整代理。",
  "chat.runError.clientEnvironmentCause.certificate": "证书校验失败",
  "chat.runError.clientEnvironmentCause.proxy": "代理配置有问题",
  "chat.runError.clientEnvironmentCause.network": "网络连不上",
  "chat.runError.clientEnvironmentCause.hostPolicy": "被系统策略拦截",
  "chat.runError.clientEnvironmentCause.localStorage": "本机存储读写失败",
  "common.cancel": "取消",
  "chat.selectFromLibrary": "从资源库导入",
  "chat.importFigma": "从 Figma 导入",
  "chat.plus.group.files": "文件",
  "chat.plus.group.code": "代码",
  "chat.plus.group.designs": "设计",
  "chat.plus.group.other": "其他",
  "chat.plus.attachFiles": "附加文件",
  "chat.plus.referenceProject": "引用其它项目",
  "chat.plus.linkLocalCode": "关联本地代码",
  "chat.plus.uploadFig": "上传 .fig 文件",
  "chat.plus.learnHow": "查看方法",
  "chat.plus.designSystem": "设计系统",
  "chat.plus.skills": "技能",
  "chat.plus.noSkills": "暂无可用技能",
  "chat.plus.connectors": "连接器",
  "chat.plus.plugins": "插件",
  "chat.plus.mcp": "MCP",
  "chat.referenceProject.title": "引用其它项目",
  "chat.referenceProject.search": "搜索项目…",
  "chat.referenceProject.empty": "没有匹配“{query}”的项目",
  "chat.referenceProject.emptyAll": "暂无其它项目",
  "chat.referenceProject.loadFailed": "无法加载项目。请确认 daemon 正在运行后重试。",
  "chat.referenceProject.confirm": "引用项目",
  "chat.contextPrompt.referenceProject":
    "请把 OpenDesign 项目“{name}”作为参考上下文。它的本地路径是：{path}。在设计或修改前，如有帮助请先搜索并读取这个目录。",
  "chat.contextPrompt.localCode":
    "请把本地代码目录“{name}”作为代码参考。它的绝对路径是：{path}。如有帮助请先读取相关文件，并与现有实现保持一致。",
  "chat.figmaHelp.title": "如何下载 .fig 文件",
  "chat.figmaHelp.intro": "从 Figma 网页版或桌面版：",
  "chat.figmaHelp.step1": "打开 Figma 文件。",
  "chat.figmaHelp.step2": "进入 File → Save local copy...（网页版在主菜单 → File）。",
  "chat.figmaHelp.step3": "Figma 会下载一个 .fig 文件，把它拖入输入框或上传。",
  "chat.figmaHelp.note": ".fig 文件会在本机解析，不会上传到 Figma。",
  "designFiles.library.label": "从资源库导入",
  "designFiles.library.title": "从资源库导入",
  "libraryPicker.title": "从资源库导入",
  "libraryPicker.searchPlaceholder": "搜索资源库…",
  "libraryPicker.empty": "资源库暂无内容",
  "libraryPicker.allKinds": "全部",
  "libraryPicker.add": "导入",
  "libraryPicker.loading": "加载中…",
  "common.save": "保存",
  "common.close": "关闭",
  "common.clear": "清除",
  "common.delete": "删除",
  "common.rename": "重命名",
  "common.edit": "编辑",
  "common.preview": "预览",
  "common.share": "分享",
  "common.search": "搜索",
  "common.searchEllipsis": "搜索…",
  "common.loading": "加载中…",
  "common.all": "全部",
  "common.none": "无",
  "common.default": "默认",
  "common.installed": "已安装",
  "common.notInstalled": "未安装",
  "common.active": "使用中",
  "common.inactive": "未使用",
  "common.offline": "未运行",
  "common.selected": "已选",
  "common.create": "创建",
  "common.openPreview": "打开预览",
  "common.exitFullscreen": "退出全屏",
  "common.fullscreen": "全屏",
  "common.openInNewTab": "在新标签页中打开",
  "common.exportPdf": "导出为 PDF",
  "common.exportZip": "下载为 .zip",
  "common.exportHtml": "导出为独立 HTML",
  "common.exportImage": "导出为图片",
  "common.exportImageFailed": "图片截图失败，请重试或使用浏览器的截图工具。",
  "common.justNow": "刚刚",
  "common.minutesAgo": "{n} 分钟前",
  "common.hoursAgo": "{n} 小时前",
  "common.daysAgo": "{n} 天前",
  "common.weeksAgo": "{n} 周前",
  "common.now": "刚刚",
  "common.minutesShort": "{n}分",
  "common.hoursShort": "{n}时",
  "common.daysShort": "{n}天",
  "common.untitled": "未命名",
  "plugins.availableDetails.provenance": "来源",
  "plugins.availableDetails.provenanceLine":
    "来自 {source} · {trust} · {resolved}",
  "plugins.availableDetails.provenanceLineWithIntegrity":
    "来自 {source} · {trust} · {resolved} · {integrity}",
  "plugins.availableDetails.install": "安装",
  "plugins.availableDetails.version": "版本",
  "plugins.availableDetails.pluginVersion": "插件版本",
  "plugins.availableDetails.copyInstallCommand": "复制安装命令",
  "plugins.availableDetails.copied": "已复制",
  "plugins.availableDetails.deprecatedPrefix": "已弃用：{message}",
  "plugins.availableDetails.deprecatedFallback": "此版本已标记为弃用。",
  "plugins.availableDetails.yanked": "已撤回。",
  "plugins.availableDetails.yankedWithReason": "已撤回：{reason}",
  "plugins.availableDetails.versionDeprecatedSuffix": "（已弃用）",
  "plugins.availableDetails.versionYankedSuffix": "（已撤回）",
  "plugins.availableDetails.ref": "引用",
  "plugins.availableDetails.integrity": "Integrity",
  "plugins.availableDetails.permissions": "权限",
  "plugins.availableDetails.capabilitySummary": "能力摘要",
  "plugins.actions.copyInstallCommand": "复制安装命令",
  "plugins.actions.copyPluginId": "复制插件 ID",
  "plugins.actions.copyReadmeBadge": "复制 README 徽章",
  "plugins.actions.openSourceGithub": "在 GitHub 打开源码",
  "plugins.actions.openSource": "打开源码",
  "plugins.actions.openHomepage": "打开项目主页",
  "plugins.actions.openMarketplace": "在插件市场打开",
  "app.brand": "OpenDesign",
  "app.brandPill": "研究预览版",
  "app.brandSubtitle": "由 Nexu Labs 出品",
  "app.welcomeLoading": "正在加载工作区…",
  "settings.welcomeKicker": "",
  "settings.welcomeTitle": "欢迎使用 OpenDesign",
  "settings.welcomeSubtitle": "",
  "settings.onboardingCreateTitle": "从一句需求开始",
  "settings.onboardingCreateBody":
    "描述你想做的网站、应用、Deck、图片或视频，OpenDesign 会创建项目，并保留可继续编辑的产物。",
  "settings.onboardingMemoryTitle": "保存工作上下文",
  "settings.onboardingMemoryBody":
    "把偏好、项目事实和长期规则写入 Memory，后续对话会自动带上正确背景。",
  "settings.onboardingMemoryCalloutTitle": "已保存到你的记忆",
  "settings.onboardingMemoryCalloutBody":
    "这些回答会构成你的记忆画像。OpenDesign 会在每个任务中复用它，并在你工作时持续学习。",
  "settings.onboardingMemoryBenefitIntent": "从一句简短需求就能理解你的意图",
  "settings.onboardingMemoryBenefitFewerQuestions": "跳过重复的设置提问",
  "settings.onboardingMemoryBenefitPersonalized":
    "按你的角色、受众和品味定制产出",
  "settings.onboardingSystemsTitle": "接入你的设计系统",
  "settings.onboardingSystemsBody":
    "选择或创建品牌系统，让生成结果跟随真实的颜色、字体和产品语言。",
  "settings.onboardingExecutionTitle": "选择模型来源",
  "settings.onboardingExecutionBody":
    "使用 OpenDesign 托管服务、连接本地 Agent，或使用你自己的模型 Key。",
  "settings.onboardingAmrCloudBenefitOfficial": "官方推荐",
  "settings.onboardingAmrCloudBenefitReady": "免部署即用",
  "settings.onboardingAmrCloudBenefitModels":
    "限时优惠、高并发使用 Claude、GPT、Fable 5 和 5.6 sol。",
  "settings.onboardingAmrCloudBenefitPricing": "SOTA Harness",
  "settings.onboardingAmrCloudUpcomingLabel": "即将支持",
  "settings.onboardingAmrCloudUpcomingImageVideo": "生图/视频",
  "settings.onboardingAmrCloudUpcomingSkills": "海量 Skills",
  "settings.onboardingAmrCloudUpcomingRouting": "智能路由",
  "settings.onboardingAmrModelSourceLabel": "OpenDesign 托管",
  "settings.onboardingAmrCloudAuthorizeAction": "授权 OpenDesign Cloud",
  "settings.onboardingAmrCloudAuthorizedAction": "已授权",
  "settings.onboardingStepConnect": "连接",
  "settings.onboardingStepDesignSystem": "构建设计系统",
  "settings.onboardingStepProfile": "了解你",
  "settings.onboardingStepNewsletter": "获取最新动态",
  "settings.onboardingNewsletterTitle": "获取最新动态",
  "settings.onboardingNewsletterBody":
    "留下邮箱，接收产品更新、新模板、设计系统资源和社区活动。",
  "settings.onboardingConnectTitle": "选择运行方式",
  "settings.onboardingConnectBody": "",
  'settings.onboardingCloudTitle': '欢迎使用 OpenDesign',
  'settings.onboardingCloudBody': '让灵感变成设计。',
  'settings.onboardingCloudSignIn': '登录 / 注册',
  'settings.onboardingFreeCredits': '免费额度',
  'settings.onboardingFreeCreditsHint': '新用户注册即赠体验额度，可免费试用 DeepSeek V4.1 Flash 模型。',
  'settings.onboardingOwnAi': '或使用自己的 AI',
  'settings.onboardingLocalAi': '本地 AI',
  'settings.onboardingApiKey': 'API 密钥',
  "settings.onboardingCloudContinue": "继续（已登录）",
  "settings.onboardingCloudAlternative": "使用本地 CLI 或自己的 API Key",
  "settings.onboardingCloudRights": "保留所有权利。",
  "settings.onboardingCloudOr": "或",
  "settings.onboardingGateTooltipNoRuntime":
    "后续流程由 AI 运行，请先选择一种运行方式。",
  "settings.onboardingGateTooltipAmr":
    "后续流程由 AI 运行，请先登录 OpenDesign Cloud。",
  "settings.onboardingGateTooltipLocal":
    "后续流程由 AI 运行，请先选择一个可用的本地 CLI。",
  "settings.onboardingGateTooltipByok":
    "后续流程由 AI 运行，请先填写并测试通过你的模型 Key。",
  "settings.onboardingRecommended": "推荐",
  "settings.onboardingAmrCloudOfficialBadge": "官方",
  "settings.onboardingLocalTitle": "本地 Agent",
  "settings.onboardingLocalBody":
    "使用 Claude Code、Codex、Cursor、OpenCode、Kimi、Qwen、Hermes、Kiro 等。",
  "settings.onboardingLocalAction": "打开 CLI 设置",
  "settings.onboardingCliScanHint": "通常 5 到 10 秒内完成扫描。",
  "settings.onboardingByokTitle": "使用自己的 Key",
  "settings.onboardingByokBody":
    "使用自己的 API Key，安全连接你偏好的模型服务商。",
  "settings.onboardingByokAction": "打开 BYOK 设置",
  "settings.onboardingDesignTitle": "设计系统",
  "settings.onboardingDesignBody": "生成一次，后续复用。",
  "settings.onboardingDesignIntroGenerateTitle": "用已有内容生成",
  "settings.onboardingDesignIntroGenerateBody":
    "从 GitHub、本地代码仓库、Figma 文件，或现成图片等内容资产中上传你的设计系统。",
  "settings.onboardingDesignIntroReuseTitle": "后续产物直接复用",
  "settings.onboardingDesignIntroReuseBody":
    "后续生成原型、Slide 和其他内容时，都可以参考现有的字体、间距、Logo 样式、色调等。",
  "settings.onboardingDesignIntroSkipTitle": "也可以先跳过",
  "settings.onboardingDesignIntroSkipBody":
    "现在不想生成也没关系，可以直接进入产品。",
  "settings.onboardingGithubTitle": "从 GitHub 导入",
  "settings.onboardingGithubBody": "使用前端仓库。",
  "settings.onboardingUploadTitle": "上传本地文件",
  "settings.onboardingUploadBody": "添加项目文件、截图、CSS、文档或素材。",
  "settings.onboardingPromptTitle": "用一句话生成",
  "settings.onboardingPromptBody": "描述产品或品牌。",
  "settings.onboardingProfileTitle": "关于你",
  "settings.onboardingProfileBody": "可选信息，用于优化默认配置。",
  "settings.onboardingRoleLabel": "你的身份",
  "settings.onboardingOrgSizeLabel": "组织规模",
  "settings.onboardingUseCaseLabel": "使用场景",
  "settings.onboardingSourceLabel": "从哪里听说的",
  "settings.onboardingSourceX": "🐦 X / Twitter",
  "settings.onboardingSourceGithub": "🐙 GitHub",
  "settings.onboardingSourceYoutube": "▶️ YouTube",
  "settings.onboardingSourceTiktok": "🎵 TikTok",
  "settings.onboardingSourceReddit": "👽 Reddit",
  "settings.onboardingSourceLinkedin": "💼 LinkedIn",
  "settings.onboardingSourceMetaSocial": "📸 Instagram / Threads / Facebook",
  "settings.onboardingSourceSearch": "🔍 搜索（Google / Bing）",
  "settings.onboardingSourceAiTool": "🤖 AI 工具（ChatGPT / Perplexity）",
  "settings.onboardingSourceFriend": "👥 朋友或同事",
  "settings.onboardingSourceCommunity": "💬 Discord / 社区",
  "settings.onboardingSourceEmail": "✉️ 邮件 / 邮件订阅",
  "settings.onboardingSourceBlog": "📝 博客 / 文章",
  "settings.onboardingSourceOther": "✨ 其他",
  "settings.onboardingSourceOtherPlaceholder": "告诉我们具体在哪（选填）",
  "settings.onboardingSelectPlaceholder": "请选择",
  "settings.onboardingSelectMultiplePlaceholder": "可选择多个",
  "settings.onboardingOrgSolo": "个人使用（1 人）",
  "settings.onboardingOrgTeam": "小团队（2-10 人）",
  "settings.onboardingOrgStartup": "初创 / 中小企业（11-50 人）",
  "settings.onboardingOrgGrowth": "成长期公司（51-200 人）",
  "settings.onboardingOrgMidMarket": "中大型公司（201-1000 人）",
  "settings.onboardingOrgEnterprise": "大型企业（1000+ 人）",
  "settings.onboardingRolePm": "📋 产品经理",
  "settings.onboardingRoleDesigner": "🎨 设计师",
  "settings.onboardingRoleEngineer": "💻 研发",
  "settings.onboardingRoleMarketing": "📣 营销",
  "settings.onboardingRoleAgency": "📣 营销代理商",
  "settings.onboardingRoleGrowth": "📈 增长",
  "settings.onboardingRoleOps": "⚙️ 运营",
  "settings.onboardingRoleFounder": "🚀 创始人 / 管理者",
  "settings.onboardingRoleStudent": "🎓 学生 / 教育者",
  "settings.onboardingRoleOther": "✨ 其他",
  "settings.onboardingUseProduct": "🎨 产品设计",
  "settings.onboardingUseDesignSystem": "🧩 设计系统",
  "settings.onboardingUsePrototype": "📱 原型 / 应用界面",
  "settings.onboardingUseLanding": "🌐 落地页",
  "settings.onboardingUseAds": "📣 广告 / 社媒内容",
  "settings.onboardingUseDashboard": "📊 仪表盘 / 内部工具",
  "settings.onboardingUseDeck": "🖥️ 演示文稿 / 提案",
  "settings.onboardingUseMarketing": "📈 营销 / 增长",
  "settings.onboardingUseEngineering": "🤝 工程交付",
  "settings.onboardingUseAgency": "💼 代理商 / 客户项目",
  "settings.onboardingBack": "上一步",
  "settings.onboardingContinue": "继续",
  "settings.onboardingFinish": "完成",
  "settings.kicker": "设置",
  "settings.title": "模型与提供商",
  "settings.subtitle": "在本机 CLI 与 BYOK 之间选择。",
  "settings.general": "通用",
  "settings.generalHint": "语言、外观、通知、项目位置、隐私和应用详情。",
  "settings.modeAria": "执行模式",
  "settings.protocolAria": "API 协议",
  "settings.modeDaemon": "本机 CLI",
  "settings.modeDaemonHelp": "通过本机的代码代理 CLI 执行",
  "settings.modeDaemonOffline": "后台守护进程未运行",
  "settings.modeDaemonOfflineMeta": "守护进程未运行",
  "settings.modeDaemonInstalledMeta": "已安装 {count} 个",
  "settings.modeApi": "API 提供方",
  "settings.cloudCalloutTitle": "使用 OpenDesign Cloud",
  "settings.cloudCalloutBody": "登录云端版本后可启用团队空间、共享项目、成员权限和审计大盘。",
  "settings.cloudCalloutButton": "登录 / 注册",
  "settings.modeApiMeta": "API 提供商",
  "settings.byokNoFileToolsNotice":
    "BYOK 无法读写或修改项目文件；需要改代码时请使用本机 CLI。",
  "settings.byokDraftNotice":
    "填写必填项后即可保存此提供商；当前配置将继续保持生效。",
  "settings.codeAgent": "代码代理",
  "settings.codeAgentHint": "选择用来运行提示词的 CLI。",
  "settings.rescan": "↻ 重新扫描",
  "settings.rescanTitle": "重新扫描 PATH",
  "settings.rescanRunning": "扫描中...",
  "settings.rescanSuccess": "扫描完成，{count} 个可用。",
  "settings.designSystemRenameFailed": "重命名失败，请检查后台守护进程后重试。",
  "settings.rescanFailed": "扫描失败，请检查后台守护进程后重试。",
  "settings.test": "测试",
  "settings.testTitle": "发送极小的测试提示词以验证连接",
  "settings.testRunning": "正在测试连接…",
  "settings.byokReadyToTest": "可测试连接",
  "settings.testCancel": "取消",
  "settings.testRetry": "重新测试",
  "settings.required": "必填",
  "settings.testMissingFields": "请填写 {fields} 后再测试连接。",
  "settings.testSuccessApi": "已连接。{ms} 毫秒响应 — '{sample}'",
  "settings.testSuccessCli": "{agentName} 在 {ms} 毫秒内响应 — '{sample}'",
  "settings.testAuthFailed": "鉴权失败，请检查 API 密钥。",
  "settings.testForbidden": "访问被拒绝。请检查账号、地区或组织。",
  "settings.testNotFoundModel": "未在此端点找到模型 '{model}'。",
  "settings.testInvalidModelId":
    "模型 ID '{model}' 格式无效。自定义 ID 必须以字母或数字开头，且不能包含空格。",
  "settings.testInvalidBaseUrl": "Base URL 无效或不可达。",
  "settings.testRateLimited": "提供商对测试进行了限流，配置看起来有效。",
  "settings.testUpstream": "提供商返回 {status}，请稍后再试。",
  "settings.testTimeout": "测试在 {ms} 毫秒后超时。",
  "settings.testAgentMissing": "{agentName} 未安装，或不在 PATH 中。",
  "settings.testAgentSpawn": "无法启动 {agentName}：{detail}。",
  "settings.testUnknown": "测试失败：{detail}",
  "settings.agentInstall.install": "安装",
  "settings.agentInstall.docs": "查看文档",
  "settings.agentInstall.pathHint":
    "如果你通过 npm 或 Homebrew 安装了 CLI，但仍显示为未安装，请确认该工具的 bin 目录已加入 OpenDesign daemon 继承的 PATH（在 macOS 上，Terminal 与 GUI 应用的 PATH 可能不同）。请参阅 QUICKSTART.md（“Local agent CLI and PATH” 章节）。",
  "settings.agentInstall.stepOpenLinks":
    "在目标代理卡片上打开“安装”或“文档”链接。",
  "settings.agentInstall.stepAuth":
    "返回 OpenDesign 之前，请先在对应 CLI 中完成认证（登录或添加 API 凭据）。",
  "settings.agentInstall.stepRescan": "在此区域点击“重新扫描”。",
  "settings.agentInstall.stepSelect": "当代理显示为已安装后，选择该代理卡片。",
  "settings.noAgentsDetected":
    "尚未检测到任何代理。请安装 Claude Code、Codex、OpenCode、Cursor Agent、Qwen 或 GitHub Copilot CLI 中的一个，然后点击「重新扫描」。",
  "settings.agentInstalledGroup": "你的 CLI（{count}）",
  "settings.agentInstallGroup": "可安装（{count}）",
  "settings.agentAuthRequired": "需要认证",
  "settings.agentAuthUnknown": "认证状态未知",
  "settings.amrCloud": "OpenDesign Cloud",
  "settings.amrAuthorize": "授权",
  "settings.amrBenefitOfficial": "官方推荐",
  "settings.amrBenefitLowerPrice": "免部署即用",
  "settings.amrBenefitManyModels": "多种模型",
  "settings.amrPromoBonus": "限时充值赠 100%",
  "settings.amrSignInToContinue": "授权后继续",
  "settings.amrSignIn": "登录",
  "settings.amrSignedIn": "已登录",
  "settings.amrWalletBalance": "钱包余额",
  "settings.amrWalletUnavailable": "余额暂不可用",
  "settings.amrWalletUpdatedAt": "更新于 {time}",
  "settings.amrWalletCached": "缓存",
  "settings.amrWalletRefresh": "刷新",
  "settings.amrWalletRefreshTitle": "刷新 OpenDesign Cloud 钱包余额",
  "settings.amrNotSignedIn": "未授权",
  "settings.amrSigningIn": "登录中…",
  "settings.amrActivationHint": "没有弹出登录页?点击下方按钮重新拉起",
  "settings.amrActivationBrowserFailedTitle": "无法打开登录页面",
  "settings.amrActivationBrowserFailedDescription": "浏览器未能自动打开，请重新尝试登录。",
  "settings.amrActivationOpen": "打开登录页",
  "settings.amrCancelSignIn": "取消登录",
  "settings.onboardingActivationPrompt": "登录页没打开？",
  "settings.onboardingActivationBrowserFailed": "无法自动打开浏览器。",
  "settings.onboardingActivationReopen": "重新打开",
  "settings.amrAccountStatus": "OpenDesign Cloud 账户状态",
  "settings.amrConsole": "OpenDesign Cloud 管理",
  "settings.amrLoginErrorCompact": "OpenDesign Cloud 登录失败。",
  "settings.advanced": "高级设置",
  "settings.amrLogin": "登录",
  "settings.amrLogout": "登出",
  "settings.amrLoggingIn": "登录中…",
  "settings.amrLoggingOut": "退出中…",
  "settings.amrLoggedInAs": "已登录 {email}",
  "settings.amrLoggedInWithPlan": "已登录 {email} · {plan}",
  "settings.amrLoggedInPill": "已登录",
  "settings.amrNotLoggedIn": "未授权",
  "settings.apiSection": "Anthropic API",
  "settings.quickFillProvider": "快速填充提供方",
  "settings.providerPreset": "提供商预设",
  "settings.protocolGroupProtocols": "协议",
  "settings.protocolGroupGateways": "网关",
  "settings.customProvider": "自定义提供方",
  "settings.apiKey": "API Key",
  "settings.apiKeyGetLink": "获取 key ↗",
  "settings.showKey": "显示 Key",
  "settings.hideKey": "隐藏 Key",
  "settings.show": "显示",
  "settings.hide": "隐藏",
  "settings.model": "模型",
  "settings.apiKeyInvalid": "API key 无效。",
  "settings.apiKeyCleaned": "已移除 API key 中多余的空白字符。",
  "settings.modelsLoadedFromAccount": "✓ 已从你的账号加载 {count} 个模型。",
  "settings.modelsLoadedCount": "✓ 已加载 {count} 个模型。",
  "settings.modelSourceAccount": "来自你的账号",
  "settings.modelSourceSuggested": "建议",
  "modelCapability.standard": "Standard",
  "modelCapability.advanced": "Advanced",
  "modelCapability.bestQuality": "Best Quality",
  "modelCapability.standardDescription": "Solid quality for regular tasks.",
  "modelCapability.advancedDescription": "Stronger quality for more demanding tasks.",
  "modelCapability.bestQualityDescription": "Best output quality for the most demanding work.",
  "modelCost.upToHalf": "低成本",
  "modelCost.halfToOne": "中成本",
  "modelCost.oneToFour": "高成本",
  "modelCost.overFour": "最高成本",
  "settings.fetchModels": "拉取模型",
  "settings.fetchModelsTitle": "从当前提供方拉取可用模型",
  "settings.fetchModelsRunning": "正在拉取模型…",
  "settings.fetchModelsMissingFields": "请填写 {fields} 后再拉取模型。",
  "settings.fetchModelsInvalidBaseUrl": "请输入有效的 Base URL 后再拉取模型。",
  "settings.fetchModelsUnsupportedAzure":
    "Azure OpenAI 使用部署名称，此处不支持自动发现模型。",
  "settings.fetchModelsUnsupportedOllama":
    "Ollama Cloud 暂不支持自动发现模型，请选择或输入模型。",
  "settings.fetchModelsSuccess": "已拉取 {count} 个模型。",
  "settings.fetchModelsEmpty": "未返回可兼容的文本模型。",
  "settings.fetchModelsUnsupported": "此协议暂不支持自动发现模型。",
  "settings.fetchModelsFailed": "无法拉取模型：{detail}",
  "settings.suggestedModelsHint":
    "这些是此协议的建议模型。你的提供方可能支持不同的模型。",
  "settings.baseUrl": "Base URL",
  "settings.baseUrlInvalid": "使用公网 http:// 或 https:// URL。",
  "settings.baseUrlCustomize": "自定义 URL",
  "settings.baseUrlDefaultHint": "仅在使用代理或兼容网关时修改。",
  "settings.azureBaseUrlPlaceholder": "粘贴 Azure endpoint URL",
  "settings.azureBaseUrlHint":
    "在 Azure portal → 你的 resource → Endpoint 中找到。",
  "settings.azureDeploymentModel": "部署名称",
  "settings.azureCustomDeploymentName": "自定义部署名称",
  "settings.azureDeploymentModelHint":
    "对于 Azure OpenAI，此字段会作为 /openai/deployments/<model> 中的部署名称使用。请填写你在 Azure 中创建的部署名称。",
  "settings.azureModelFetchHint":
    "填写 Azure resource 里的部署名称。Azure deployment 目前无法自动拉取。",
  "settings.apiVersion": "API 版本",
  "settings.byokImageModel": "图片生成模型",
  "settings.byokVideoModel": "视频生成模型",
  "settings.byokVideoI2vHint":
    "图生视频模型:需要参考图(不指定时自动使用项目中最新的图片)",
  "settings.byokSpeechModel": "语音生成模型",
  "settings.byokSpeechVoice": "音色",
  "settings.byokModelDefaultOption": "默认",
  "settings.maxTokens": "最大 tokens（可选）",
  "settings.maxTokensHint": "最大响应长度。留空则使用模型默认值。",
  "settings.apiHint": "仅保存在此设备本地。",
  "settings.skipForNow": "暂时跳过",
  "settings.getStarted": "开始使用",
  "settings.envConfigure": "模型与提供商",
  "settings.localCli": "本机 CLI",
  "settings.dshSetupTitle": "连接 DeepSeek Harness",
  "settings.dshSetupDescription": "OpenDesign 将通过这台电脑上的 dsh CLI 安装连接组件。",
  "settings.dshSetupNote": "只安装 OpenDesign 的 profile 组件。DeepSeek Harness 仍由你自行安装和管理。",
  "settings.dshSetupConfirm": "安装并选择",
  "settings.dshSetupInstalling": "正在安装…",
  "settings.dshSetupRequired": "需要安装连接组件",
  "settings.anthropicApi": "Anthropic API",
  "settings.noAgentSelected": "尚未选择代理",
  "settings.language": "界面语言",
  "settings.languageHint": "切换界面语言，设置仅保存在当前浏览器。",
  "settings.agentModelHead": "模型：",
  "settings.modelPicker": "模型",
  "settings.modelSourceLive": "来自 CLI 的实时列表",
  "settings.modelUsesCliDefault": "CLI 默认设置",
  "settings.modelSourceFallback": "内置列表",
  "settings.reasoningPicker": "推理强度",
  "settings.serviceTierPicker": "服务层级",
  "settings.modelPickerHint":
    "当 CLI 提供 `models` 命令时会自动拉取。选择「默认」则沿用 CLI 自身的配置；选择「自定义」可手动输入任何 CLI 支持的模型 id。",
  "settings.modelPickerLiveHint":
    "模型列表来自这个 CLI；选“默认”会沿用 CLI 自己的设置。",
  "settings.modelPickerLiveCatalogOnlyHint": "模型列表来自这个 CLI。",
  "settings.modelPickerFallbackHint":
    "正在显示内置默认值。点击“重新扫描”可从 CLI 拉取实时模型。",
  "settings.cliEnvTitle": "高级：代理与自定义路径",
  "settings.cliEnvHint":
    "用于覆盖所选 CLI 的底层环境变量：API key、代理 base URL、自定义 home 或非标准可执行文件路径。不填 base URL 时，CLI 会使用自己的默认接口地址。密钥只保存在本地应用配置中，并且只传给所选 CLI。",
  "settings.cliEnvClaudeConfigDir": "Claude Code 配置目录",
  "settings.cliEnvClaudeBaseUrl": "Claude proxy base URL",
  "settings.cliEnvClaudeApiKey": "Claude CLI API key",
  "settings.cliEnvCodexHome": "Codex home",
  "settings.cliEnvCodexBin": "Codex 可执行文件路径",
  "settings.cliEnvCodexBaseUrl": "Codex/OpenAI proxy base URL",
  "settings.cliEnvCodexApiKey": "Codex/OpenAI CLI API key",
  "settings.modelCustom": "自定义（在下方填写）…",
  "settings.modelCustomLabel": "自定义模型 id",
  "settings.modelCustomPlaceholder": "例如 anthropic/claude-sonnet-4-6",
  "settings.mediaProviders": "媒体生成提供商",
  "settings.mediaProvidersHint": "连接图片、视频、音频和搜索提供商。",
  "settings.mcpServerTitle": "OpenDesign MCP",
  "settings.mcpServerHint":
    "将 OpenDesign 作为 MCP 服务器暴露给你的编码代理。",
  "settings.externalMcpTitle": "外部 MCP",
  "settings.externalMcpHint":
    "接入外部服务的 MCP 工具（Higgsfield、GitHub 等）。",
  "settings.mediaProviderApiKey": "API key",
  "settings.mediaProviderBaseUrl": "Base URL",
  "settings.mediaProviderConfigured": "已配置",
  "settings.mediaProviderUnset": "未配置",
  "settings.mediaProviderClear": "清除配置",
  "settings.mediaProviderClearConfirm":
    "清除已保存的 {name} 设置？您需要再次输入才能使用 {name}。",
  "settings.mediaProviderPlaceholder": "粘贴 API key",
  "settings.mediaProviderBaseUrlPlaceholder": "覆盖默认 Base URL",
  "settings.mediaProviderReload": "刷新提供商",
  "settings.mediaProviderReloadError": "无法刷新提供商设置。",
  "settings.mediaProviderReloadSuccess": "提供商设置已刷新。",
  "settings.mediaProviderLoadError": "无法加载提供商设置，暂时使用本地保存的设置。",
  "settings.mediaProviderComingSoonHint": "这些提供商已在计划中，但暂时还不能配置。",
  "settings.privacy": "隐私",
  "settings.privacyHint": "与 OpenDesign 团队共享哪些数据",
  "settings.privacyConsentKicker": "帮助我们改进 OpenDesign",
  "settings.privacyConsentLead":
    "分享使用数据后，我们能更了解 OpenDesign 在真实工作流里的表现，并优先改进真正影响体验的地方。",
  "settings.privacyConsentFooter": "你可以随时在 设置 → 隐私 中修改这些选项。",
  "settings.privacyConsentShare": "分享",
  "settings.privacyConsentDecline": "不分享",
  "settings.privacyConsentAccept": "我知道了",
  "settings.privacyConsentBannerFooter":
    "默认开启数据分享。你可以随时在 设置 → 隐私 中关闭。",
  "settings.privacyConsentPolicyLink": "阅读隐私政策",
  "settings.privacyMetrics": "匿名指标",
  "settings.privacyMetricsHint":
    "运行次数、token 用量、错误率、耗时等基础使用指标。",
  "settings.privacyContent": "对话和工具内容",
  "settings.privacyContentHint":
    "在剥离密钥等敏感信息后，我们会使用 prompt、助手回复、工具输入/输出，以及质量回看所需的上下文。",
  "settings.privacyInstallationId": "匿名 ID",
  "settings.privacyOptedOut": "已退出",
  "settings.privacyDataDeletion": "删除我的数据",
  "settings.privacyDataDeletionHint":
    "轮换你的匿名 ID 并停止发送。已有数据按我们的留存策略自然过期。",
  "settings.about": "关于",
  "settings.aboutHint": "版本和运行时详情",
  "settings.appVersion": "版本",
  "settings.appChannel": "渠道",
  "settings.appRuntime": "运行时",
  "settings.appPlatform": "平台",
  "settings.appArchitecture": "架构",
  "settings.runtimePackaged": "已打包应用",
  "settings.runtimeDevelopment": "开发环境",
  "settings.versionUnavailable": "守护进程离线时无法获取版本详情。",
  "settings.allowSilentUpdates": "允许以后自动安装应用内更新",
  "settings.allowSilentUpdatesDesc": "有可应用的应用内更新时，下次启动将自动安装。不会立刻升级当前版本。安装器更新仍会先询问。",
  "settings.installLatest": "安装最新版本",
  "settings.alreadyLatest": "当前为最新版本",
  "settings.mcpTitle": "将 OpenDesign 连接到编程助手",
  "settings.mcpHint": "通过 MCP，让支持的助手访问你的项目和设计上下文。",
  "settings.mcpDaemonError":
    "无法连接到本地守护进程以解析安装路径（{error}）。请确保 OpenDesign 正在运行，然后重新打开此面板。",
  "settings.mcpBuildDaemon": "请先构建守护进程。",
  "settings.mcpNodeMissing": "Node 二进制文件缺失。",
  "settings.mcpBuildHint":
    "apps/daemon/dist/cli.js 缺失。请运行 `pnpm --filter @open-design/daemon build` 并刷新。",
  "settings.mcpMethodCli": "设置命令",
  "settings.mcpInstructionCli": "在终端中运行以下命令：",
  "settings.mcpMethodToml": "TOML 配置",
  "settings.mcpInstructionCodex":
    "将以下配置追加到 {path}。Codex CLI 与 Codex IDE 扩展共享同一配置。",
  "settings.mcpMethodOneClick": "一键安装",
  "settings.mcpInstructionCursor":
    '点击"在 Cursor 中安装"以通过确认对话框安装，或将此 JSON 合并到 {path}。',
  "settings.mcpDeeplinkInstallCursor": "在 Cursor 中安装",
  "settings.mcpMethodJson": "JSON 配置",
  "settings.mcpInstructionKiro":
    "打开 {path} 并合并此 JSON。对于 workspace 级配置，请使用 .kiro/settings/mcp.json。",
  "settings.mcpInstructionCopilot":
    '打开命令面板（{shortcut}），运行 "MCP: Open User Configuration"，然后合并此 JSON。Copilot Chat 必须处于 Agent 模式，工具才会显示。',
  "settings.mcpInstructionAntigravity":
    '在 Antigravity 中：Agent 面板 "..." 菜单 → MCP Servers → Manage MCP Servers → View raw config。合并此 JSON。',
  "settings.mcpInstructionZed":
    '打开 Zed Settings（{shortcut}），然后将此配置合并到顶层对象中。Zed 使用 "context_servers"，而非 "mcpServers"。',
  "settings.mcpInstructionWindsurf":
    "打开 {path}（或在 Cascade 中使用 MCPs 图标 → Configure）并合并：",
  "settings.mcpCopyAria": "复制设置命令",
  "settings.mcpResolvingFailed": "# 解析路径失败，请查看上方错误",
  "settings.mcpLoadingPaths": "# 正在从本地守护进程加载安装路径…",
  "settings.mcpCopied": "已复制",
  "settings.mcpCopy": "复制命令",
  "settings.mcpCursorApproval": "Cursor 会在写入配置前弹出确认对话框。",
  "settings.mcpCodexOneClickInstall": "配置到 Codex",
  "settings.mcpCodexOneClickUninstall": "取消配置",
  "settings.mcpCodexOneClickUnavailable":
    "未在 PATH 中找到 codex CLI——请先安装 Codex 或手动复制片段。",
  "settings.mcpCodexInstallSuccess": "已配置。请重启 Codex 以加载新 server。",
  "settings.mcpCodexUninstallSuccess": "已从 Codex 取消配置。",
  "settings.mcpCodexBusy": "处理中…",
  "settings.mcpCodexInstallError": "操作失败：{error}",
  "settings.mcpRestartNote": "添加 server 后，请重启编程助手。",
  "settings.mcpRestartDetail":
    "大多数编辑器仅在启动时加载 MCP server。在 Cursor / VS Code / Antigravity / Windsurf 中，你可以在命令面板中运行 `Developer: Reload Window`，无需完全重启。Zed 和 Claude Code 需要退出并重新打开。",
  "settings.mcpCapabilitiesTitle": "你的助手可以做什么",
  "settings.mcpCapabilityRead": "读取或搜索项目中的任意文件。",
  "settings.mcpCapabilityPull": "将设计文件、样式、组件和字体作为上下文。",
  "settings.mcpCapabilityDefault":
    "将当前在 OpenDesign 中打开的项目和文件作为上下文。",
  "settings.mcpRunningNote": "请保持 OpenDesign 运行。设置完成后，重启编程助手。",
  "entry.tabDesigns": "我的设计",
  "entry.tabTemplates": "模板",
  "entry.tabDesignSystems": "设计体系",
  "entry.tabConnectors": "连接器",
  "entry.openSettingsTitle": "设置",
  "entry.openSettingsAria": "打开设置",
  "entry.discordLabel": "加入 Discord",
  "entry.discordAria": "加入 Discord 社区，领取使用额度",
  "entry.discordAriaWithOnline": "加入 OpenDesign Discord - {online}",
  "entry.discordOnlineLabel": "{count} 在线",
  "entry.xAria": "关注 @OpenDesignHQ，看新功能",
  "entry.mailAria": "有问题？给我们发邮件",
  "entry.accountSettings": "设置",
  "chat.collapsePane": "收起对话栏",
  "collabPresence.ariaOne": "1 位协作者在线",
  "collabPresence.aria": "{count} 位协作者在线",
  "collabPresence.ariaWithSelfOne": "1 位协作者在线，包含你",
  "collabPresence.ariaWithSelf": "{count} 位协作者在线，包含你",
  "collabPresence.moreOnline": "另外 {count} 位在线",
  "collabPresence.dialogTitle": "在线协作成员",
  "collabPresence.onlineCount": "{count} 在线",
  "collabPresence.selfBadge": "你",
  "collabPresence.roleOwner": "Owner",
  "collabPresence.roleAdmin": "Admin",
  "collabPresence.roleMember": "Member",
  "collabPresence.viewingFileSelf": "你正在查看 {file}",
  "collabPresence.viewingFileOther": "正在查看 {file}",
  "collabPresence.viewingProjectSelf": "你正在查看此项目",
  "collabPresence.viewingProjectOther": "正在查看此项目",
  "entry.followXLabel": "在 X 上关注 @OpenDesignHQ",
  "entry.followThreadsLabel": "Follow OpenDesign on Threads",
  "entry.followInstagramLabel": "在 Instagram 上关注 @opendesign.ai",
  "entry.followLinkedinLabel": "在 LinkedIn 上关注 OpenDesign",
  "entry.followXiaohongshuLabel": "在小红书上关注 OpenDesign",
  "entry.youtubeLabel": "OpenDesign on YouTube",
  "entry.resizeAria": "调整侧边栏宽度",
  "entry.loadingWorkspace": "正在加载工作区…",
  "entry.useEverywhereTitle": "随处使用",
  "entry.useEverywhereAria": "打开「随处使用」指南（CLI、MCP、HTTP、Skills）",
  "entry.workspaceTeamsLabel": "团队版",
  "workspaceSwitcher.invite": "邀请同事",
  "workspaceSwitcher.createTeam": "新建团队",
  "workspaceSwitcher.draftsTooltip": "全部项目",
  "workspaceSwitcher.allProjectsTooltip": "团队项目",
  "entry.primaryNavAria": "主导航",
  "entry.billingTierTeam": "团队版",
  "entry.billingTierFree": "免费版",
  "entry.billingTierPro": "专业版",
  "entry.billingTierPlus": "标准版",
  "entry.billingTierMax": "旗舰版",
  "entry.billingTierGo": "轻享版",
  "entry.billingFamilyCreator": "创作会员",
  "entry.creditsAria": "{tier} · 可用额度",
  "entry.creditsAriaWithBalance": "{tier} · 可用额度 {balance}",
  "entry.creditsGrantTip": "团队版按订阅发放额度，可在计费中查看用量。",
  "entry.creditsUpgrade": "升级",
  "entry.creditsManage": "管理",
  "entry.creditsOpening": "正在打开...",
  "entry.creditsRemaining": "可用额度",
  "entry.credits": "额度",
  "entry.creditsUsage": "查看使用情况",
  "entry.creditsMemberNoticeTitle": "额度不足？",
  "entry.creditsMemberNoticeBody": "你当前是 Member，不能自行续额度。需要更多额度时，可以提醒团队 Admin 提额。",
  "entry.creditsMemberNoticeAction": "提醒 Admin 提额",
  "entry.accountToggleTheme": "切换主题",
  "entry.accountSwitchLanguage": "切换语言",
  "entry.accountLanguageMeta": "中文 / English",
  "entry.accountGithubHelp": "获取帮助",
  "entry.accountFeatureRequest": "提交建议",
  "entry.accountBilling": "账单",
  "entry.accountAddAccount": "添加账号",
  "entry.accountSignOut": "退出登录",
  "signOut.confirmTitle": "退出登录",
  "signOut.confirmMessage": "确定要退出登录吗？",
  "signOut.confirmAction": "退出登录",
  "entry.navRecents": "首页",
  "entry.navDashboard": "数据大盘",
  "entry.blankDraftsTitle": "开始一个私人草稿",
  "entry.blankDraftsDescription": "先在这里创建项目。移入团队空间之前，只有你自己可见。",
  "entry.projectsLoadFailed": "无法加载项目，请重试。",
  "entry.blankAllProjectsTitle": "还没有团队项目",
  "entry.blankAllProjectsDescription": "共享到团队空间的项目会出现在这里，工作空间成员都可以访问。",
  "entry.blankCreate": "新建方案",
  "entry.workspaceTeamsTitle": "团队版工作区 — 告诉我们你的团队需求",
  "entry.workspaceTeamsAria": "打开团队版工作区页面",
  "entry.navExpand": "展开侧栏",
  "entry.navCollapse": "收起侧栏",
  "entry.navNewProject": "新建项目",
  "entry.navHome": "主页",
  "entry.navProjects": "项目",
  "entry.navTasks": "自动化",
  "entry.navPlugins": "插件",
  "entry.navDesignSystems": "设计体系",
  "entry.navBrands": "设计系统",
  "entry.navIntegrations": "集成",
  "entry.navMembers": "成员",
  "entry.navWorkspaceSettings": "Workspace 设置",
  "entry.navDrafts": "全部项目",
  "entry.navAllProjects": "团队项目",
  "entry.draftsDescription": "自己创建的项目，仅自己可见",
  "entry.allProjectsDescription": "团队所有人的项目",
  "entry.navBoard": "看板",
  "entry.navTeamSection": "团队",
  "entry.teamSlotNote": "该视图由团队服务提供，接入中。",
  "entry.cloudCalloutTitle": "OpenDesign Cloud 版",
  'entry.cloudRecovering': '账号连接中断，正在自动恢复…',
  'entry.authExpiredBody': 'Open Design 尚未登录\n请先登录，以便查看项目和继续对话。',
  'home.createFailed': '启动任务失败，请重试。',
  'home.daemonRecovering': '本地连接已断开\n暂时无法连接这台电脑上的 Open Design 服务，请重启客户端。',
  'home.createTimedOut': '项目准备超时，任务尚未开始。请重新发送。',
  'home.amrGateUnavailable': '暂时无法确认 OpenDesign Cloud 额度，请重新发送。',
  'home.bundledScenarioMissing': '内置场景“{scenarioId}”未安装。请重新安装 OpenDesign，以恢复默认插件。',
  "entry.cloudCalloutBody": "登录即可享受云端协作",
  "entry.cloudCreditsTitle": "注册即领免费额度",
  "entry.cloudCreditsBody": "新注册 OpenDesign 账号，即可领取免费额度，使用最先进的模型进行设计创作。",
  "entry.cloudCreditsCta": "注册 / 登录",
  "entry.localAccountName": "本地模式",
  "entry.cloudCalloutDismissAria": "关闭 OpenDesign Cloud 版说明",
  "entry.workspaceLockedNote": "工作区已锁定，恢复账单后可继续编辑共享项目。",
  "entry.workspaceLockedRecover": "恢复访问",
  "messageCenter.openAria": "打开消息中心",
  "messageCenter.unreadCount": "{count} 条未读",
  "messageCenter.title": "消息中心",
  "messageCenter.subtitle": "OpenDesign 更新、平台公告和权益提醒",
  "messageCenter.filterAll": "全部",
  "messageCenter.filterUnread": "未读",
  "messageCenter.filterRead": "已读",
  "messageCenter.markAllRead": "全部标为已读",
  "messageCenter.emptyAllTitle": "暂时没有消息",
  "messageCenter.emptyUnreadTitle": "都看完了",
  "messageCenter.emptyReadTitle": "暂时没有已读消息",
  "messageCenter.archive": "归档",
  "messageCenter.unarchive": "移回收件箱",
  "messageCenter.archivedTitle": "已归档",
  "messageCenter.emptyArchivedTitle": "没有已归档的消息",
  "messageCenter.emptyBody": "新消息会出现在这里。",
  "messageCenter.close": "关闭消息中心",
  "messageCenter.desktopSettings": "桌面提醒设置",
  "messageCenter.desktopSettingsHint": "任务完成声音和系统通知仍在设置中管理。",
  "goPlanSunset.closeAria": "关闭弹窗",
  "goPlanSunset.title": "关于停售 Go 订阅的公告",
  "goPlanSunset.subtitle": "尊敬的 OpenDesign 用户：OpenDesign Go 上线后获得了很多用户的关注和意见反馈，我们意识到目前 OpenDesign 在额度规则/产品体验等方面仍有不足，对此我们深表歉意。",
  "goPlanSunset.decisionsAria": "公告决定",
  "goPlanSunset.decisionsIntro": "为了确保给大家提供最佳设计体验，我们决定：",
  "goPlanSunset.decisionStopSales": "即日起停售 Go 新订阅",
  "goPlanSunset.decisionRefund": "8 月 31 日前原路全额退款；退款后权益停止（到账以渠道为准）",
  "goPlanSunset.decisionUnaffected": "除 Go 之外的其他订阅计划用户不受影响",
  "goPlanSunset.closing": "感谢您的理解和支持，也感谢所有提出批评的用户。我们将持续聚焦更智能的设计交付，让每个人和每个团队都能更好地交付满意的设计作品！",
  "goPlanSunset.dismissError": "确认失败，请重试。",
  "goPlanSunset.viewSubscriptions": "查看其他订阅",
  "goPlanSunset.confirming": "正在确认…",
  "goPlanSunset.acknowledge": "我知道了",
  "workspaceTabs.project": "项目",
  "workspaceTabs.pluginDetails": "插件详情",
  "workspaceTabs.marketplace": "插件市场",
  "homeHero.title": "让我们创建{word}",
  "homeHero.titleWords": "原型,幻灯片,文档",
  "homeHero.subtitle": "好的作品，从这里开始",
  "homeHero.startWithTemplate": "从模板开始…",
  "homeHero.startBlankProject": "创建一个空白项目",
  "homeHero.templatePicker.label": "创作类型",
  "homeHero.templatePicker.searchPlaceholder": "搜索模板",
  "homeHero.templatePicker.projectTypes": "项目类型",
  "homeHero.subtitlePrefix": "Claude Design 的源码可用替代方案。",
  "homeHero.placeholder": "描述你想生成的内容…",
  "homeHero.placeholderActive": "编辑示例请求，或写下你自己的需求…",
  "homeHero.carousel.hint": "上传文件、关联设计系统，或描述你想创作的内容",
  "homeHero.carousel.onePageBrief": "撰写一页项目简介",
  "homeHero.carousel.notesToDeck": "把我的笔记变成演示文稿",
  "homeHero.carousel.signupFlow": "设计一个注册流程",
  "homeHero.carousel.improveBrief": "改进现有的项目简介",
  "homeHero.carousel.loadingAnimation": "制作一个加载动画",
  "homeHero.carousel.teamUpdateSlides": "为团队汇报设计幻灯片",
  "homeHero.carousel.ordersDashboard": "做一个订单跟踪仪表盘原型",
  "homeHero.carousel.productDetail": "排版一个商品详情页",
  "homeHero.carousel.caseStudy": "梳理一个案例研究大纲",
  "homeHero.carousel.landingIntro": "为落地页设计一段简短的开场",
  "homeHero.carousel.pitchDeck": "为新产品制作一个路演演示",
  "homeHero.carousel.appIdea": "描述一个应用创意",
  "homeHero.carousel.landingLayout": "勾勒一个落地页布局",
  "homeHero.skills": "技能",
  "homeHero.addMenu": "添加",
  "homeHero.addPlugin": "添加插件",
  "homeHero.addConnectors": "添加连接器",
  "homeHero.addMcp": "添加 MCP 服务",
  "homeHero.noPlugins": "暂无已安装的插件",
  "homeHero.noMcp": "暂无 MCP 服务",
  "homeHero.noConnectors": "暂无已连接的连接器",
  "homeHero.applying": "正在应用…",
  "homeHero.pluginTitle": "插件：{title}",
  "homeHero.pluginPrefix": "插件：{title}",
  "homeHero.skillPrefix": "技能：{title}",
  "homeHero.removePlugin": "移除插件",
  "homeHero.removePluginAria": "移除插件 {title}",
  "homeHero.clearActivePlugin": "清除当前插件",
  "homeHero.clearActiveSkill": "清除当前技能",
  "homeHero.contextItemsResolved": "已解析 {n} 个上下文项",
  "homeHero.attachmentsScrollPrev": "向左滚动附件",
  "homeHero.attachmentsScrollNext": "向右滚动附件",
  "homeHero.removeFile": "移除文件",
  "homeHero.contextSearchResults": "上下文搜索结果",
  "homeHero.contextSurfaces": "上下文来源",
  "homeHero.loadingContext": "正在加载上下文…",
  "homeHero.noResults": "没有找到“{query}”的结果。",
  "homeHero.searchPrompt": "搜索文件、插件、技能、MCP 服务器和连接器。",
  "homeHero.parameters": "{n} 个参数",
  "homeHero.details": "详情",
  "homeHero.toRun": "运行",
  "homeHero.forNewLine": "换行",
  "homeHero.run": "运行",
  "homeHero.typeSomethingToRun": "输入内容后运行",
  "homeHero.promptExamples": "示例提示词",
  "homeHero.footer.designSystem": "风格",
  "homeHero.footer.autoDesignSystem": "自动",
  "homeHero.footer.autoDesignSystemSummary":
    "根据当前 Prompt 自动匹配合适的设计体系和视觉风格。",
  "homeHero.footer.ratio": "比例",
  "homeHero.footer.duration": "时长",
  "homeHero.footer.resolution": "分辨率",
  "homeHero.footer.speakerNotes": "备注",
  "homeHero.footer.noSpeakerNotes": "无备注",
  "homeHero.footer.availableCount": "{n} 个可用",
  "homeHero.footer.noMatches": "无匹配结果",
  "homeHero.moreShortcuts": "更多",
  "homeHero.railAria": "选择项目类别或启动入口",
  "homeHero.subTypeAria": "选择子类型",
  "homeHero.subTypeMore": "更多",
  "homeHero.confirmReplaceTitle": "替换当前 Prompt？",
  "homeHero.confirmReplaceBody": "使用 {title} 会替换输入框中的现有文本。",
  "homeHero.confirmReplace": "替换",
  "homeHero.chip.prototype": "原型",
  "homeHero.chip.webClone": "网站复刻",
  "homeHero.chip.liveArtifact": "实时产物",
  "homeHero.chip.deck": "幻灯片",
  "homeHero.chip.image": "图片",
  "homeHero.chip.video": "视频",
  "homeHero.chip.motionDesign": "动效设计",
  "homeHero.chip.motionDesignDesc": "动态图形、艺术动画与产品短片",
  "homeHero.chip.motionDesignHint": "描述你想表达的内容、风格和时长，制作一段有节奏的动效。",
  "homeHero.chip.hyperframes": "HyperFrames",
  "homeHero.chip.webgl": "WebGL",
  "homeHero.chip.webglDesc": "着色器、3D 与生成式 GPU 视觉",
  "homeHero.chip.worker": "Worker 可视化",
  "homeHero.chip.workerDesc": "离主线程模拟、粒子与数据可视化",
  "homeHero.chip.audio": "音频",
  "homeHero.chip.createBrandKit": "创建设计系统",
  "homeHero.chip.createPlugin": "创建插件",
  "homeHero.chip.figma": "来自 Figma",
  "homeHero.chip.folder": "来自文件夹",
  "homeHero.chip.template": "来自模板",
  "homeHero.chip.liveArtifactHint": "构建可实时预览的交互式 HTML/CSS/JS 制品。",
  "homeHero.chip.hyperframesHint":
    "创作基于 HTML 的动态内容：字幕、音频响应视觉和场景转场。",
  "homeHero.chip.createBrandKitHint":
    "从网站提取一个设计系统，然后在任意对话中应用它。",
  "homeHero.chip.createPluginHint":
    "创作可复用的 OpenDesign 插件，并添加到我的插件。",
  "homeHero.chip.figmaHint": "将 Figma 画框迁移到当前设计体系。",
  "homeHero.chip.folderHint": "导入本地文件夹并继续编辑。",
  "homeHero.chip.templateHint": "从内置模板开始。",
  "homeHero.chip.wireframe": "线框图",
  "homeHero.chip.mobile": "移动应用",
  "homeHero.chip.document": "文档",
  "homeHero.chip.prototypeDesc": "可交互的应用原型",
  "homeHero.chip.webCloneDesc": "按源码证据复刻网站",
  "homeHero.chip.wireframeDesc": "低保真屏幕与流程",
  "homeHero.chip.mobileDesc": "iOS 与安卓界面",
  "homeHero.chip.deckDesc": "演示文稿与路演稿",
  "homeHero.chip.documentDesc": "简历、报告与 PDF",
  "homeHero.chip.imageDesc": "海报、图形与插画",
  "homeHero.chip.videoDesc": "短片、Reels 与宣传片",
  "homeHero.chip.audioDesc": "配音、音乐与音效",
  "homeHero.chip.hyperframesDesc": "动态图形与循环动画",
  "homeHero.chip.liveArtifactDesc": "数据驱动的实时看板",
  "homeHero.chip.createBrandKitDesc": "从网站提取品牌设计系统",
  "homeHero.chip.prototypeNext":
    "打开对话,构建可逐轮打磨的高保真可点击网页原型。",
  "homeHero.chip.webCloneNext": "打开使用 web-clone skill 的对话，先贴目标 URL，再侦察、复刻并审计产物。",
  "homeHero.chip.wireframeNext":
    "打开对话,先用低保真屏幕与流程验证结构,再做视觉设计。",
  "homeHero.chip.mobileNext": "打开对话,排布 iOS 与安卓的移动端界面。",
  "homeHero.chip.deckNext": "打开对话,生成可演示、可导出的幻灯片。",
  "homeHero.chip.documentNext": "打开对话,起草精美的文档——简历、报告或 PDF。",
  "homeHero.chip.imageNext": "打开对话,生成符合品牌的图片并持续迭代。",
  "homeHero.chip.videoNext": "打开对话,生成可继续打磨的短视频。",
  "homeHero.chip.audioNext": "打开对话,创建配音、音乐或音效。",
  "homeHero.chip.webClonePromptSeed": "想要复刻的网站链接：",
  "homeWorkingDir.trigger": "选择工作目录",
  "homeWorkingDir.triggerShort": "工作目录",
  "homeWorkingDir.pick": "选择目录",
  "homeWorkingDir.replace": "修改工作目录",
  "homeWorkingDir.recent": "最近使用的目录",
  "homeWorkingDir.clear": "移除工作目录",
  "homeWorkingDir.hint": "让 Agent 可读取该本地目录（不会导入到 Design Files）",
  "homeWorkingDir.missing": "该工作目录已不存在，请重新选择",
  "homeWorkingDir.applyFailed": "无法设置工作目录，该文件夹可能已不存在",
  "workingDirPicker.title": "目录",
  "workingDirPicker.homeTitle": "默认存在本地存储，点击可选择文件夹",
  "workingDirPicker.processing": "处理中…",
  "workingDirPicker.select": "本地存储",
  "workingDirPicker.clearAria": "清除工作目录",
  "workingDirPicker.replaceFailed": "替换工作目录失败",
  "workingDirPicker.unavailable": "未选择目录 — 启动桌面版以使用原生选择器",
  "workingDirPicker.openUnavailable": "请在桌面版中打开此项目以显示文件夹。",
  "workingDirPicker.openFailed": "无法显示此文件夹",
  "workingDirPicker.showInFileManager": "在文件管理器中显示",
  "workingDirPicker.replace": "选择文件夹…",
  "workingDirPicker.recent": "最近使用的目录",
  "workingDirPicker.defaultLabel": "本地存储",
  "handoff.toTarget": "交付给 {target}",
  "handoff.openInTarget": "在 {target} 中打开",
  "handoff.openAction": "打开",
  "handoff.menuTitle": "在哪个编辑器中打开？",
  "handoff.action": "交付",
  "handoff.fallbackTitle": "未找到编辑器 - 使用 {target} 打开",
  "handoff.chooseTargetAria": "选择交付目标",
  "handoff.optionsAria": "交付选项",
  "handoff.editorSection": "通过编辑器打开",
  "handoff.cliSection": "复制给 CLI",
  "handoff.clickOpen": "点击打开",
  "handoff.framework": "代码框架",
  "handoff.framework.react": "React",
  "handoff.framework.vue": "Vue.js",
  "handoff.framework.svelte": "Svelte",
  "handoff.framework.solid": "SolidJS",
  "handoff.framework.next": "Next.js",
  "handoff.framework.vanilla": "JS",
  "handoff.frameworkPrompt.react": "React",
  "handoff.frameworkPrompt.vue": "Vue.js",
  "handoff.frameworkPrompt.svelte": "Svelte",
  "handoff.frameworkPrompt.solid": "SolidJS",
  "handoff.frameworkPrompt.next": "Next.js / React",
  "handoff.frameworkPrompt.vanilla": "原生 JavaScript、HTML 和 CSS",
  "handoff.amrWebsite": "打开 OpenDesign Cloud 官网",
  "handoff.copyPrompt": "复制提示词",
  "handoff.copyPromptForTarget": "复制给 {target} 的提示词",
  "handoff.copied": "已复制",
  "handoff.projectPathUnavailable": "还没有拿到项目本地路径，请稍后再试。",
  "handoff.copyFailed": "浏览器拒绝写入剪贴板，请稍后再试。",
  "handoff.promptIntro": "请基于这个 OpenDesign 项目的本地文件夹继续实现：",
  "handoff.promptTarget": "目标",
  "handoff.promptCli": "CLI",
  "handoff.promptStepsLead": "你现在是在 {cli} 中接手，请：",
  "handoff.promptReadFiles":
    "先进入或读取这个目录，优先阅读 DESIGN.md、README、现有 HTML/CSS/JS、素材和 package.json（如果存在）。",
  "handoff.promptKeepDesign":
    "保持现有视觉、布局、交互和素材，不要只描述方案。",
  "handoff.promptProduceCode":
    "生成或修改真实可运行的 {framework} 代码；如果项目已有更明确的工程栈，先说明冲突并优先保持可运行。",
  "handoff.promptVerify": "完成后告诉我运行、预览和验证命令。",
  "handoff.promptCommandHint": "如果要先切到项目目录，可以用：",
  "handoff.promptProject": "项目",
  "handoff.promptProjectId": "项目 ID",
  "handoff.notInstalled": "未安装",
  "handoff.notDetectedTitle": "{target} - 未在 $PATH 中检测到",
  "designSystemPicker.select": "选择设计系统",
  "designSystemPicker.loading": "正在加载设计系统…",
  "designSystemPicker.searchPlaceholder": "搜索设计系统（标题 / 分类 / 摘要）",
  "designSystemPicker.searchCompactPlaceholder": "搜索设计系统",
  "designSystemPicker.noneTitle": "不指定设计系统",
  "designSystemPicker.noneSummary":
    "不指定设计系统，模型会根据你的 Prompt 自由发挥视觉风格。",
  "designSystemPicker.empty": "没有匹配的设计系统",
  "designSystemPicker.openPreview": "打开预览",
  "designSystemPicker.loadingPreview": "正在加载预览…",
  "designSystemPicker.noPreview": "无预览页面 — 在「设计系统」中查看完整预览",
  "designSystemPicker.previewHint": "将鼠标悬停在左侧条目上查看预览",
  "designSystemPicker.fullscreenAria": "{title} 全屏预览",
  "designSystemPicker.closeFullscreen": "关闭全屏预览",
  "designSystemPicker.closeEsc": "关闭 (Esc)",
  "designSystemPicker.previewFrameTitle": "{title} 预览",
  "designSystemPicker.fullscreenFrameTitle": "{title} 全屏预览",
  "recentProjects.title": "最近项目",
  "recentProjects.viewAll": "查看全部",
  "recentProjects.empty": "还没有项目 — 输入 Prompt 即可开始。",
  "recentProjects.ownerAll": "所有",
  "recentProjects.ownerMine": "仅自己",
  "recentProjects.ownerOthers": "其他人",
  "recentProjects.kindAll": "任何类型",
  "recentProjects.kindPrototype": "原型",
  "recentProjects.kindSlides": "幻灯片",
  "recentProjects.kindDocument": "文档",
  "recentProjects.kindImage": "图片",
  "recentProjects.kindMedia": "媒体",
  "recentProjects.kindOther": "其他",
  "recentProjects.inviteTeammates": "邀请同事",
  "recentProjects.multiSelect": "多选",
  "recentProjects.sortAria": "项目排序",
  "recentProjects.sortNewest": "最近更新",
  "recentProjects.sortOldest": "最早更新",
  "recentProjects.sortName": "名称",
  "recentProjects.collectionRecent": "最近浏览过",
  "recentProjects.collectionPersonalProjects": "个人项目",
  "recentProjects.collectionTeamProjects": "团队项目",
  "recentProjects.viewList": "列表视图",
  "recentProjects.sharedBadge": "共享",
  "recentProjects.sharedProjectFallbackName": "共享项目",
  "recentProjects.creatorLine": "{name}创建",
  "recentProjects.selfCreator": "我",
  "recentProjects.teamMemberCreator": "团队成员",
  "recentProjects.ownOnlyMutation": "只能修改或删除自己创建的项目。",
  "recentProjects.shareInProgress": "分享中…",
  "recentProjects.duplicateInProgress": "复制中…",
  "recentProjects.sharedInTeam": "已在团队空间",
  "recentProjects.moveToTeam": "转入团队空间",
  "recentProjects.moveToTeamDescPre": "转入团队空间后，",
  "recentProjects.moveToTeamDescStrong": "团队全体成员都可以查看和评论",
  "recentProjects.moveToTeamDescPost": "，只有创建者可以编辑。该操作可在「团队项目」中找到。",
  "recentProjects.moveToPersonalDescPre": "移出团队空间后，将回到私人项目，",
  "recentProjects.moveToPersonalDescStrong": "只有你可以查看和编辑",
  "recentProjects.moveToPersonalDescPost": "。",
  "recentProjects.moveDontRemind": "不再提示",
  "recentProjects.confirmMoveToTeam": "确认转入",
  "recentProjects.confirmMoveToPersonal": "确认移出",
  "recentProjects.unshareInProgress": "移出中…",
  "recentProjects.moveOutOfTeam": "移出团队空间",
  "recentProjects.unshareFailed": "移出团队空间失败，请稍后重试。",
  "recentProjects.shareFailed": "转入团队空间失败，请稍后重试。",
  "recentProjects.shareOwnerConflict": "转入团队空间失败：该项目已由其他成员共享至团队空间。",
  "recentProjects.clearFilters": "清除筛选",
  "pluginsHome.title": "社区",
  "pluginsHome.subtitle":
    "当前运行环境内置的 OpenDesign 工作流。选择一个加载 starter prompt，或浏览插件市场查看更多。",
  "pluginsHome.browseRegistry": "浏览插件市场",
  "pluginsHome.count": "{filtered} / {total}",
  "pluginsHome.loadingCatalog": "正在加载目录…",
  "pluginsHome.emptyCatalog":
    "目录为空。OpenDesign 会随附内置插件，如果这里一直为空，请尝试重启 daemon。",
  "pluginsHome.emptyFiltered": "没有插件匹配当前筛选条件。",
  "pluginsHome.clearFilters": "清除筛选",
  "pluginsHome.modeAria": "插件模式",
  "pluginsHome.featured": "已保存",
  "pluginsHome.totalInCatalog": "目录中共 {n} 个",
  "pluginsHome.categoryFilterAria": "类别筛选",
  "pluginsHome.subcategoryFilterAria": "{label} 子类别筛选",
  "pluginsHome.allCategory": "全部 {label}",
  "pluginsHome.searchPlaceholder": "搜索插件…",
  "pluginsHome.searchAria": "搜索插件",
  "pluginsHome.clearSearch": "清除搜索",
  "pluginsHome.sortAria": "排序方式",
  "pluginsHome.sortHot": "热门",
  "pluginsHome.sortNewest": "最新",
  "pluginsHome.facet.import": "导入",
  "pluginsHome.facet.create": "创建",
  "pluginsHome.facet.export": "导出",
  "pluginsHome.facet.share": "分享",
  "pluginsHome.facet.deploy": "部署",
  "pluginsHome.facet.refine": "优化",
  "pluginsHome.facet.extend": "扩展",
  "pluginsHome.facet.figma": "Figma",
  "pluginsHome.facet.github": "GitHub",
  "pluginsHome.facet.codeFolder": "代码 / 文件夹",
  "pluginsHome.facet.url": "URL",
  "pluginsHome.facet.screenshot": "截图",
  "pluginsHome.facet.pdf": "PDF",
  "pluginsHome.facet.pptx": "PPTX",
  "pluginsHome.facet.framer": "Framer",
  "pluginsHome.facet.webflow": "Webflow",
  "pluginsHome.facet.slides": "幻灯片",
  "pluginsHome.facet.publicLink": "公开链接",
  "pluginsHome.facet.githubPr": "GitHub PR",
  "pluginsHome.facet.githubGist": "GitHub Gist",
  "pluginsHome.subfacet.business-dashboards": "数据看板",
  "pluginsHome.subfacet.app-prototypes": "应用",
  "pluginsHome.subfacet.landing-marketing": "落地页 / 营销",
  "pluginsHome.subfacet.developer-tools": "开发者工具",
  "pluginsHome.subfacet.docs-reports": "文档 / 报告",
  "pluginsHome.subfacet.brand-design": "品牌 / 设计",
  "pluginsHome.subfacet.pitch-business": "路演 / 商务",
  "pluginsHome.subfacet.course-training": "课程 / 培训",
  "pluginsHome.subfacet.reports-briefings": "报告 / 简报",
  "pluginsHome.subfacet.product-sales": "产品 / 销售",
  "pluginsHome.subfacet.engineering-talks": "技术分享",
  "pluginsHome.subfacet.creative-decks": "创意幻灯片",
  "pluginsHome.subfacet.ui-product-mockups": "UI / 产品样机",
  "pluginsHome.subfacet.brand-visuals": "品牌 / Logo",
  "pluginsHome.subfacet.storyboards-motion-refs": "分镜",
  "pluginsHome.subfacet.social-content": "社交 / 内容",
  "pluginsHome.subfacet.avatar-portrait": "头像 / 人像",
  "pluginsHome.subfacet.illustration-style": "插画 / 风格",
  "pluginsHome.subfacet.motion-effects": "动效 / 特效",
  "pluginsHome.subfacet.social-short-form": "社交 / 短视频",
  "pluginsHome.subfacet.marketing-product": "营销 / 产品",
  "pluginsHome.subfacet.data-explainers": "数据 / 解说",
  "pluginsHome.subfacet.cinematic-story": "电影感 / 叙事",
  "pluginsHome.commercialCategory.student-coursework": "学生作业",
  "pluginsHome.commercialCategory.corporate-strategy": "企业战略",
  "pluginsHome.commercialCategory.professional-training": "职业培训",
  "pluginsHome.commercialCategory.b2b-sales": "B2B 销售",
  "pluginsHome.commercialCategory.academic-research": "学术研究",
  "pluginsHome.commercialCategory.marketing-gtm": "市场增长",
  "pluginsHome.commercialCategory.data-finance": "数据与财务",
  "pluginsHome.commercialCategory.fundraising-pitch": "融资路演",
  "pluginsHome.commercialCategory.government-policy": "政府与政策",
  "pluginsHome.commercialCategory.product-management": "产品管理",
  "pluginsHome.commercialCategory.consulting": "咨询顾问",
  "pluginsHome.commercialCategory.career": "职业发展",
  "pluginsHome.commercialCategory.ai-literacy": "AI 素养",
  "pluginsHome.commercialCategory.life": "生活故事",
  "pluginsHome.commercialCategory.design-craft": "设计打磨",
  "pluginsView.lede":
    "浏览已安装工作流，发现插件市场条目，管理来源，并为团队分发准备插件。",
  "pluginsView.importPlugin": "导入插件",
  "pluginsView.agentContext": "智能体上下文",
  "pluginsView.summaryAria": "插件概览",
  "pluginsView.areasAria": "插件区域",
  "pluginsView.loading": "正在加载插件…",
  "pluginsView.tab.installed": "已安装",
  "pluginsView.tab.available": "可用",
  "pluginsView.tab.sources": "来源",
  "pluginsView.tab.team": "团队",
  "pluginsView.tabHint.installed": "你的插件",
  "pluginsView.tabHint.available": "来自来源",
  "pluginsView.tabHint.sources": "目录",
  "pluginsView.tabHint.team": "企业",
  "pluginsView.installedTitle": "已安装插件",
  "pluginsView.installedSubtitle": "你导入或从插件市场来源安装的插件。",
  "pluginsView.installedEmpty":
    "还没有已安装的用户插件。可使用创建 / 导入，或安装一个可用条目。",
  "pluginsView.availableTitle": "来源中的可用插件",
  "pluginsView.availableSubtitle": "从已配置插件市场发现的目录条目。",
  "pluginsView.availableFiltersAria": "可用插件筛选",
  "pluginsView.searchAvailableAria": "搜索可用插件",
  "pluginsView.searchAvailablePlaceholder": "搜索可用插件",
  "pluginsView.clearAvailableSearch": "清除可用插件搜索",
  "pluginsView.source": "来源",
  "pluginsView.availableEmptyInstalled":
    "暂无可用条目。已安装的目录条目会从“可用”中移除；卸载后会再次出现。",
  "pluginsView.availableEmptyFiltered": "没有可用条目匹配当前筛选条件。",
  "pluginsView.availableEmptyNoSources":
    "暂无可用条目。请在“来源”标签页添加来源。",
  "pluginsView.installing": "正在安装…",
  "pluginsView.installWaiting": "等待中…",
  "pluginsView.installQueuedHint": "正在安装另一个插件。安装会逐个进行，等它完成后即可安装这个。",
  "pluginsView.install": "安装",
  "pluginsView.sourcesTitle": "Registry 来源",
  "pluginsView.sourcesSubtitle": "为“可用插件”提供条目的插件市场目录。",
  "pluginsView.sourceUrl": "来源 URL",
  "pluginsView.defaultTrust": "默认信任级别",
  "pluginsView.trust.restricted": "受限",
  "pluginsView.trust.trusted": "可信",
  "pluginsView.trust.official": "官方",
  "pluginsView.adding": "正在添加…",
  "pluginsView.addSource": "添加来源",
  "pluginsView.sourcesEmpty": "还没有配置 registry 来源。",
  "pluginsView.pluginsCount": "{n} 个插件",
  "pluginsView.catalogVersion": "目录 v{version}",
  "pluginsView.trustFor": "{name} 的信任级别",
  "pluginsView.refreshing": "正在刷新…",
  "pluginsView.removing": "正在移除…",
  "pluginsView.marketplaceTitle": "扩展",
  "pluginsView.marketplaceBody": "安装专家套件、技能和连接器，为 OpenDesign 增加新的工作能力。",
  "pluginsView.marketplaceModeAria": "市场模式",
  "pluginsView.marketplaceSourceFiltersAria": "市场来源筛选",
  "pluginsView.scope.official": "OpenDesign 官方",
  "pluginsView.scope.team": "团队",
  "pluginsView.scope.personal": "个人的",
  "pluginsView.kind.plugins": "专家套件",
  "pluginsView.kind.skills": "技能",
  "pluginsView.searchPlugins": "搜索专家套件",
  "pluginsView.searchSkills": "搜索技能",
  "pluginsView.modeNote.plugins": "专家套件是面向角色行业的工具套件，在对话框中输入 @ 或斜杠即可使用。",
  "pluginsView.modeNote.skills": "技能是可复用的任务流程和审查规则，可独立使用，也可以被专家套件组合调用。",
  "pluginsView.create": "新增",
  "pluginsView.createTitle": "新增 {kind}",
  "pluginsView.createWithAgent": "描述需求，让 Agent 帮你做",
  "pluginsView.createWithAgentBody": "不用导入现成的扩展，直接在首页对话框里描述你想要什么。",
  "pluginsView.createWithAgentAction": "去描述需求",
  "pluginsView.createPluginBody": "从 GitHub 或本地文件夹导入一个插件，上传后即可在团队内使用。",
  "pluginsView.createSkillBody": "创建一个可复用的任务流程或审查规则，之后可以被 Plugin 复用。",
  "pluginsView.createClose": "关闭新增面板",
  "pluginsView.createTypeAria": "创建类型",
  "pluginsView.importFromUrl": "从链接导入",
  "pluginsView.importUrlBody": "粘贴 {kind} 的公开链接，OpenDesign 会拉取清单、校验能力并上传到团队空间。",
  "pluginsView.uploadFolder": "上传本地文件夹",
  "pluginsView.uploadFolderBody": "选择包含 {manifest} 的本地目录，校验通过后上传为团队 {kind}。",
  "pluginsView.importing": "导入中…",
  "pluginsView.importAndUpload": "导入并上传",
  "pluginsView.uploading": "上传中…",
  "pluginsView.uploadKind": "上传 {kind}",
  "pluginsView.filesSelected": "已选择 {count} 个文件",
  "pluginsView.chooseFolder": "选择文件夹",
  "pluginsView.emptyNoMatchTitle": "没有匹配的结果",
  "pluginsView.emptyNoMatchHint": "换个关键词试试。",
  "pluginsView.emptyTeamTitle": "还没有共享到团队的内容",
  "pluginsView.emptyTeamHint": "在「个人的」里把专家套件或技能共享给团队后，会出现在这里。",
  "pluginsView.emptyPersonalPluginsTitle": "还没有个人专家套件",
  "pluginsView.emptyPersonalSkillsTitle": "还没有个人技能",
  "pluginsView.emptyPersonalHint": "从「OpenDesign 官方」安装，或点击右上角「新增」来创建。",
  "pluginsView.emptyOfficialPluginsTitle": "暂无可用的官方专家套件",
  "pluginsView.emptyOfficialSkillsTitle": "暂无可用的官方技能",
  "pluginsView.emptyOfficialHint": "稍后再来看看，或在插件来源中添加一个市场。",
  "pluginsView.teamSharedBadge": "团队共享",
  "pluginsView.tryIt": "试试看",
  "pluginsView.categoriesAria": "分类",
  "pluginsView.statSkills": "{count} 个技能",
  "pluginsView.statConnectors": "{count} 个连接器",
  "pluginsView.uninstall": "卸载",
  "pluginsView.uninstalling": "卸载中…",
  "pluginsView.uninstallConfirm": "确定卸载「{title}」？",
  "pluginsView.uninstallSuccess": "已卸载「{title}」",
  "pluginsView.uninstallFailed": "无法卸载「{title}」",
  "pluginsView.sharing": "共享中…",
  "pluginsView.unsharing": "取消共享中…",
  "pluginsView.shareToTeam": "转为团队共享",
  "pluginsView.syncToTeam": "同步更新到团队",
  "pluginsView.unshareFromTeam": "取消团队共享",
  "pluginsView.moreActions": "{title} 更多操作",
  "pluginsView.skillUrlUnsupported": "技能暂不支持从链接导入，请改用「上传本地文件夹」。",
  "pluginsView.importPluginSuccess": "已导入并上传专家套件",
  "pluginsView.importFailed": "导入失败，请检查链接后重试。",
  "pluginsView.uploadPluginSuccess": "已上传专家套件",
  "pluginsView.uploadFailed": "上传失败，请检查文件夹内容。",
  "pluginsView.importSkillSuccess": "已导入 Skill「{name}」，可在「个人的」中转为团队共享。",
  "pluginsView.shareSuccess": "已将「{title}」共享给团队，团队成员即可使用",
  "pluginsView.shareUnavailable": "暂时无法共享「{title}」，请确认你在团队工作区内。",
  "pluginsView.shareFailed": "共享「{title}」失败，请稍后重试。",
  "pluginsView.syncSuccess": "已将最新的「{title}」同步到团队。",
  "pluginsView.syncUnavailable": "暂时无法同步「{title}」。请确认你在团队工作区中。",
  "pluginsView.syncFailed": "同步「{title}」到团队失败，请稍后重试。",
  "pluginsView.unshareSuccess": "已取消「{title}」的团队共享。",
  "pluginsView.unshareUnavailable": "暂时无法取消「{title}」的团队共享，请确认你有权限。",
  "pluginsView.unshareFailed": "取消「{title}」的团队共享失败，请稍后重试。",
  "pluginsView.installSuccess": "已安装「{title}」",
  "pluginsView.installFailed": "安装「{title}」失败",
  "pluginsView.skillMissingFile": "所选文件夹中未找到 SKILL.md。",
  "pluginsView.skillReadFailed": "无法读取 SKILL.md，请重试。",
  "pluginsView.skillMissingName": "SKILL.md 缺少 name 字段。",
  "pluginsView.skillEmptyBody": "SKILL.md 内容为空。",
  "pluginsView.teamTitle": "私有团队插件市场",
  "pluginsView.teamBody":
    "此区域预留给企业和团队目录、私有信任策略，以及共享插件生命周期控制。",
  "pluginCard.details": "详情",
  "pluginCard.use": "使用",
  "pluginCard.useWithQuery": "带查询使用",
  "pluginCard.applying": "正在应用…",
  "pluginCard.duplicate": "Remix",
  "pluginCard.duplicating": "正在 Remix…",
  "pluginCard.duplicateFailed": "无法 Remix 这个模板。",
  "pluginCard.saved": "已保存",
  "pluginCard.publish": "发布",
  "pluginCard.contribute": "贡献",
  "pluginCard.starting": "正在启动…",
  "pluginCard.detailsAria": "查看 {title} 的详情",
  "pluginCard.chooseUseAria": "选择 {title} 的使用方式",
  "pluginCard.useOptionsAria": "{title} 的使用选项",
  "pluginCard.duplicateAria": "将 {title} Remix 成新项目",
  "pluginCard.saveAria": "保存 {title}",
  "pluginCard.savedAria": "{title} 已保存",
  "pluginCard.shareAria": "分享 {title}",
  "pluginCard.publishAria": "将 {title} 发布为 GitHub 仓库",
  "pluginCard.publishTitle": "将插件发布为 GitHub 仓库",
  "pluginCard.contributeAria": "将 {title} 贡献到 OpenDesign",
  "pluginCard.contributeTitle": "通过 pull request 将插件贡献到 OpenDesign",
  "integrations.kicker": "集成",
  "integrations.lede":
    "连接外部系统，把 MCP 工具带入智能体循环，并在其它 IDE、脚本和自动化中使用 OpenDesign。",
  "integrations.agentReady": "智能体就绪",
  "integrations.areasAria": "集成区域",
  "integrations.tabLabel.mcp": "MCP 服务器",
  "integrations.tabLabel.skills": "技能",
  "integrations.tabHint.mcp": "外部工具",
  "integrations.tabHint.connectors": "账号和 API",
  "integrations.tabHint.useEverywhere": "CLI、HTTP、MCP",
  "integrations.skillsTitle": "技能集成",
  "integrations.skillsBody":
    "技能级集成管理正在从另一个分支迁移过来。此标签页预留给 MCP、连接器和未来技能设置，使它们位于同一个集成路由中。",
  "mcpClient.title": "外部 MCP 服务器",
  "mcpClient.subtitle": "供编码智能体使用的第三方工具。",
  "mcpClient.addServer": "添加服务器",
  "mcpClient.emptyTitle": "尚未配置 MCP 服务器。",
  "mcpClient.emptyBody":
    "点击“添加服务器”开始 — 选择模板（Higgsfield OpenClaw、Pollinations、Allyson、Imagician、EdgeOne Pages、GitHub、Filesystem…），或配置自定义 stdio / HTTP 服务器。",
  "mcpClient.saveChanges": "保存更改",
  "mcpClient.storedAt": "存储于",
  "mcpClient.daemonError":
    "无法连接本地 daemon。请确认 OpenDesign 正在运行，然后重新打开此面板。",
  "mcpClient.saveFailed": "保存失败。请检查 daemon 是否正在运行后重试。",
  "useEverywhere.modalAria": "随处使用 OpenDesign",
  "useEverywhere.modalTitle": "随处使用 OpenDesign",
  "useEverywhere.modalSubtitle":
    "把 OpenDesign 接入任何 IDE、智能体或脚本：CLI、HTTP、MCP 和 Skills。使用“复制智能体指南”，粘贴到 Claude Code、Codex、Cursor、openclaw 或 hermes 中即可完成配置。",
  "useEverywhere.closeAria": "关闭随处使用",
  "useEverywhere.closeTitle": "关闭 (Esc)",
  "useEverywhere.tabsAria": "集成入口",
  "useEverywhere.footStrong": "一键交接。",
  "useEverywhere.footBody":
    "复制一份结构化 Markdown 指南，智能体可以立即按步骤安装、验证并使用。",
  "useEverywhere.configureMcp": "配置 MCP 服务器",
  "useEverywhere.copyGuide": "复制智能体指南",
  "useEverywhere.copy": "复制",
  "useEverywhere.copied": "已复制",
  "useEverywhere.copyFailed": "复制失败",
  "useEverywhere.copySnippetAria": "复制代码片段：{label}",
  "useEverywhere.section.overview.tab": "概览",
  "useEverywhere.section.overview.heading":
    "OpenDesign 可在智能体工作的任何地方运行",
  "useEverywhere.section.overview.intro":
    "OpenDesign 不只是一个窗口；它包含本地特权 daemon（`od`），以及 Skills + Design Systems + Atoms registry。它在你的机器上运行后，任何代码智能体（Claude Code、Codex、Cursor、OpenCode/openclaw、Hermes 或你自己的脚本）都可以通过四种可互换入口驱动生成、检查项目并产出设计制品。",
  "useEverywhere.section.overview.bullet1":
    "CLI — 使用 `od <command>` 支持无头脚本、CI 和 shell 自动化。",
  "useEverywhere.section.overview.bullet2":
    "MCP 服务器 — 将 OpenDesign 作为 Model Context Protocol 服务器接入，使任何支持 MCP 的智能体都能列出技能、运行场景并读取制品。",
  "useEverywhere.section.overview.bullet3":
    "HTTP API — `http://127.0.0.1:7456/api/*` REST + SSE 端点；与 Web UI 使用同一套接口。",
  "useEverywhere.section.overview.bullet4":
    "Skills — 可直接放入的 `SKILL.md` 包（兼容 Claude），任何已在 PATH 中的智能体都能调用，甚至不需要打开 OpenDesign。",
  "useEverywhere.section.overview.bullet5":
    "标准制品 — 在 daemon 启动前，从 Skills、内置默认插件和社区插件示例中种子生成真实 HTML 项目。",
  "useEverywhere.section.overview.snippet1": "本地启动 daemon（和 Web UI）",
  "useEverywhere.section.overview.snippet2": "确认服务可访问",
  "useEverywhere.section.overview.snippet3": "启动前导入标准制品",
  "useEverywhere.section.overview.footer":
    "daemon 默认写入项目本地的 `./.od/`。设置 `OD_DATA_DIR=~/.open-design` 可在多个项目间共享数据。",
  "useEverywhere.section.cli.tab": "CLI · od",
  "useEverywhere.section.cli.heading": "从任意 shell 驱动 OpenDesign",
  "useEverywhere.section.cli.intro":
    "`od` 命令随 daemon 一起发布，也是 Claude Code / Codex 运行生成时使用的同一个二进制。多数子命令都是向本地 daemon 发送 POST 的轻量客户端，因此无论你通过 `pnpm tools-dev` 启动，还是通过打包应用启动，行为都一致。",
  "useEverywhere.section.cli.bullet1":
    "`od`（无参数）— 启动 daemon 并打开 Web UI。",
  "useEverywhere.section.cli.bullet2":
    "`od media generate ...` — 通过统一媒体协议生成图片 / 视频 / 音频字节。",
  "useEverywhere.section.cli.bullet3":
    "`od run ...` — 从 prompt + skill 启动一次项目运行。",
  "useEverywhere.section.cli.bullet4":
    "`od plugin install <source>` / `od plugin apply <id>` — 安装并应用社区插件。",
  "useEverywhere.section.cli.bullet5":
    "`od skills list` / `od design-systems list` — 查看本地可用内容。",
  "useEverywhere.section.cli.bullet6":
    "`od status` / `od doctor` — 验证 daemon 健康状态并检测 PATH 中的智能体 CLI。",
  "useEverywhere.section.cli.snippet1": "生成图片（委托给已配置的媒体提供方）",
  "useEverywhere.section.cli.snippet2":
    "无头运行场景插件，并以 JSON Lines 流式输出事件",
  "useEverywhere.section.cli.snippet3":
    "清点本地可用的 skills 和 design systems",
  "useEverywhere.section.cli.snippet4": "通过 CLI 检查种子制品",
  "useEverywhere.section.cli.snippet5":
    "验证环境和已检测到的智能体（Claude、Codex、Cursor 等）",
  "useEverywhere.section.cli.footer":
    "所有子命令都支持 `--daemon-url http://127.0.0.1:<port>`，用于指定某个运行中的 daemon；在测试中运行第二个隔离实例时很有用。",
  "useEverywhere.section.mcp.tab": "MCP 服务器",
  "useEverywhere.section.mcp.heading":
    "把 OpenDesign 暴露为任意代码智能体可用的 MCP 服务器",
  "useEverywhere.section.mcp.intro":
    "OpenDesign 内置 Model Context Protocol 服务器（`od mcp`），让任何支持 MCP 的客户端（Cursor、Claude Code、Antigravity、VS Code Copilot Chat、openclaw、hermes）都能发现 OpenDesign 工具（列出技能、渲染预览、生成媒体、运行插件），无需手动 shell 调用。daemon 会通过 `GET /api/mcp/install-info` 为主流客户端发布可直接粘贴的安装片段。",
  "useEverywhere.section.mcp.bullet1":
    "Stdio 传输 — 无需额外端口，客户端直接启动 `od mcp`。",
  "useEverywhere.section.mcp.bullet2":
    "作为 sidecar 启动时，会通过本地 IPC 状态 socket 自动发现实时 daemon URL。",
  "useEverywhere.section.mcp.bullet3":
    "普通安装会回退到 `--daemon-url http://127.0.0.1:<port>`，确保 MCP 进程总能找到运行中的 daemon。",
  "useEverywhere.section.mcp.bullet4":
    "固定 `OD_DATA_DIR`，让派生的 MCP 进程写入 daemon 已使用的位置，避免打包 macOS app bundle 中的 EPERM 问题。",
  "useEverywhere.section.mcp.snippet1":
    "通用 MCP 客户端配置（适用于 Cursor、Claude Code、Codex 等）",
  "useEverywhere.section.mcp.snippet2":
    "或者：让 daemon 返回与你安装方式匹配的片段",
  "useEverywhere.section.mcp.snippet3": "实时看板 MCP 变体（读取并刷新仪表盘）",
  "useEverywhere.section.mcp.footer":
    "在 OpenDesign 应用中，打开“设置 → 集成”即可复制特定客户端的安装命令（Cursor、Claude Code、Antigravity、VS Code），无需手写 JSON。",
  "useEverywhere.section.http.tab": "HTTP API",
  "useEverywhere.section.http.heading": "与 Web UI 相同的 REST + SSE 接口",
  "useEverywhere.section.http.intro":
    "本地 daemon 在 `http://127.0.0.1:7456` 提供 HTTP API（端口可配置）。Web UI 调用的每个端点也都可以供你的脚本使用。流式端点（聊天回合、项目运行）会发出 Server-Sent Events，事件类型定义在 `@open-design/contracts` 中。",
  "useEverywhere.section.http.bullet1": "`GET /api/health` — daemon 存活检查。",
  "useEverywhere.section.http.bullet2":
    "`GET /api/skills` 和 `GET /api/design-systems` — 可用 registry。",
  "useEverywhere.section.http.bullet3":
    "`GET /api/projects` 和 `POST /api/projects` — 列出和创建项目（POST 返回项目和首个会话）。",
  "useEverywhere.section.http.bullet4":
    "`GET /api/projects/:id/chat` — 某个会话的智能体事件 SSE 流。",
  "useEverywhere.section.http.bullet5":
    "`POST /api/plugins/:id/apply` — 绑定已安装插件，并获得其渲染后的示例查询和输入。",
  "useEverywhere.section.http.bullet6":
    "`GET /api/agents` — 检测 PATH 中的代码智能体 CLI。",
  "useEverywhere.section.http.snippet1":
    "列出已安装的 skills（智能体会把它们作为模板使用）",
  "useEverywhere.section.http.snippet2": "从 prompt 创建项目（完整服务端流程）",
  "useEverywhere.section.http.snippet3":
    "流式读取聊天回合（SSE，每行兼容 JSON Lines）",
  "useEverywhere.section.http.footer":
    "每个请求 / 响应的纯 TypeScript 类型都在 `@open-design/contracts` 中；脚本中导入即可获得完整自动补全，无需接入生成器。",
  "useEverywhere.section.skills.tab": "Skills 和无头模式",
  "useEverywhere.section.skills.heading":
    "任意智能体可直接使用的 Skills，即使 OpenDesign 未运行",
  "useEverywhere.section.skills.intro":
    "Skill 是一个包含 Claude 兼容 `SKILL.md`（YAML front matter + 正文）的目录。OpenDesign 通过 `od:` 命名空间（`mode`、`preview`、`design_system`、`inputs` 等）扩展该格式，使同一个制品既能在 OpenDesign 内使用，也能被 Claude Code、Codex、openclaw 或 hermes 这类普通智能体使用。发现逻辑遵循优先级链，因此项目可以覆盖自己的 skills。",
  "useEverywhere.section.skills.bullet1":
    "发现顺序：`./.claude/skills/` → `./skills/` → `~/.claude/skills/`（项目优先）。",
  "useEverywhere.section.skills.bullet2":
    "把同一个 skill 符号链接到多个项目，无需复制即可共享。",
  "useEverywhere.section.skills.bullet3":
    "每个 skill 都可以声明 connectors、atoms、design-system 要求，以及用于 gallery 的 `preview` 示例输出。",
  "useEverywhere.section.skills.bullet4":
    "无头模式：PATH 中有 `od` 的智能体可以调用 `od skills list` 后运行任意 skill；只读流程不强制需要 daemon。",
  "useEverywhere.section.skills.bullet5":
    "`pnpm seed:test-projects` 会用默认插件示例和社区插件示例演练同一制品形态，并把生成的 `index.html` 项目保存为可复用测试数据。",
  "useEverywhere.section.skills.snippet1":
    "最小 SKILL.md（Claude 兼容 front matter + OpenDesign 扩展）",
  "useEverywhere.section.skills.snippet2":
    "把共享 skill 符号链接到项目中（cc-switch 风格）",
  "useEverywhere.section.skills.snippet3":
    "无头模式：列出 daemon 当前看到的 skills",
  "useEverywhere.section.skills.snippet4": "无头制品夹具包",
  "useEverywhere.section.skills.footer":
    "规范：`docs/skills-protocol.md` 和 `docs/agent-adapters.md` 覆盖完整适配器表面（Claude Code、Codex、Cursor、MCP-capable agents、BYOK API fallback）以及每种适配器的 skill 注入策略。",
  "tasks.kicker": "自动化工作区",
  "tasks.comingSoon": "即将上线",
  "tasks.lede":
    "自动化会把 Prompt 变成可持续运行的工作：Orbit 负责执行，例程负责保留，计划决定触发时间，实时看板展示变化。",
  "tasks.newAutomation": "新建自动化",
  "tasks.previewNote":
    "当前仅为预览界面。Orbit 设置已可用；例程、计划和实时看板接线会随后端分支合并后上线。",
  "tasks.primitivesAria": "自动化基础能力",
  "tasks.primitive.orbit.title": "Orbit",
  "tasks.primitive.orbit.body": "用于长期或周期性智能体工作的持久运行时。",
  "tasks.primitive.orbit.enabled": "每日摘要已启用",
  "tasks.primitive.orbit.manualOnly": "仅手动",
  "tasks.primitive.routines.title": "例程",
  "tasks.primitive.routines.body": "单次聊天结束后仍能保留的持久任务定义。",
  "tasks.primitive.routines.meta": "产品外壳已就绪",
  "tasks.primitive.schedules.title": "计划",
  "tasks.primitive.schedules.body": "按时间或事件触发，决定例程何时运行。",
  "tasks.primitive.schedules.meta": "分支待合并",
  "tasks.primitive.liveArtifacts.title": "实时看板",
  "tasks.primitive.liveArtifacts.body": "智能体工作时持续更新的报告和笔记。",
  "tasks.primitive.liveArtifacts.meta": "预览模型",
  "tasks.listAria": "自动化列表",
  "tasks.routinesAndRuns": "{n} 个例程和运行",
  "tasks.filtersAria": "自动化筛选",
  "tasks.filter.scheduled": "已计划",
  "tasks.filter.running": "运行中",
  "tasks.filter.done": "已完成",
  "tasks.configurationAria": "自动化配置",
  "tasks.slot.trigger": "触发器",
  "tasks.slot.pattern": "模式",
  "tasks.slot.runtime": "运行时",
  "tasks.slot.output": "输出",
  "tasks.liveArtifact": "实时看板",
  "tasks.viewProgress": "查看进度",
  "tasks.pause": "暂停",
  "tasks.runNow": "立即运行",
  "tasks.openArtifact": "打开制品",
  "tasks.status.dailyAt": "每日 · {time}",
  "tasks.status.pausedManual": "已暂停 · 仅手动",
  "tasks.sample.orbit.title": "Orbit 每日连接器摘要",
  "tasks.sample.orbit.metaEnabled": "连接器摘要已计划运行",
  "tasks.sample.orbit.metaDisabled": "打开 Orbit 设置以启用",
  "tasks.sample.orbit.previewEnabled": "orbit_daily.html · 实时看板",
  "tasks.sample.orbit.previewDisabled": "尚未计划运行",
  "tasks.sample.orbit.triggerEnabled": "计划 · 每日 {time}",
  "tasks.sample.orbit.triggerDisabled": "手动 · 按需运行",
  "tasks.sample.orbit.pattern": "例程 · 连接器摘要",
  "tasks.sample.orbit.runtime": "Orbit · daemon 计划任务",
  "tasks.sample.orbit.output": "实时看板 · 可刷新报告",
  "tasks.sample.orbit.artifactMetaEnabled": "每次运行后刷新",
  "tasks.sample.orbit.artifactMetaDisabled": "等待计划",
  "tasks.sample.orbit.body1": "# Orbit 每日活动摘要",
  "tasks.sample.orbit.body2": "已检查连接器 · 成功、跳过和失败",
  "tasks.sample.orbit.body3": "重点内容会变成可刷新的实时看板。",
  "tasks.sample.mcp.title": "MCP 替代方案研究",
  "tasks.sample.mcp.status": "正在 Orbit 中运行 · 2 小时 14 分",
  "tasks.sample.mcp.meta": "已处理 14 / 30 个来源",
  "tasks.sample.mcp.preview": "research_notes.md · 实时",
  "tasks.sample.mcp.trigger": "手动 · 一次性",
  "tasks.sample.mcp.pattern": "深度研究 Prompt",
  "tasks.sample.mcp.runtime": "远程 · 持久",
  "tasks.sample.mcp.output": "实时报告 · 自动更新",
  "tasks.sample.mcp.artifactMeta": "12 秒前更新",
  "tasks.sample.mcp.body1": "# MCP 替代方案 - 阶段性发现",
  "tasks.sample.mcp.body2": "已审阅 14 个来源 · 入围 3 个候选",
  "tasks.sample.mcp.body3": "## 入围清单",
  "tasks.sample.mcp.body4": "- 基于 JSON-RPC 的工具调用 schema...",
  "tasks.sample.mcp.body5": "- 基于 gRPC 的智能体协议...",
  "tasks.sample.weekly.title": "团队周报摘要",
  "tasks.sample.weekly.status": "下次：周一 9:00 AM",
  "tasks.sample.weekly.meta": "更新团队周报文档",
  "tasks.sample.weekly.preview": "team_weekly.md · 下一个制品",
  "tasks.sample.weekly.trigger": "计划 · 每周",
  "tasks.sample.weekly.pattern": "例程 · 团队摘要",
  "tasks.sample.weekly.runtime": "远程 · 周期性",
  "tasks.sample.weekly.output": "实时看板 · Markdown",
  "tasks.sample.weekly.artifactMeta": "4 天前更新",
  "tasks.sample.weekly.body1": "# 团队周报",
  "tasks.sample.weekly.body2": "## 进行中",
  "tasks.sample.weekly.body3": "- 设计体系集成梳理",
  "tasks.sample.weekly.body4": "- 连接器质量清理",
  "tasks.sample.weekly.body5": "## 风险",
  "tasks.sample.pr.title": "PR 评审提醒",
  "tasks.sample.pr.status": "新 PR 触发 · 23 分钟前已发送",
  "tasks.sample.pr.meta": "发送 Slack 私信",
  "tasks.sample.pr.preview": "上次发送成功",
  "tasks.sample.pr.trigger": "事件 · 新 PR",
  "tasks.sample.pr.pattern": "例程 · 通知",
  "tasks.sample.pr.runtime": "本地 · 快速运行",
  "tasks.sample.pr.output": "消息 · Slack 私信",
  "tasks.sample.pr.artifactMeta": "23 分钟前触发",
  "tasks.sample.pr.body1": "已打开 PR #184 等待评审",
  "tasks.sample.pr.body2": "匹配评审者：design-platform、web-runtime",
  "tasks.sample.pr.body3": "发送结果：Slack 私信已发送",
  "tasks.sample.meeting.title": "会前准备",
  "tasks.sample.meeting.status": "明天 · 10:00 AM",
  "tasks.sample.meeting.meta": "一次性 · 发送摘要",
  "tasks.sample.meeting.preview": "meeting_brief.md · 已排队",
  "tasks.sample.meeting.trigger": "计划 · 一次性",
  "tasks.sample.meeting.pattern": "简报 Prompt",
  "tasks.sample.meeting.runtime": "远程 · 有边界",
  "tasks.sample.meeting.output": "制品 + 消息",
  "tasks.sample.meeting.artifactMeta": "已排队等待生成",
  "tasks.sample.meeting.body1": "# 会议简报",
  "tasks.sample.meeting.body2": "议程来源：日历事件 + 关联文档",
  "tasks.sample.meeting.body3": "输出将包含决策、阻塞点和问题。",
  "tasks.sample.candidate.title": "候选人跟踪",
  "tasks.sample.candidate.status": "失败 · 需要处理",
  "tasks.sample.candidate.meta": "授权已过期",
  "tasks.sample.candidate.preview": "重新连接 Greenhouse 以继续",
  "tasks.sample.candidate.trigger": "计划 · 每日",
  "tasks.sample.candidate.pattern": "例程 · 申请人同步",
  "tasks.sample.candidate.runtime": "远程 · 周期性",
  "tasks.sample.candidate.output": "实时看板 · 表格",
  "tasks.sample.candidate.artifactMeta": "授权恢复前已暂停",
  "tasks.sample.candidate.body1": "# 候选人管道",
  "tasks.sample.candidate.body2": "上次成功同步：2 天前",
  "tasks.sample.candidate.body3": "需要操作：重新连接来源账号。",
  "routines.title": "自动化",
  "routines.subtitle": "无需值守、按计划运行的自动化任务。",
  "routines.newAutomation": "新建自动化",
  "routines.loading": "加载中…",
  "routines.empty": "还没有自动化任务。",
  "routines.emptyHint": "点击“新建自动化”即可安排一次无人值守的智能体运行。",
  "routines.runHistoryLoading": "正在加载运行记录…",
  "routines.runHistoryEmpty": "还没有运行记录。",
  "routines.fieldName": "名称",
  "routines.fieldNamePlaceholder": "晨间简报",
  "routines.fieldPrompt": "提示词",
  "routines.fieldPromptPlaceholder":
    "拉取昨天的 GitHub 与 Linear 活动并总结有哪些变化。",
  "routines.fieldSchedule": "计划",
  "routines.fieldMinute": "每小时的第几分钟",
  "routines.fieldTime": "时间",
  "routines.fieldTimezone": "时区",
  "routines.fieldsetProject": "项目",
  "routines.kind.hourly": "每小时",
  "routines.kind.daily": "每天",
  "routines.kind.weekdays": "工作日",
  "routines.kind.weekly": "每周",
  "routines.weekday.short.0": "周日",
  "routines.weekday.short.1": "周一",
  "routines.weekday.short.2": "周二",
  "routines.weekday.short.3": "周三",
  "routines.weekday.short.4": "周四",
  "routines.weekday.short.5": "周五",
  "routines.weekday.short.6": "周六",
  "routines.weekday.long.0": "周日",
  "routines.weekday.long.1": "周一",
  "routines.weekday.long.2": "周二",
  "routines.weekday.long.3": "周三",
  "routines.weekday.long.4": "周四",
  "routines.weekday.long.5": "周五",
  "routines.weekday.long.6": "周六",
  "routines.timeAm": "上午",
  "routines.timePm": "下午",
  "routines.describe.hourly": "每小时的第 {minute} 分运行",
  "routines.describe.daily": "每天 {time}（{tz}）运行",
  "routines.describe.weekdays": "周一至周五 {time}（{tz}）运行",
  "routines.describe.weekly": "每{day} {time}（{tz}）运行",
  "routines.modeCreate": "每次运行新建项目",
  "routines.modeCreateHint": "每次触发都使用一个全新且隔离的工作区。",
  "routines.modeReuse": "复用现有项目",
  "routines.modeReuseHint": "每次运行作为该项目中的一次新对话。",
  "routines.pickProject": "— 选择一个项目 —",
  "routines.targetReuse": "→ {project}",
  "routines.targetCreate": "→ 每次运行新建项目",
  "routines.tagPaused": "已暂停",
  "routines.metaNext": "下次：{when}",
  "routines.metaLast": "上次：",
  "routines.triggerManual": "手动",
  "routines.triggerScheduled": "计划",
  "routines.openProject": "打开项目",
  "routines.openProjectTitle": "打开本次运行写入的项目",
  "routines.runNow": "立即运行",
  "routines.edit": "编辑",
  "routines.pause": "暂停",
  "routines.resume": "恢复",
  "routines.history": "历史记录",
  "routines.hideHistory": "隐藏历史记录",
  "routines.delete": "删除",
  "routines.deleteTitle": "删除此自动化",
  "routines.cancel": "取消",
  "routines.save": "保存",
  "routines.saving": "保存中…",
  "routines.create": "创建",
  "routines.creating": "创建中…",
  "routines.status.queued": "排队中",
  "routines.status.running": "运行中",
  "routines.status.succeeded": "成功",
  "routines.status.failed": "失败",
  "routines.status.canceled": "已取消",
  "routines.confirmDelete": "删除此自动化？过往运行记录及其项目将予以保留。",
  "routines.errorPickProject":
    "请选择要复用的项目，或切换为“每次运行新建项目”。",
  "routines.errorAgentEmptyOutput":
    "代理已完成运行但未产生任何输出。模型或提供商可能返回了空响应，请检查代理日志中的上游错误。",
  "entry.githubStarLabel": "Star",
  "entry.githubStarTitle": "为我们在 GitHub 点亮 Star",
  "entry.githubStarAria": "在 GitHub 上为 OpenDesign 点亮 Star",
  "entry.tabImageTemplates": "图片模板",
  "entry.tabVideoTemplates": "视频模板",
  "promptTemplates.emptyNoMatch": "没有匹配的模板。",
  "promptTemplates.fetchError": "无法加载此模板正文。",
  "promptTemplates.promptLabel": "Prompt 正文",
  "promptTemplates.copyPrompt": "复制 Prompt",
  "promptTemplates.copyDone": "已复制！",
  "promptTemplates.allSources": "所有来源",
  "promptTemplates.retry": "重试",
  "connectors.title": "连接器",
  "connectors.subtitle": "可为实时看板提供数据的本地和未来数据源。",
  "connectors.account": "账号",
  "connectors.noAccount": "未连接",
  "connectors.tools": "工具",
  "connectors.connect": "连接",
  "connectors.disconnect": "断开连接",
  "connectors.authorizationPending": "等待授权中...",
  "connectors.authorizationPendingHint": "请在已打开的窗口中完成授权。",
  "connectors.cancelAuthorization": "取消",
  "connectors.configure": "配置",
  "connectors.unavailable": "不可用",
  "connectors.phaseStubTitle": "连接器 API 将在 Phase 3 提供；这里是预览入口。",
  "connectors.statusAvailable": "可用",
  "connectors.statusConnected": "已连接",
  "connectors.statusError": "错误",
  "connectors.statusDisabled": "已停用",
  "connectors.gateTitle": "添加 Composio API 密钥以继续",
  "connectors.gateBody": "在上方粘贴密钥并点击“保存密钥”，即可加载可用集成。",
  "connectors.aboutLabel": "简介",
  "connectors.detailsLabel": "详情",
  "connectors.statusLabel": "状态",
  "connectors.category.aiAgents": "AI 代理",
  "connectors.category.aiInfrastructure": "AI 基础设施",
  "connectors.category.accounting": "会计",
  "connectors.category.admin": "管理",
  "connectors.category.advertising": "广告",
  "connectors.category.analytics": "分析",
  "connectors.category.automation": "自动化",
  "connectors.category.cms": "CMS",
  "connectors.category.crm": "CRM",
  "connectors.category.calendar": "日历",
  "connectors.category.commerce": "电商",
  "connectors.category.communication": "沟通",
  "connectors.category.contacts": "联系人",
  "connectors.category.dataPlatform": "数据平台",
  "connectors.category.database": "数据库",
  "connectors.category.design": "设计",
  "connectors.category.developer": "开发者工具",
  "connectors.category.documentation": "文档",
  "connectors.category.erp": "ERP",
  "connectors.category.education": "教育",
  "connectors.category.email": "邮件",
  "connectors.category.events": "活动",
  "connectors.category.fieldService": "现场服务",
  "connectors.category.finance": "财务",
  "connectors.category.fitness": "健身",
  "connectors.category.forms": "表单",
  "connectors.category.gaming": "游戏",
  "connectors.category.hr": "人力资源",
  "connectors.category.hospitality": "酒店与款待",
  "connectors.category.itsm": "ITSM",
  "connectors.category.integration": "集成",
  "connectors.category.localization": "本地化",
  "connectors.category.logistics": "物流",
  "connectors.category.maps": "地图",
  "connectors.category.marketing": "营销",
  "connectors.category.media": "媒体",
  "connectors.category.meetings": "会议",
  "connectors.category.nonprofit": "非营利",
  "connectors.category.observability": "可观测性",
  "connectors.category.payments": "支付",
  "connectors.category.personal": "个人",
  "connectors.category.presentations": "演示文稿",
  "connectors.category.procurement": "采购",
  "connectors.category.product": "产品",
  "connectors.category.productivity": "生产力",
  "connectors.category.projectManagement": "项目管理",
  "connectors.category.recruiting": "招聘",
  "connectors.category.research": "研究",
  "connectors.category.salesIntelligence": "销售情报",
  "connectors.category.scheduling": "日程安排",
  "connectors.category.search": "搜索",
  "connectors.category.security": "安全",
  "connectors.category.signing": "签署",
  "connectors.category.social": "社交",
  "connectors.category.spreadsheets": "电子表格",
  "connectors.category.storage": "存储",
  "connectors.category.support": "支持",
  "connectors.category.surveys": "问卷",
  "connectors.category.tasks": "任务",
  "connectors.category.timeTracking": "时间追踪",
  "connectors.category.video": "视频",
  "connectors.category.whiteboard": "白板",
  "connectors.categoryLabel": "类别",
  "connectors.providerLabel": "提供方",
  "connectors.toolsSection": "工具",
  "connectors.toolsLoading": "正在加载工具…",
  "connectors.noToolsAvailable":
    "暂无可用工具，连接后即可发现此集成提供的能力。",
  "connectors.toolDetailsUnavailable":
    "无法获取工具详情,但此连接器报告了 {n} 个工具。",
  "connectors.loadMoreTools": "加载更多工具",
  "connectors.openDetailsAria": "查看 {name} 详情",
  "connectors.toolsBadgeNone": "暂无工具",
  "connectors.toolsBadgeOne": "{n} 个工具",
  "connectors.toolsBadgeMany": "{n} 个工具",
  "connectors.searchPlaceholder": "搜索连接器…",
  "connectors.searchAriaLabel": "按名称、提供方或工具搜索连接器",
  "connectors.searchClear": "清除搜索",
  "connectors.emptyNoMatchTitle": "没有匹配“{query}”的连接器",
  "connectors.emptyNoMatchBody": "换个关键词试试，或清除搜索以浏览完整目录。",
  "connectors.emptyNoMatchAction": "清除搜索",
  "newproj.tabPrototype": "原型",
  "newproj.tabLiveArtifact": "实时看板",
  "newproj.tabDeck": "幻灯片",
  "newproj.tabTemplate": "从模板",
  "newproj.tabMedia": "媒体",
  "newproj.tabOther": "其它",
  "newproj.titlePrototype": "新建原型",
  "newproj.titleLiveArtifact": "新建实时看板",
  "newproj.titleDeck": "新建幻灯片",
  "newproj.titleTemplate": "从模板开始",
  "newproj.titleImage": "新建图片",
  "newproj.titleVideo": "新建视频",
  "newproj.titleAudio": "新建音频",
  "newproj.titleMedia": "新建媒体",
  "newproj.titleOther": "新建项目",
  "newproj.namePlaceholder": "项目名称",
  "newproj.fidelityLabel": "精度",
  "newproj.fidelityWireframe": "线框图",
  "newproj.fidelityHigh": "高保真",
  "newproj.toggleSpeakerNotes": "使用演讲备注",
  "newproj.toggleSpeakerNotesHint": "减少幻灯片上的文字，要点放到备注中。",
  "newproj.toggleAnimations": "加入动效",
  "newproj.toggleAnimationsHint": "在模板基础上叠加动效（入场、悬停、过渡）。",
  "newproj.targetPlatformsLabel": "目标平台",
  "newproj.targetPlatformsHint":
    "可多选。响应式 Web 仅覆盖浏览器断点；如需原生跨平台版本，请加入 iOS、Android、平板应用或桌面应用。",
  "newproj.platform.responsive.label": "响应式 Web",
  "newproj.platform.responsive.hint":
    "一套 Web 体验，适配桌面、平板和移动浏览器",
  "newproj.platform.webDesktop.label": "桌面 Web",
  "newproj.platform.webDesktop.hint": "浏览器优先的产品或落地页",
  "newproj.platform.mobileIos.label": "iOS 应用",
  "newproj.platform.mobileIos.hint": "iPhone 画框与 iOS 交互规范",
  "newproj.platform.mobileAndroid.label": "Android 应用",
  "newproj.platform.mobileAndroid.hint": "Pixel 画框与 Material 交互规范",
  "newproj.platform.tablet.label": "平板应用",
  "newproj.platform.tablet.hint": "原生风格的平板体验，支持分屏视图",
  "newproj.platform.desktopApp.label": "桌面应用",
  "newproj.platform.desktopApp.hint": "macOS/Windows 应用外观",
  "newproj.surfaceOptionsLabel": "配套界面",
  "newproj.includeLandingPage": "包含落地页",
  "newproj.includeLandingPageHint":
    "为广告、候补名单、发布活动、应用下载或产品说明添加一个响应式营销页面。",
  "newproj.includeOsWidgets": "包含系统小部件",
  "newproj.includeOsWidgetsHint":
    "为移动/平板应用添加平台原生的主屏幕、锁屏或快捷小部件。",
  "newproj.includeOsWidgetsDisabledHint":
    "选择 iOS、Android 或平板应用作为目标平台时可用。",
  "newproj.templateLabel": "模板",
  "newproj.noTemplatesTitle": "还没有模板",
  "newproj.noTemplatesBody":
    "打开任意项目，在文件查看器内的「分享」菜单将其保存为模板，模板将出现在这里。",
  "newproj.savedTemplate": "已保存的模板",
  "newproj.fileSingular": "个文件",
  "newproj.filePlural": "个文件",
  "newproj.create": "创建",
  "newproj.locationLabel": "保存到",
  "newproj.locationDefault": "OpenDesign 项目",
  "newproj.locationExternalBase": "外部基目录",
  "newproj.createLiveArtifact": "创建实时看板",
  "newproj.createFromTemplate": "基于模板创建",
  "newproj.createDisabledTitle":
    "请先在任意项目内通过「分享」菜单将其保存为模板。",
  "newproj.openFolder": "打开文件夹",
  "newproj.openingFolder": "正在打开…",
  "newproj.importClaudeZip": "导入 Claude Design ZIP",
  "newproj.importClaudeZipTitle": "导入 Claude Design 导出的 .zip 文件",
  "newproj.importingClaudeZip": "正在导入…",
  "newproj.privacyFooter": "默认情况下只有你能看到自己的项目。",
  "newproj.designSystem": "设计体系",
  "newproj.dsNoneFreeform": "不指定 — 自由发挥",
  "newproj.dsNoneSubtitleEmpty": "不使用体系 token，由你决定整体配色",
  "newproj.dsNoneSubtitleSelected": "跳过体系 token，由代理自行选择配色。",
  "newproj.dsCategoryFallback": "设计体系",
  "newproj.dsSearch": "搜索设计体系…",
  "newproj.dsModeAria": "选择模式",
  "newproj.dsModeSingle": "单选",
  "newproj.dsModeMulti": "多选",
  "newproj.dsNoneTitle": "不指定 — 自由发挥",
  "newproj.dsNoneSub": "跳过体系 token，由代理自行选择配色。",
  "newproj.dsEmpty": "没有匹配「{query}」的设计体系。",
  "newproj.dsFootSingular": "只作为灵感参考。",
  "newproj.dsFootPlural": "只作为灵感参考。",
  "newproj.dsFootClear": "清除",
  "newproj.dsBadgeDefault": "默认",
  "newproj.dsPrimaryFallback": "主体系",
  "newproj.surfaceImage": "图片",
  "newproj.surfaceVideo": "视频",
  "newproj.surfaceAudio": "音频",
  "newproj.modelLabel": "模型",
  "newproj.modelSearch": "搜索模型…",
  "newproj.modelEmpty": "没有匹配的模型。",
  "newproj.modelRecommended": "推荐",
  "newproj.modelMissingTitle": "选择模型",
  "newproj.modelMissingSub": "为此场景选一个模型。",
  "newproj.aspectLabel": "比例",
  "newproj.videoLengthLabel": "时长",
  "newproj.videoLengthSeconds": "{n} 秒",
  "newproj.audioKindLabel": "音频类型",
  "newproj.audioKindMusic": "音乐",
  "newproj.audioKindSpeech": "配音 / TTS",
  "newproj.audioKindSfx": "音效",
  "newproj.audioDurationLabel": "时长",
  "newproj.audioDurationSeconds": "{n} 秒",
  "newproj.voiceLabel": "声音",
  "newproj.voicePlaceholder": "提供商 voice id，可选",
  "newproj.connectorsLabel": "连接器",
  "newproj.connectorsHint": "实时看板可以从这些数据源拉取信息。",
  "newproj.connectorsEmptyTitle": "尚未配置连接器",
  "newproj.connectorsEmptyBody":
    "连接一个数据源，让实时看板加载真实数据而非占位内容。",
  "newproj.connectorsEmptyCta": "去配置连接器 →",
  "newproj.connectorsLoading": "正在加载连接器…",
  "newproj.connectorsCountOne": "已连接 {n} 个",
  "newproj.connectorsCountMany": "已连接 {n} 个",
  "newproj.connectorsManage": "管理",
  "newproj.promptTemplateLabel": "参考模板",
  "newproj.promptTemplateNoneTitle": "不指定 — 自由发挥",
  "newproj.promptTemplateNoneSub": "跳过模板库，自己描述需求",
  "newproj.promptTemplateRefSub": "参考模板",
  "newproj.promptTemplateSearch": "搜索模板…",
  "newproj.promptTemplateEmpty": "当前还没有此类型的模板。",
  "newproj.promptTemplateBodyLabel": "Prompt（可继续优化）",
  "newproj.promptTemplateOptimizeHint":
    "可以任意编辑 — 修改后的内容会作为 agent 生成时的参考。",
  "newproj.promptTemplateBodyEmpty": "正文为空 — agent 不会拿到模板参考。",
  "newproj.deleteTemplateTitle": "删除模板",
  "newproj.deleteTemplateConfirm": "确定删除「{name}」？此操作无法撤销。",
  "newproj.deleteTemplateConfirmCta": "删除模板",
  "newproj.deleteTemplateError": "无法删除该模板，请重试。",
  "designs.subRecent": "最近",
  "designs.subYours": "我的设计",
  "designs.filterAria": "筛选项目",
  "designs.searchPlaceholder": "搜索…",
  "designs.emptyNoProjects": "还没有项目。",
  "designs.emptyNoMatch": "没有匹配的项目。",
  "designs.deleteTitle": "删除项目",
  "designs.deleteConfirm": "确定删除「{name}」？",
  "designs.cardFreeform": "自由设计",
  "designs.badgeLive": "实时",
  "designs.liveArtifactBadgesAria": "实时看板标记",
  "designs.liveCount": "{n} 个实时",
  "designs.statusLive": "实时看板",
  "designs.statusArchived": "已归档",
  "designs.statusError": "错误",
  "designs.statusRefreshing": "刷新中…",
  "designs.statusRefreshFailed": "刷新失败",
  "designs.statusRefreshed": "已刷新",
  "designs.status.notStarted": "未开始",
  "designs.status.queued": "等待中",
  "designs.status.running": "运行中",
  "designs.status.awaitingInput": "等待回复",
  "designs.status.incomplete": "未完成",
  "designs.status.succeeded": "已完成",
  "designs.status.published": "已发布",
  "designs.status.failed": "失败",
  "designs.status.canceled": "已取消",
  "designs.viewToggleAria": "视图模式",
  "designs.viewGrid": "网格视图",
  "designs.viewKanban": "看板视图",
  "designs.kanbanEmptyColumn": "暂无设计",
  "designs.deleteAria": "删除项目 {name}",
  "designs.menuMore": "更多操作",
  "designs.menuRename": "重命名",
  "designs.menuDelete": "删除",
  "designs.renamePrompt": "为「{name}」输入新名称",
  "designs.selectMode": "选择",
  "designs.cancelSelect": "取消",
  "designs.deleteSelected": "删除所选",
  "designs.selectedCount": "已选择 {n} 项",
  "designs.deleteSelectedConfirm": "确定删除选中的 {n} 个项目？",
  "designs.deleteSelectedSuccess": "已成功删除 {n} 个项目。",
  "designs.deleteSelectedPartial": "已删除 {deleted} 个项目；{failed} 个失败。",
  "designs.tagPrototype": "原型",
  "designs.tagLiveArtifact": "实时看板",
  "designs.tagWebClone": "网站复刻",
  "designs.tagSlide": "幻灯片",
  "designs.tagMedia": "媒体",
  "designs.renameTitle": "重命名项目",
  "designs.renameSave": "确定",
  "designs.renameCancel": "取消",
  "examples.typeLabel": "类型",
  "examples.surfaceLabel": "类型",
  "examples.surfaceWeb": "网页",
  "examples.surfaceImage": "图片",
  "examples.surfaceVideo": "视频",
  "examples.surfaceAudio": "音频",
  "examples.scenarioLabel": "场景",
  "examples.modeAll": "全部",
  "examples.modePrototypeDesktop": "原型 · 桌面端",
  "examples.modePrototypeMobile": "原型 · 移动端",
  "examples.modeDeck": "幻灯片",
  "examples.modeDocument": "文档与模板",
  "examples.modeOrbit": "Orbit",
  "examples.modeLive": "实时",
  "examples.scenarioGeneral": "通用",
  "examples.scenarioEngineering": "工程",
  "examples.scenarioProduct": "产品",
  "examples.scenarioDesign": "设计",
  "examples.scenarioMarketing": "市场",
  "examples.scenarioSales": "销售",
  "examples.scenarioFinance": "财务",
  "examples.scenarioHr": "人力资源",
  "examples.scenarioOperations": "运营",
  "examples.scenarioSupport": "支持",
  "examples.scenarioLegal": "法务",
  "examples.scenarioEducation": "教育",
  "examples.scenarioPersonal": "个人",
  "examples.searchPlaceholder": "搜索示例…",
  "examples.searchAria": "按名称搜索示例",
  "examples.emptyNoSkills": "没有可用的技能，守护进程是否在运行？",
  "examples.emptyNoMatch": "没有匹配当前筛选的示例。",
  "examples.openPreview": "⤢ 打开预览",
  "examples.loadingPreview": "正在加载预览…",
  "examples.hoverPreview": "将鼠标悬停以查看预览",
  "examples.usePrompt": "使用此 Prompt",
  "examples.previewModalTitle": "在弹窗中查看完整预览",
  "examples.shareTitle": "分享此示例",
  "examples.shareLoadFirst": "请先悬停以加载预览",
  "examples.unavailablePlaceholder":
    "此技能未附带 {kind} 预览样例 — 打开查看详情",
  "examples.shareUnavailable": "此技能未附带 {kind} 预览样例可分享",
  "examples.shareMenu": "分享 ▾",
  "examples.exportPdfAllSlides": "导出为 PDF（全部幻灯片）",
  "examples.exportPptxLocked": "导出为 PPTX…（请先打开模板）",
  "examples.tagSlideDeck": "幻灯片",
  "examples.tagTemplate": "模板",
  "examples.tagDesignSystem": "设计体系",
  "examples.tagMobilePrototype": "移动端原型",
  "examples.tagDesktopPrototype": "桌面端原型",
  "examples.tagImage": "图片",
  "examples.tagVideo": "视频",
  "examples.tagAudio": "音频",
  "examples.previewLabel": "预览",
  "ds.surfaceLabel": "类型",
  "ds.surfaceWeb": "网页",
  "ds.surfaceImage": "图片",
  "ds.surfaceVideo": "视频",
  "ds.surfaceAudio": "音频",
  "ds.searchPlaceholder": "搜索设计体系…",
  "ds.emptyNoMatch": "没有匹配的设计体系。",
  "ds.badgeDefault": "默认",
  "ds.preview": "预览完整体系",
  "ds.previewTitle": "预览完整设计体系",
  "ds.categoryAll": "全部",
  "ds.categoryUncategorized": "未分类",
  "ds.showcase": "展示",
  "ds.tokens": "Token",
  "ds.specToggle": "DESIGN.md",
  "ds.specLoading": "正在加载 DESIGN.md…",
  "avatar.title": "账户与设置",
  "avatar.localCli": "本机 CLI",
  "avatar.anthropicApi": "Anthropic API",
  "avatar.useLocal": "使用本机 CLI",
  "avatar.useApi": "使用 API · BYOK",
  "avatar.codeAgent": "代码代理",
  "avatar.rescan": "重新扫描 PATH",
  "avatar.amrConsole": "OpenDesign Cloud 账户",
  "avatar.amrConsoleMeta": "余额与充值",
  "avatar.settings": "设置",
  "avatar.backToProjects": "返回项目列表",
  "avatar.metaActive": "使用中",
  "avatar.metaOffline": "未运行",
  "avatar.metaSelected": "已选",
  "avatar.noAgentSelected": "尚未选择代理",
  "avatar.modelSection": "模型",
  "avatar.modelLabel": "模型",
  "avatar.reasoningLabel": "推理",
  "avatar.serviceTierLabel": "服务层级",
  "avatar.customSuffix": "（自定义）",
  "socialShare.openDesignSection": "分享 OpenDesign",
  "socialShare.openDesignTitle": "GitHub 上的 OpenDesign",
  "socialShare.openDesignText":
    "OpenDesign 是源码可用的设计智能工作区，可以生成、编辑、部署并交付设计产物。",
  "socialShare.openDesignCopyText": "{text}\n{url}",
  "socialShare.projectSection": "社媒分享",
  "socialShare.publishPageTitle": "发布分享页",
  "socialShare.publishPageSubtitle": "发布当前预览，以便分享到社媒平台。",
  "socialShare.projectTitle": "{title} · OpenDesign",
  "socialShare.projectText":
    "我用 OpenDesign 做了 {title}。查看已部署产物，也推荐收藏仓库：{repo}",
  "socialShare.projectCopyText":
    "我用 OpenDesign 做了 {title}\n{url}\nOpenDesign 仓库：{repo}",
  "socialShare.deployFirst": "先部署，再分享到社媒…",
  "socialShare.copied": "已复制",
  "socialShare.platform.x": "X",
  "socialShare.platform.linkedin": "LinkedIn",
  "socialShare.platform.facebook": "Facebook",
  "socialShare.platform.reddit": "Reddit",
  "socialShare.platform.telegram": "Telegram",
  "socialShare.platform.whatsapp": "WhatsApp",
  "socialShare.platform.weibo": "微博",
  "socialShare.platform.line": "LINE",
  "socialShare.platform.instagram": "Instagram",
  "socialShare.platform.xiaohongshu": "小红书",
  "inlineSwitcher.chipTitle": "切换 CLI / 模型",
  "inlineSwitcher.chipCli": "本地 CLI",
  "inlineSwitcher.chipByok": "自带 Key",
  "inlineSwitcher.modelDefault": "默认",
  "inlineSwitcher.noAgent": "未选择",
  "inlineSwitcher.modeLabel": "模式",
  "inlineSwitcher.agentLabel": "代理",
  "inlineSwitcher.providerLabel": "服务商",
  "inlineSwitcher.modelLabel": "模型",
  "inlineSwitcher.useCli": "使用本地 CLI",
  "inlineSwitcher.useByok": "使用自带 API Key",
  "inlineSwitcher.daemonOffline": "守护进程离线 — 打开设置",
  "inlineSwitcher.noAgentsDetected": "PATH 中未发现可用 CLI",
  "inlineSwitcher.openSettingsForModel": "在“设置”中配置该服务商",
  "inlineSwitcher.missingApiKey": "尚未填写 API Key — 在“设置”中添加。",
  "inlineSwitcher.openFullSettings": "打开执行设置",
  "inlineSwitcher.customSuffix": "（自定义）",
  "inlineSwitcher.unlimitedBadge": "无限使用",
  "project.backToProjects": "返回项目列表",
  "project.brandReadyTitle": "{name} 设计体系已就绪",
  "project.brandReadyTitleGeneric": "你的设计体系已就绪",
  "project.brandReadyCta": "在设计体系中预览",
  "project.brandReadyDismiss": "忽略",
  "project.brandReadyRefineHint":
    "自动提取可能漏掉细节。大范围使用前先优化这套体系。",
  "project.brandReadyAiOptimize": "AI 优化",
  "project.brandReadyEditManually": "手动编辑",
  "project.brandReadyPreviewOpened": "已跳转到设计体系预览。",
  "project.previewCommentSaveFailed": "评论保存失败，请重试。",
  "project.previewCommentSaveFailedTitle": "评论保存失败",
  "project.previewCommentSaveFailedDescription": "本次评论未保存成功，请重新尝试。",
  "project.previewCommentReorderFailed": "评论顺序保存失败，刷新页面后可能恢复原状。",
  "project.metaFreeform": "自由设计",
  "project.customInstructions": "项目指令",
  "project.customInstructionsPlaceholder": "此项目的指令（每条消息都会注入）…",
  "project.resizeChatPanel": "调整聊天面板大小",
  "project.instructionsActive": "已生效 — 每条消息都会附带",
  "project.missing": "该项目已删除或不存在。",
  "chat.tabChat": "对话",
  "chat.tabComments": "评论",
  "chat.commentsSoon": "评论 — 即将上线",
  "chat.comments.attached": "已附加到对话",
  "chat.comments.emptyAttached": "没有已附加的评论。",
  "chat.comments.saved": "已保存的评论",
  "chat.comments.emptySaved": "没有已保存的评论。",
  "chat.comments.add": "添加",
  "chat.comments.addAll": "全部添加",
  "chat.comments.remove": "移除",
  "chat.comments.placeholder": "评论此元素…",
  "chat.comments.addSend": "添加并发送",
  "chat.comments.updateSend": "更新并发送",
  "chat.comments.removeAttachment": "移除评论附件",
  "chat.comments.removeAttachmentAria": "移除 {name} 的评论附件",
  "chat.comments.comment": "评论",
  "chat.comments.sendToChat": "发送到聊天",
  "chat.comments.viewAll": "查看全部评论",
  "chat.comments.sending": "发送中…",
  "chat.comments.edit": "编辑",
  "chat.comments.select": "选择",
  "chat.comments.selectAll": "全选",
  "chat.comments.deselect": "取消选择",
  "chat.comments.nSelected": "已选择 {n} 个",
  "chat.comments.pin": "图钉",
  "chat.comments.addNote": "添加备注",
  "chat.comments.savedToast": "评论已保存",
  "chat.comments.pinSavedToast": "图钉已保存",
  "chat.comments.pinAtCoords": "位于 {x}, {y}",
  "chat.comments.capturedItems": "{n} 个捕获项",
  "chat.comments.clear": "清除",
  "chat.comments.targetImage": "图片",
  "chat.comments.targetControl": "控件",
  "chat.comments.targetLink": "链接",
  "chat.comments.targetText": "文本",
  "chat.comments.targetSection": "分区",
  "chat.comments.targetPage": "页面",
  "chat.comments.targetArea": "区域",
  "chat.annotationNotePlaceholder": "为这个标记添加说明",
  "chat.annotationAttachImage": "添加图片",
  "chat.annotationAttachedImages": "已添加图片",
  "chat.annotationAttachedRemove": "移除最后一张图片",
  "chat.annotationAddToInput": "发送到输入框",
  "chat.annotationAddingToInput": "正在添加...",
  "chat.annotationQueue": "加入队列",
  "chat.annotationQueueing": "加入队列中...",
  "chat.annotationSubmitOptions": "提交选项",
  "chat.annotationSending": "发送中...",
  "chat.annotationSendDisabledReason": "当前正有任务在执行",
  "chat.annotationPreviewMissing": "无法截到下面的预览，请重试",
  "chat.annotationPreviewMissingInk":
    "无法截到下面的预览，请重试，避免只附带笔迹",
  "chat.annotationSentWithoutScreenshot":
    "未能截取预览，已发送标注（不含截图）。",
  "chat.annotationTimeout": "标注发送超时，请重试",
  "chat.annotationFailed": "标注发送失败，请重试",
  "chat.annotationProjectCreateFailed": "无法创建项目，标注未发送",
  "chat.annotationUploadFailed": "附件上传失败，请重试",
  "chat.attachmentFolderUnsupported": "文件夹无法作为附件拖入，请改为选择其中的文件。",
  "chat.conversationsTitle": "历史会话",
  "chat.conversationsAria": "历史会话",
  "chat.newConversation": "新建对话",
  "chat.newSession": "新会话",
  "chat.newConversationsTitle": "新建对话",
  "chat.conversationsHeading": "对话",
  "chat.emptyConversations": "还没有对话。",
  "chat.deleteConversation": "删除对话",
  "chat.renameConversationLabel": "重命名「{title}」",
  "chat.deleteConversationConfirm": "确定删除「{title}」？该操作会删除其消息。",
  "chat.untitledConversation": "未命名对话",
  "chat.forkConversationFailed": "无法开始新会话。",
  "chat.startTitle": "开始一个对话",
  "chat.startHint": "描述你想生成的内容，或从下面的示例开始：",
  "chat.brandBrowserAssistDesktopOnly":
    "浏览器辅助需要桌面应用，OpenDesign 才能读取实时浏览器页面。",
  "chat.brandBrowserAssistReadFailed":
    "无法读取浏览器页面。请确认品牌网站已打开并完全加载。",
  "chat.memoryWrittenSummary": "已记住 {count} 条偏好",
  "chat.brandBrowserAssistMessage":
    "OpenDesign 需要浏览器辅助才能完成这次品牌提取。请先在 Browser 标签页清除页面拦截，然后在下方确认。",
  "brandEnrichment.title": "AI 优化",
  "brandEnrichment.body":
    "OpenDesign 会在后台运行更深度的抽取，自动带上合适的设计系统 skills，并原地更新这个系统。通常需要 10-20 分钟，你可以继续做别的事。",
  "brandEnrichment.cta": "AI 优化",
  "brandEnrichment.busy": "正在启动 AI 优化...",
  "brandExtractionTranscript.sourceDesignMd": "粘贴的 DESIGN.md",
  "brandExtractionTranscript.user": "从 {source} 抽取一个设计系统。",
  "brandExtractionTranscript.doneTitle": "{name} 的程序化抽取已完成。",
  "brandExtractionTranscript.doneBody":
    "我已经从 {source} 创建并注册了 {designSystemId} 设计系统。现在可以预览，也可以直接用于新设计。",
  "brandExtractionTranscript.next":
    "接下来，你可以选择：让 agent 消耗模型 token 做更深一轮语义化抽取并原地更新设计系统，或用这个已抽取的设计系统新建设计。",
  "chat.fillInputTitle": "点击填充到输入框",
  "chat.jumpToLatest": "回到最新",
  "chat.scrollToLatest": "滚动到最新",
  "chat.you": "你",
  "chat.record.retryImage": "刚才有 {count} 张配套插图没生成出来,麻烦重新生成一下",
  "chat.quote.add": "添加到对话",
  "chat.quote.count": "{count} 条注释",
  "chat.quote.duplicate": "会话已添加",
  "chat.quote.removeAria": "移除注释",
  "chat.support.title": "联系支持",
  "chat.support.join": "加入",
  "chat.sendFailedRetryAria": "发送失败,重试",
  "chat.audio.play": "播放",
  "chat.audio.pause": "暂停",
  "chat.audio.download": "下载 {name}",
  "chat.upgrade.balance": "剩余额度",
  "chat.upgrade.whyLow": "余额可能撑不完下一个任务 —— 中途用尽会停在半成品上",
  "chat.upgrade.whyOut": "现在无法开始新任务",
  "chat.upgrade.pausedTitle": "额度不足，任务已暂停",
  "chat.upgrade.pausedMessage": "当前额度不足，请充值或升级套餐后再试。",
  "chat.upgrade.pausedTeamTitle": "团队额度不足，任务已暂停",
  "chat.upgrade.pausedTeamMessage": "当前团队额度不足，请联系团队管理员充值或升级订阅。",
  "chat.openFile": "打开 {name}",
  "chat.copyPrompt": "复制提示词",
  "chat.copyErrorDiagnostic": "复制错误诊断信息",
  "chat.copyDone": "已复制！",
  "chat.inspect.noEditableTargets": "未找到可编辑的文本或样式目标。",
  "chat.inspect.noCommentTargets": "未找到可评论的文本或视觉目标。",
  "chat.inspect.editHint": "在预览中选择文本或样式目标进行编辑。",
  "chat.inspect.commentHint": "在预览中选择文本或区域进行评论。",
  "chat.composerPlaceholder": "描述你想生成的内容…",
  "chat.activeFileEditingLabel": "编辑中",
  "chat.activeFilePlaceholder": "让 OpenDesign 修改 {file}...",
  "chat.designArtifactsShowMore": "再显示 {count} 个设计文件",
  "chat.mode.chat.label": "提问",
  "chat.mode.chat.title": "Ask 模式",
  "chat.mode.chat.summary":
    "适合快速问答、修改建议、规划和讨论，不默认创建新的设计产物。",
  "chat.mode.chat.solves":
    "用来澄清想法、调试提示词、比较方案，或询问已有稿子的改进点。",
  "chat.mode.chat.query1": "总结这份稿子，并指出还缺什么。",
  "chat.mode.chat.query2": "帮我判断这个落地页应该怎么组织结构。",
  "chat.mode.chat.query3": "看一下这个设计，给我具体的改进建议。",
  "chat.mode.plan.label": "规划",
  "chat.mode.plan.title": "规划模式",
  "chat.mode.plan.summary":
    "先生成可编辑的规划文档，等你确认和修改后，再交给 Design 生成最终产物。",
  "chat.mode.plan.solves":
    "适合 PRD、PPT 大纲、原型需求、线框图、分镜脚本，以及任何需要先确认方向的大需求。",
  "chat.mode.plan.query1": "先生成一份逐页 PPT 大纲。",
  "chat.mode.plan.query2": "先写 PRD，再基于 PRD 生成原型。",
  "chat.mode.plan.query3": "把这个想法整理成可编辑的设计规划文档。",
  "chat.mode.design.label": "设计",
  "chat.mode.design.title": "设计模式",
  "chat.mode.design.summary":
    "适合创建或修改具体设计产物，比如网页、原型、实时看板、幻灯片、图片、视频、HyperFrames、音频、数据看板和项目文件。",
  "chat.mode.design.solves":
    "当你希望 OpenDesign 生成文件、更新工作区，或把需求变成多模态可交付结果时使用。",
  "chat.mode.design.query1":
    "根据这段需求做一个产品发布落地页和 HyperFrames 原型。",
  "chat.mode.design.query2": "做一份 10 页投资人 Deck，并附上讲稿备注。",
  "chat.mode.design.query3": "为这次 campaign 生成图片、视频和音频创意。",
  "chat.mode.cardBestFor": "适合解决",
  "chat.mode.cardTry": "可以这样问",
  "chat.mode.cardCost": "预计消耗",
  "chat.mode.chat.cost": "较低",
  "chat.mode.chat.costNote": "只是对话，不生成任何文件，消耗最少。",
  "chat.mode.plan.cost": "中等",
  "chat.mode.plan.costNote": "先生成一份可编辑的方案文档，再进入生成阶段。",
  "chat.mode.design.cost": "较高",
  "chat.mode.design.costNote": "会生成文件和多模态内容，单次运行消耗可能最高。",
  "chat.modePicker.choose": "选择模式",
  "chat.modePicker.current": "模式：{name}",
  "chat.modePicker.clear": "清除模式",
  "chat.modePicker.mode": "模式",
  "chat.composerHint": "⌘/Ctrl + Enter 发送 · 说清目标、内容、风格和格式",
  "chat.cliSettingsTitle": "CLI 与模型设置",
  "chat.cliSettingsAria": "打开 CLI 与模型设置",
  "chat.attachTitle": "附加文件（也可以粘贴/拖入）",
  "chat.addContextTitle": "添加内容",
  "chat.attachAria": "附加文件",
  "chat.importTitle": "导入素材（即将上线）",
  "chat.importLabel": "导入",
  "chat.importComingSoon": "即将上线",
  "chat.importSoon": "即将",
  "chat.importFig": "上传 .fig 文件",
  "chat.importGitHub": "连接 GitHub",
  "chat.importWeb": "抓取网页元素",
  "chat.importFolder": "关联代码目录",
  "chat.importSkills": "技能与设计体系",
  "chat.importProject": "引用其它项目",
  "chat.importDesignSystemHeader": "选择一个设计体系",
  "chat.importDesignSystemBack": "返回",
  "chat.importDesignSystemSearch": "搜索设计体系…",
  "chat.importDesignSystemEmpty": '没有匹配 "{query}" 的设计体系',
  "chat.importDesignSystemNone": "不指定 — 自由风格",
  "chat.importDesignSystemNoneSub": "本轮不锚定任何体系",
  "chat.importDesignSystemActive": "当前",
  "chat.importDesignSystemSwitched": "已切换设计体系为 {title}",
  "chat.importDesignSystemFailed": "切换设计体系失败，请重试。",
  "chat.importDesignSystemLoadFailed": "无法加载设计体系。",
  "browserUse.title": "灵感",
  "browserUse.summary":
    "{count} 个网页操作，优先展示素材提取、设计语言、动效、视觉校验和组件结构。",
  "browserUse.searchAria": "搜索灵感",
  "browserUse.searchPlaceholder": "搜索截图、字体、配色、a11y...",
  "browserUse.empty": "没有匹配的灵感",
  "browserUse.unavailable": "灵感暂不可用",
  "browserUse.added": "已加入输入框",
  // Design Browser
  "designBrowser.aria": "内置浏览器",
  "designBrowser.goBack": "后退",
  "designBrowser.goForward": "前进",
  "designBrowser.reload": "重新加载",
  "designBrowser.stopLoading": "停止加载",
  "designBrowser.viewportAria": "浏览器视口",
  "designBrowser.addressPlaceholder": "输入 URL 或搜索...",
  "designBrowser.addressAria": "浏览器地址",
  "designBrowser.savePageBrief": "保存页面简报",
  "designBrowser.viewport.desktop": "桌面端",
  "designBrowser.viewport.desktopTitle": "使用完整的浏览器标签页尺寸",
  "designBrowser.viewport.tablet": "平板",
  "designBrowser.viewport.tabletTitle": "以 820px 宽度预览",
  "designBrowser.viewport.mobile": "手机",
  "designBrowser.viewport.mobileTitle": "以 390px 宽度预览",
  "designBrowser.menu": "浏览器菜单",
  "designBrowser.suggestion.reference": "参考",
  "designBrowser.suggestion.history": "历史",
  "designBrowser.menu.copyScreenshot": "复制截图",
  "designBrowser.menu.hardReload": "强制刷新",
  "designBrowser.menu.copyUrl": "复制 URL",
  "designBrowser.menu.openInBrowser": "在浏览器中打开",
  "designBrowser.menu.savePageBrief": "保存页面简报",
  "designBrowser.menu.clearBrowsingHistory": "清除浏览历史",
  "designBrowser.menu.clearCookies": "清除 Cookie",
  "designBrowser.menu.clearAllData": "清除全部数据",
  "designBrowser.status.noUrlToCopy": "没有可复制的 URL",
  "designBrowser.status.urlCopied": "URL 已复制",
  "designBrowser.status.openHttpUrlFirst": "请先打开 http URL",
  "designBrowser.status.openPageBeforeScreenshot": "请先打开页面再截图",
  "designBrowser.status.screenshotCopied": "截图已复制到剪贴板",
  "designBrowser.status.screenshotSaved": "截图已保存到项目",
  "designBrowser.addImageToChatButton": "添加到对话",
  "designBrowser.status.imageAddedToChat": "图片已添加到对话",
  "designBrowser.status.screenshotFailed": "截图失败",
  "designBrowser.status.openPageBeforeBrief": "请先打开页面再保存简报",
  "designBrowser.status.briefSaveFailed": "保存简报失败",
  "designBrowser.status.desktopDataUnavailable": "当前环境无法访问桌面浏览器数据",
  "designBrowser.status.browserDataCleared": "浏览器数据已清除",
  "designBrowser.status.browserDataClearFailed": "清除浏览器数据失败",
  "designBrowser.status.historyCleared": "浏览历史已清除",
  "designBrowser.status.openPageBeforeTools": "请先打开页面再使用浏览器工具",
  "designBrowser.status.clickElementToComment": "点击页面元素添加评论",
  "designBrowser.status.clickElementToTune": "点击页面元素调参",
  "designBrowser.status.noElementSelected": "未选中浏览器元素",
  "designBrowser.status.addBrowserComment": "添加浏览器评论",
  "designBrowser.status.tuneElementThenSaveHtml": "调整元素后保存 HTML",
  "designBrowser.status.tuneLiveOnly": "非项目页面只能实时预览调参",
  "designBrowser.status.pickerFailed": "浏览器元素选择失败",
  "designBrowser.status.applyStyleFailed": "无法在浏览器页面应用样式",
  "designBrowser.status.editTextFailed": "无法在浏览器页面编辑文本",
  "designBrowser.status.onlyProjectHtmlCanSave": "只能保存项目内 HTML 页面",
  "designBrowser.status.htmlSaved": "HTML 修改已保存",
  "designBrowser.status.htmlSaveFailed": "HTML 保存失败",
  "designBrowser.status.commentSavingUnavailable": "当前无法保存评论",
  "designBrowser.status.commentSaved": "浏览器评论已保存",
  "designBrowser.status.commentSendingUnavailable": "当前无法发送评论",
  "designBrowser.comments.aria": "浏览器评论",
  "designBrowser.comments.openFor": "打开 {label} 的浏览器评论",
  "designBrowser.comment.dialog": "浏览器评论",
  "designBrowser.comment.elementFallback": "浏览器元素",
  "designBrowser.comment.close": "关闭浏览器评论",
  "designBrowser.comment.noteAria": "浏览器评论备注",
  "designBrowser.comment.placeholder": "描述需要修改或检查的问题...",
  "designBrowser.comment.addNote": "添加备注",
  "designBrowser.comment.saveComment": "保存评论",
  "designBrowser.comment.sending": "正在发送...",
  "designBrowser.comment.sendToChat": "发送到对话",
  "designBrowser.inspect.editTitle": "编辑 HTML 元素",
  "designBrowser.inspect.tuneTitle": "调整浏览器元素",
  "designBrowser.inspect.closeTune": "关闭浏览器调参",
  "designBrowser.inspect.colors": "颜色",
  "designBrowser.inspect.text": "文本",
  "designBrowser.inspect.fill": "填充",
  "designBrowser.inspect.type": "字体",
  "designBrowser.inspect.size": "字号",
  "designBrowser.inspect.weight": "字重",
  "designBrowser.inspect.spacing": "间距",
  "designBrowser.inspect.pad": "内边距",
  "designBrowser.inspect.radius": "圆角",
  "designBrowser.inspect.content": "内容",
  "designBrowser.inspect.elementText": "元素文本",
  "designBrowser.inspect.saving": "正在保存...",
  "designBrowser.inspect.saveHtml": "保存 HTML",
  "designBrowser.inspect.liveOnly": "仅实时预览",
  "designBrowser.reference.kicker": "OpenDesign 浏览器",
  "designBrowser.reference.title": "参考看板",
  "designBrowser.reference.subtitle": "精选灵感、真实产品 UI、动效、色彩、字体、素材和设计系统参考。打开任意站点即可边浏览边收集下一个产物所需的设计语言。",
  "designBrowser.reference.categoryAria": "参考分类",
  "designBrowser.reference.searchPlaceholder": "搜索参考...",
  "designBrowser.reference.searchAria": "搜索参考",
  "designBrowser.reference.clearSearch": "清除搜索",
  "designBrowser.reference.noMatches": "没有匹配“{query}”的参考。",
  "designBrowser.reference.clearFilters": "清除筛选",
  "designBrowser.reference.open": "打开",
  "designBrowser.reference.group.inspiration": "灵感",
  "designBrowser.reference.group.interfaces": "真实界面",
  "designBrowser.reference.group.motion": "动效",
  "designBrowser.reference.group.color": "色彩",
  "designBrowser.reference.group.type": "字体",
  "designBrowser.reference.group.icons": "图标",
  "designBrowser.reference.group.illustration": "插画",
  "designBrowser.reference.group.photography": "摄影",
  "designBrowser.reference.group.3d": "3D 与图形",
  "designBrowser.reference.group.mockups": "样机",
  "designBrowser.reference.group.systems": "设计系统",
  "designBrowser.reference.group.components": "组件",
  "designBrowser.reference.group.guidelines": "规范与无障碍",
  "designBrowser.reference.group.tools": "工具与资源",
  "designBrowser.reference.site.dribbble.detail": "设计作品和 UI 灵感。",
  "designBrowser.reference.site.behance.detail": "创意作品集和案例研究。",
  "designBrowser.reference.site.awwwards.detail": "获奖网站设计参考。",
  "designBrowser.reference.site.godly.detail": "现代网页设计精选。",
  "designBrowser.reference.site.land_book.detail": "落地页图库和版式模式。",
  "designBrowser.reference.site.mobbin.detail": "真实 App 界面和 UI 模式。",
  "designBrowser.reference.site.screenlane.detail": "来自 App 的最新 UI 设计模式。",
  "designBrowser.reference.site.pageflows.detail": "真实产品用户流程和引导。",
  "designBrowser.reference.site.uisources.detail": "头部 App 的交互模式。",
  "designBrowser.reference.site.collectui.detail": "按类别整理的每日 UI 集合。",
  "designBrowser.reference.site.gsap.detail": "生产级动画引擎和示例。",
  "designBrowser.reference.site.animations.detail": "动画模式和交互示例。",
  "designBrowser.reference.site.transitions.detail": "现代界面的转场模式。",
  "designBrowser.reference.site.motionsites.detail": "高品质动效和交互参考。",
  "designBrowser.reference.site.motion.detail": "滚动和时间轴动画灵感。",
  "designBrowser.reference.site.animography.detail": "动态字体和文字动效。",
  "designBrowser.reference.site.reactbits.detail": "React 闪光文字动效参考。",
  "designBrowser.reference.site.coolors.detail": "快速配色生成器。",
  "designBrowser.reference.site.colorhunt.detail": "精选配色方案。",
  "designBrowser.reference.site.realtimecolors.detail": "在真实 UI 中预览配色。",
  "designBrowser.reference.site.color_adobe.detail": "色轮和配色和谐规则。",
  "designBrowser.reference.site.happyhues.detail": "放在真实语境中的配色。",
  "designBrowser.reference.site.fonts_google.detail": "开源字体库。",
  "designBrowser.reference.site.fontshare.detail": "可商用的高质量免费字体。",
  "designBrowser.reference.site.typewolf.detail": "字体使用案例和搭配建议。",
  "designBrowser.reference.site.fontpair.detail": "字体搭配建议。",
  "designBrowser.reference.site.fontsinuse.detail": "真实设计中的字体案例。",
  "designBrowser.reference.site.thesvg.detail": "SVG 素材和矢量参考。",
  "designBrowser.reference.site.svglogos.detail": "适合产品和品牌稿的干净 SVG Logo。",
  "designBrowser.reference.site.icons_lobehub.detail": "产品和 AI 品牌界面图标。",
  "designBrowser.reference.site.icon_sets_iconify.detail": "20 万+ 开源图标集合。",
  "designBrowser.reference.site.lucide.detail": "简洁一致的开源图标集。",
  "designBrowser.reference.site.heroicons.detail": "Tailwind 出品的 SVG 图标。",
  "designBrowser.reference.site.svgrepo.detail": "免费 SVG 矢量和图标。",
  "designBrowser.reference.site.storyset.detail": "可定制矢量插画。",
  "designBrowser.reference.site.undraw.detail": "MIT 协议开源插画。",
  "designBrowser.reference.site.blush.detail": "可混搭组合的插画。",
  "designBrowser.reference.site.lummi.detail": "免费 AI 生成视觉素材。",
  "designBrowser.reference.site.whirrls.detail": "手绘风图片参考。",
  "designBrowser.reference.site.worldindots.detail": "点阵地图和数据可视化参考。",
  "designBrowser.reference.site.unsplash.detail": "免费高分辨率照片。",
  "designBrowser.reference.site.pexels.detail": "免费图库照片和视频。",
  "designBrowser.reference.site.pixabay.detail": "免版税图片和媒体素材。",
  "designBrowser.reference.site.cosmos.detail": "视觉发现和情绪板。",
  "designBrowser.reference.site.spline.detail": "浏览器中的 3D 设计工具。",
  "designBrowser.reference.site.threejs.detail": "WebGL 3D 参考和演示。",
  "designBrowser.reference.site.womp.detail": "易上手的浏览器 3D 创作。",
  "designBrowser.reference.site.pixcap.detail": "3D 图标、样机和场景。",
  "designBrowser.reference.site.shots.detail": "设备和浏览器样机。",
  "designBrowser.reference.site.mockuuups.detail": "拖拽式设备样机。",
  "designBrowser.reference.site.angle.detail": "3D 设备样机库。",
  "designBrowser.reference.site.rotato.detail": "动画 3D 产品样机。",
  "designBrowser.reference.site.impeccable.detail": "高质量风格和界面参考。",
  "designBrowser.reference.site.styles_refero.detail": "设计风格参考和视觉系统。",
  "designBrowser.reference.site.brandfetch.detail": "品牌素材、Logo 和识别资产。",
  "designBrowser.reference.site.designsystemsrepo.detail": "公开设计系统图库。",
  "designBrowser.reference.site.startups.detail": "头部创业公司的产品和品牌参考。",
  "designBrowser.reference.site.base_ui.detail": "用于自定义系统的无样式无障碍基础组件。",
  "designBrowser.reference.site.ui_shadcn.detail": "基于 Radix 和 Tailwind 的可组合 React 组件。",
  "designBrowser.reference.site.heroui.detail": "现代 React 组件库和设计系统。",
  "designBrowser.reference.site.radix_ui.detail": "无障碍低层 UI 原语。",
  "designBrowser.reference.site.react_spectrum_adobe.detail": "Adobe 出品的无障碍行为原语。",
  "designBrowser.reference.site.headlessui.detail": "面向 Tailwind 的无样式无障碍组件。",
  "designBrowser.reference.site.mui.detail": "基于 Material 的 React 组件生态。",
  "designBrowser.reference.site.mantine.detail": "功能完整的 React 组件和 Hooks。",
  "designBrowser.reference.site.chakra_ui.detail": "带主题 token 的无障碍 React 组件。",
  "designBrowser.reference.site.ant.detail": "企业级组件系统和模式。",
  "designBrowser.reference.site.ark_ui.detail": "跨现代框架的 Headless 组件。",
  "designBrowser.reference.site.daisyui.detail": "Tailwind CSS 组件类和主题。",
  "designBrowser.reference.site.developer_apple.detail": "Apple 平台设计规范。",
  "designBrowser.reference.site.m3_material.detail": "Google Material Design 3。",
  "designBrowser.reference.site.lawsofux.detail": "UX 原则和启发式规则。",
  "designBrowser.reference.site.webaim.detail": "颜色对比度检查器。",
  "designBrowser.reference.site.a11yproject.detail": "无障碍清单和模式。",
  "designBrowser.reference.site.toolfolio.detail": "设计工具、资源和集合。",
  "designBrowser.reference.site.getdesign.detail": "精选设计资源。",
  "designBrowser.reference.site.tasteskill.detail": "设计品味训练和评审参考。",
  "designBrowser.reference.site.uigoodies.detail": "手工精选设计资源。",
  "designBrowser.reference.site.sidebar.detail": "每天五条设计链接。",
  "designBrowser.reference.site.github.detail": "嵌入式浏览器工作流的参考实现。",
  "browserUse.category.assets": "素材提取",
  "browserUse.category.tokens": "设计语言",
  "browserUse.category.motion": "动效",
  "browserUse.category.visual": "视觉校验",
  "browserUse.category.structure": "组件结构",
  "browserUse.category.project": "项目运行",
  "browserUse.category.general": "通用操作",
  "browserUse.input.none": "无需输入",
  "browserUse.input.assetKind": "类型：images / svgs / media / fonts，最多 200",
  "browserUse.input.optionalSelector": "可选选择器",
  "browserUse.input.requirementSelector": "校验要求，可选选择器",
  "browserUse.input.selectorOptional": "可选选择器",
  "browserUse.input.scaleOne": "缩放 1x",
  "browserUse.input.selectorScaleTwo": "选择器，默认 2x",
  "browserUse.input.gridOverlay": "12 列，最大宽 1200，间距 24",
  "browserUse.input.bodySelector": "selector='body'",
  "browserUse.input.navigate": "URL、域名或搜索词",
  "browserUse.input.selector": "选择器",
  "browserUse.input.selectorText": "选择器和文本",
  "browserUse.input.scroll": "像素、top、bottom 或 page",
  "browserUse.input.terminalRun": "命令，超时 120 秒",
  "browserUse.input.command": "命令",
  "browserUse.input.maxChars": "最多 8000 字符",
  "browserUse.input.custom": "{input}",
  "browserUse.action.extract_logo.output":
    "从 header、nav、类名、位置、OG 图片和 favicon 中找出最可能的 Logo。",
  "browserUse.action.list_images.output":
    "枚举 img、srcset、source 和 CSS 背景图，并带尺寸和 alt。",
  "browserUse.action.download_assets.output":
    "下载素材文件夹，并生成支持 referer/cookie 的 _manifest.json。",
  "browserUse.action.extract_svgs.output":
    "提取内联 SVG 和外链 .svg，分别保存为 SVG 文件。",
  "browserUse.action.optimize_svgs.output": "输出优化后的 SVG 文件和压缩比例。",
  "browserUse.action.extract_colors.output":
    "频率加权配色板和 :root CSS 颜色变量，输出 palette.json 与 palette.html。",
  "browserUse.action.extract_fonts.output":
    "字体家族、字号、字重和 @font-face Top 列表，输出 typography.json。",
  "browserUse.action.extract_design_tokens.output":
    "圆角、阴影、间距和 CSS 变量，输出 tokens.json。",
  "browserUse.action.extract_type_scale.output":
    "标题、正文、按钮的字号阶梯、字重、行高和比例。",
  "browserUse.action.extract_buttons.output":
    "去重后的按钮样式库，输出 buttons.html 和 buttons.json。",
  "browserUse.action.extract_grid_system.output":
    "Grid/Flex 容器、方向、间距、列数和最大宽度，输出 layout.json。",
  "browserUse.action.extract_breakpoints.output":
    "响应式媒体查询断点，输出 breakpoints.json。",
  "browserUse.action.extract_gradients.output":
    "CSS 渐变，输出 gradients.css、gradients.json 和 HTML 预览。",
  "browserUse.action.extract_shadows.output":
    "box-shadow、text-shadow 和 drop-shadow，输出 shadows.json 和预览。",
  "browserUse.action.extract_easings.output":
    "过渡和动画缓动函数，输出 easings.json。",
  "browserUse.action.export_tokens.output":
    "导出 tokens.css、tokens.scss、tailwind.theme.js 和 style-dictionary.tokens.json。",
  "browserUse.action.extract_animations.output":
    "@keyframes、transition、transform 规则和动效库检测，输出 motion.css 与 motion.json。",
  "browserUse.action.validate_view.output": "截图路径和结构化视觉/布局问题。",
  "browserUse.action.audit_layout.output":
    "布局缺陷检测：溢出、越界、重叠、文字裁切，输出 audit.json。",
  "browserUse.action.audit_accessibility.output":
    "A11y 问题：选择器、标签、角色、焦点、对比度，以及必要截图。",
  "browserUse.action.responsive_screenshots.output":
    "mobile 390、tablet 834、desktop 1440 三档截图。",
  "browserUse.action.screenshot_full.output": "超出视口的整页长截图。",
  "browserUse.action.screenshot_element.output": "单元素截图，默认 2x。",
  "browserUse.action.screenshot_with_grid.output": "带布局栅格叠加的截图。",
  "browserUse.action.screenshot_dark_mode.output":
    "模拟 prefers-color-scheme: dark 后截图。",
  "browserUse.action.generate_styleguide.output":
    "一页式样式指南，包含配色、字号阶梯、圆角和阴影。",
  "browserUse.action.extract_html.output":
    "清洗后的自包含 HTML，移除 script、noscript 和内联事件属性。",
  "browserUse.action.extract_component_inventory.output":
    "重复组件模式、选择器、数量和截图。",
  "browserUse.action.extract_copy.output":
    "标题、CTA、正文和描述，输出 copy.md 与 copy.json。",
  "browserUse.action.extract_nav.output":
    "主导航和页脚链接，输出 sitemap.md 与 nav.json。",
  "browserUse.action.extract_forms.output":
    "表单字段、标签、校验提示和提交动作，输出 forms.json。",
  "browserUse.action.run_project.output":
    "识别 dev server URL 并在 Browser 标签中打开。",
  "browserUse.action.detect_project.output":
    "框架、包管理器、安装命令、dev 命令和端口。",
  "browserUse.action.page_info.output":
    "URL、标题、描述、OG 图片、主题色、favicon 和 viewport。",
  "browserUse.action.snapshot.output":
    "最多 120 个可见交互/文本元素，含 tag、label、href 和坐标。",
  "browserUse.action.navigate.output": "打开页面并返回 page_info。",
  "browserUse.action.click.output": "滚动到可见后点击第一个匹配元素。",
  "browserUse.action.type_text.output":
    "填写输入框，并触发 input/change 事件。",
  "browserUse.action.scroll.output": "当前和最大滚动位置。",
  "browserUse.action.extract_og_metadata.output":
    "Meta 标题/描述/canonical、OG/Twitter 卡片、社交图和主题色。",
  "browserUse.action.terminal_run.output": "stdout、stderr 和退出码。",
  "browserUse.action.terminal_run_background.output":
    "后台任务 id 和最近输出。",
  "browserUse.action.terminal_read.output": "共享终端最近输出。",
  "chat.designToolbox.title": "设计百宝箱",
  "chat.designToolbox.tooltip": "设计百宝箱",
  "chat.designToolbox.aria": "打开设计百宝箱",
  "chat.designToolbox.searchPlaceholder":
    "搜索 skills / MCP / plugins / connectors / design files…",
  "chat.designToolbox.searchAria": "搜索设计百宝箱资源",
  "chat.designToolbox.followupSection": "后续动作",
  "chat.designToolbox.resourcesSection": "全局资源",
  "chat.designToolbox.selected": "已选",
  "chat.designToolbox.noResources": "没有找到“{query}”相关资源。",
  "chat.designToolbox.badge.video": "视频",
  "chat.designToolbox.badge.image": "图像",
  "chat.designToolbox.badge.motion": "动效",
  "chat.designToolbox.badge.polish": "润色",
  "chat.designToolbox.action.auto-match.title": "智能匹配下一步",
  "chat.designToolbox.action.auto-match.badge": "匹配",
  "chat.designToolbox.action.auto-match.description":
    "先定义好看标准，再全局匹配 skills / MCP / plugins / connectors / files。",
  "chat.designToolbox.action.asset-search.title": "找图 / 找参考图",
  "chat.designToolbox.action.asset-search.badge": "素材",
  "chat.designToolbox.action.asset-search.description":
    "为当前设计搜索可用图片、参考截图、moodboard 和素材来源候选。",
  "chat.designToolbox.action.icon-workflow.title": "找 icon / 替换 icon",
  "chat.designToolbox.action.icon-workflow.badge": "图标",
  "chat.designToolbox.action.icon-workflow.description":
    "查找、生成或替换图标、SVG、Lucide icon 和视觉符号，并保持风格一致。",
  "chat.designToolbox.action.image-replace.title": "替换页面图片",
  "chat.designToolbox.action.image-replace.badge": "换图",
  "chat.designToolbox.action.image-replace.description":
    "审查当前配图，把薄弱的 hero、分区、背景或卡片图片替换成更合适的素材。",
  "chat.designToolbox.action.reference-extract.title": "参考图获取 / 风格提取",
  "chat.designToolbox.action.reference-extract.badge": "参考",
  "chat.designToolbox.action.reference-extract.description":
    "分析参考截图或网站，提取配色、字体、布局姿态、动效和素材方向。",
  "chat.designToolbox.action.motion.title": "加动画 / 动效",
  "chat.designToolbox.action.motion.badge": "动画",
  "chat.designToolbox.action.motion.description":
    "给当前 HTML 或页面元素加入入场、滚动、状态切换和微交互。",
  "chat.designToolbox.action.motion-polish.title": "动效润色",
  "chat.designToolbox.action.motion-polish.badge": "节奏",
  "chat.designToolbox.action.motion-polish.description":
    "检查现有动效的节奏、缓动、性能和 reduced-motion 兜底。",
  "chat.designToolbox.action.transition-motion.title": "设计过场动画",
  "chat.designToolbox.action.transition-motion.badge": "过场",
  "chat.designToolbox.action.transition-motion.description":
    "设计页面、场景、加载和状态切换过场，并补上克制节奏和 reduced-motion 兜底。",
  "chat.designToolbox.action.threejs-scene.title": "3D / Three.js 场景",
  "chat.designToolbox.action.threejs-scene.badge": "3D",
  "chat.designToolbox.action.threejs-scene.description":
    "加入或规划 Three.js、Spline、Vanta、粒子、WebGL、地图或 deck.gl 风格交互视觉。",
  "chat.designToolbox.action.anti-ai-polish.title": "反 AI 味美化",
  "chat.designToolbox.action.anti-ai-polish.badge": "去味",
  "chat.designToolbox.action.anti-ai-polish.description":
    "移除模板感、AI 紫蓝渐变、廉价卡片堆叠和空泛 copy。",
  "chat.designToolbox.action.visual-polish.title": "设计润色 / 可交付",
  "chat.designToolbox.action.visual-polish.badge": "润色",
  "chat.designToolbox.action.visual-polish.description":
    "审一次视觉层级、排版、间距、响应式、可访问性和交付状态。",
  "chat.designToolbox.action.image-gen.title": "生图 / 视觉参考",
  "chat.designToolbox.action.image-gen.badge": "生图",
  "chat.designToolbox.action.image-gen.description":
    "为当前页面生成分区视觉参考、素材、图标、社媒图或 moodboard。",
  "chat.designToolbox.action.chart-gen.title": "图表 / 图解生成",
  "chat.designToolbox.action.chart-gen.badge": "图表",
  "chat.designToolbox.action.chart-gen.description":
    "生成 ECharts、React Flow、图解、数据看板、关系图或数据可视化素材。",
  "chat.designToolbox.action.logo-gen.title": "logo / 品牌标识生成",
  "chat.designToolbox.action.logo-gen.badge": "Logo",
  "chat.designToolbox.action.logo-gen.description":
    "为当前品牌创建 logo 路线、字标、组合标、符号和身份系统生成 prompt。",
  "chat.designToolbox.action.plan-outline.title": "基于想法生成 PPT 大纲",
  "chat.designToolbox.action.plan-outline.badge": "规划",
  "chat.designToolbox.action.plan-outline.description":
    "先把粗略想法变成可编辑的 Markdown PPT 大纲，再创建幻灯片。",
  "chat.designToolbox.action.video-gen.title": "生视频 / 动画脚本",
  "chat.designToolbox.action.video-gen.badge": "视频",
  "chat.designToolbox.action.video-gen.description":
    "把设计转成短视频、Remotion / Hyperframes 分镜或可生成视频的 prompt。",
  "chat.designToolbox.kind.skill": "技能",
  "chat.designToolbox.kind.plugin": "插件",
  "chat.designToolbox.kind.mcp": "MCP",
  "chat.designToolbox.kind.mcpTemplate": "MCP 模板",
  "chat.designToolbox.kind.connector": "连接器",
  "chat.designToolbox.kind.designFile": "设计文件",
  "chat.designToolbox.context.browser": "浏览器",
  "chat.designToolbox.context.designFiles": "设计文件",
  "chat.designToolbox.context.designSystem": "设计体系",
  "chat.designToolbox.context.folder": "文件夹",
  "chat.designToolbox.context.terminal": "终端",
  "chat.designToolbox.context.sideChat": "侧边对话",
  "chat.designToolbox.context.liveArtifact": "实时看板",
  "chat.designToolbox.context.file": "文件",
  "chat.designToolbox.prompt.contextGeneric":
    "当前目标：当前打开的 HTML / 设计文件 / 网页元素。",
  "chat.designToolbox.prompt.contextSpecific": "当前目标：{kind} · {label}。",
  "chat.designToolbox.prompt.preserveDraft":
    "保留我输入框里已有的意图：{draft}",
  "chat.designToolbox.prompt.selectedSkill":
    "已选 skill：{skill}。请把它作为本轮主要工作流。",
  "chat.designToolbox.prompt.noSkill":
    "如果没有匹配到具体 skill，请先从当前可用 skills / MCP / plugins / connectors / design files 中选择最合适的组合。",
  "chat.designToolbox.prompt.autoMatchIntro":
    "请作为 Creative Director 总调度完成一套设计流程：",
  "chat.designToolbox.prompt.autoMatchStep1":
    "1. 先帮我定义“什么是好看的设计”：受众、业务目标、品牌气质、风格参考、信息密度、色彩/字体/动效/素材标准，以及不能出现的 AI 味/模板感。",
  "chat.designToolbox.prompt.autoMatchStep2":
    "2. 搜索并匹配上面的全量资源索引，不要只看设计百宝箱推荐项；需要时组合 skills、MCP、plugins、connectors 和 design files。",
  "chat.designToolbox.prompt.autoMatchStep3":
    "3. 如果目标或审美标准还不够清楚，用结构化 question-form 引导我选择，给出推荐默认项，并确保每个有限选项问题都有可编辑的自定义填写入口；如果已经足够清楚，直接执行下一步。",
  "chat.designToolbox.prompt.autoMatchStep4":
    "4. 按“诊断 -> 风格方向 -> 资源选择 -> 具体改动/生成 -> 验证”的顺序走完全程。每一步说明为什么选这些资源，以及下一步需要我确认什么。",
  "chat.designToolbox.prompt.assetSearch":
    "为当前设计寻找最合适的图片/参考素材。搜索现有文件、connectors、MCP、浏览器截图和生成工具，给出具体候选、使用方式、必要的授权/来源提醒；如果没有可用素材，给出可执行的生图 prompt。",
  "chat.designToolbox.prompt.iconWorkflow":
    "优化当前设计的 icon 系统：找出缺失图标，替换薄弱图标，保持描边/填充/圆角/线宽一致；优先使用现有图标库，库里没有合适图标时再生成 SVG/icon prompt。",
  "chat.designToolbox.prompt.imageReplace":
    "审查当前设计里的每个图片位，找出占位感或质量弱的配图，然后替换或指定更好的 hero、分区、背景、卡片和社媒图。保持布局不乱，并给出明确文件/prompt/来源选择。",
  "chat.designToolbox.prompt.referenceExtract":
    "把当前参考图/参考网站/design file 当作视觉输入，提取配色、字号阶梯、布局节奏、组件姿态、动效线索和素材风格，再应用到当前设计；不要逐字复制受保护的品牌资产。",
  "chat.designToolbox.prompt.motion":
    "请基于当前 HTML / 页面元素加入高质量动效：入场、滚动、状态切换、过场、Rive/Lottie 风格图标动效或 GSAP/Motion 微交互任选最有效的 1-2 处。保持克制，优先 transform / opacity，并加 prefers-reduced-motion 兜底。",
  "chat.designToolbox.prompt.planOutline":
    "基于这个想法创建或更新一份 Markdown PPT/Deck 规划文档。暂时不要生成最终 PPT。请包含逐页标题、页面目标、内容要点、视觉方向、所需数据/素材和开放问题。把它保存为 Design Files 里的 `.md` 文件，并告诉我需要 review 哪个文件。",
  "chat.designToolbox.prompt.motionPolish":
    "请审查并润色现有动效的节奏、缓动、性能和可访问性。修掉突兀、廉价或影响阅读的动画；必要时改成更细腻的时间线。",
  "chat.designToolbox.prompt.transitionMotion":
    "为当前设计规划高质量过场动画：页面/场景切换、加载承接、状态变化和分区衔接。需要时使用 GSAP/Motion/CSS，保持性能和克制节奏，并提供 reduced-motion 行为。",
  "chat.designToolbox.prompt.threejsScene":
    "为当前设计规划或实现一个聚焦的 Three.js/WebGL 视觉。可考虑 Three.js、Spline 风格场景、Vanta 背景、粒子系统、Mapbox/deck.gl 数据层或浏览器 Portal 效果，但必须有用并验证可渲染。",
  "chat.designToolbox.prompt.antiAiPolish":
    "请做一次反 AI 味美化：移除模板化布局、廉价渐变/光晕、无意义卡片堆叠和空泛文案；保持信息不丢失，直接改到更像真实设计师交付。",
  "chat.designToolbox.prompt.visualPolish":
    "请把这个设计打磨到可交付：检查视觉层级、排版、间距、响应式、按钮状态、空/加载/错误状态和可访问性，并直接完成最重要的修正。",
  "chat.designToolbox.prompt.imageGen":
    "请为当前设计生成下一步视觉资产方案：可以是分区参考图、hero 素材、插画、icon、社媒图或 moodboard。先判断最缺哪类图，再给可执行的生成 prompt / 文件计划。",
  "chat.designToolbox.prompt.chartGen":
    "为当前设计生成最合适的图表、图解或数据可视化。根据数据和用户目标，在 ECharts、React Flow、SVG/CSS 图解、雷达图、关系图、看板或 deck.gl/地图可视化之间选择。",
  "chat.designToolbox.prompt.logoGen":
    "为当前品牌创建 logo 和身份方向。输出多条字标、符号、组合标、配色、使用规则和生成 prompt 路线；确保结果原创，并能落到当前 artifact 里。",
  "chat.designToolbox.prompt.videoGen":
    "请把当前设计转成视频方向：生成短视频分镜、Hyperframes / Remotion 帧结构或 Sora/fal 可用 prompt。优先让现有 HTML / 页面内容自然变成镜头。",
  "chat.designToolbox.prompt.useSkill": "使用 {skill} 处理当前设计。",
  "chat.designToolbox.prompt.skillInstruction":
    "请先判断最合适的加工目标，再直接完成一轮具体改动；如果它依赖外部素材或 API，请给出可运行的替代方案或明确需要我补充什么。",
  "chat.designToolbox.prompt.selectedResource":
    "已选资源：{kind} · {title}（{id}）。",
  "chat.designToolbox.prompt.resourceDescription": "资源说明：{description}",
  "chat.designToolbox.prompt.pluginResource":
    "请把这个 plugin 当作当前设计流程的主要上下文。如果它暴露输入项或 GenUI，请在需要时引导我选择；如果不适合当前目标，请改选更合适的全局资源并说明原因。",
  "chat.designToolbox.prompt.mcpResource":
    "请优先使用这个 MCP 能力完成当前设计下一步。需要外部素材、网页截图、图像/视频生成或数据时，先判断它能否完成，再给出可执行计划。",
  "chat.designToolbox.prompt.mcpTemplateResource":
    "这个 MCP 是可配置模板。如果它是完成当前设计最需要的工具，请先引导我完成配置；如果已有替代资源可用，请先用替代资源继续。",
  "chat.designToolbox.prompt.connectorResource":
    "请在需要真实数据、素材、账号内容或外部工作流时使用这个 connector；使用前先说明会读取/写入什么，必要时让我确认。",
  "chat.designToolbox.prompt.fileResource":
    "请把这个 design file 作为当前设计对象或参考资产，基于它完成下一步加工；如果需要同时比较其他文件，请从全量 design files 中继续搜索。",
  "chat.designToolbox.prompt.resourceIndex":
    "全局资源索引：skills({skills})、plugins({plugins})、MCP({mcpEnabled} enabled / {mcpTemplates} templates)、connectors({connectors} connected)、design files({files})。",
  "chat.designToolbox.prompt.searchableSkills": "可搜索 skills",
  "chat.designToolbox.prompt.searchablePlugins": "可搜索 plugins",
  "chat.designToolbox.prompt.availableMcp": "可用 MCP",
  "chat.designToolbox.prompt.connectedConnectors": "已连接 connectors",
  "chat.designToolbox.prompt.referenceDesignFiles": "可参考 design files",
  "chat.designToolbox.prompt.mcpTemplateName": "{name} template",
  "chat.designToolbox.prompt.processRule":
    "流程规则：先定义审美目标和约束，再搜索/匹配资源；需要用户选择时生成结构化 question-form，并为有限选项保留可编辑的自定义答案，确认后继续执行。",
  "chat.designToolbox.prompt.moreSuffix": "，+{count} more",
  "chat.designToolbox.prompt.compactLine": "{label}：{values}{suffix}。",
  "chat.mentionTabsAria": "提及来源",
  "chat.mentionTabAll": "全部",
  "chat.mentionTabTabs": "标签页",
  "chat.mentionTabPlugins": "插件",
  "chat.mentionTabSkills": "技能",
  "chat.mentionTabMcp": "MCP",
  "chat.mentionTabConnectors": "连接器",
  "chat.mentionTabFiles": "设计文件",
  "chat.mentionNoResults": "没有找到“{query}”的结果。",
  "chat.mentionSearchPrompt":
    "搜索设计文件、标签页、插件、技能、MCP 服务器和连接器。",
  "chat.mentionSectionTabs": "标签页",
  "chat.mentionSectionPlugins": "插件",
  "chat.mentionSectionSkills": "技能",
  "chat.mentionSectionMcp": "MCP",
  "chat.mentionSectionConnectors": "连接器",
  "chat.mentionSectionFiles": "设计文件",
  "chat.mentionActiveSkill": "已启用",
  "chat.mentionUseMcpTitle": "使用 {name}",
  "chat.mentionUseConnectorTitle": "使用 {name}",
  "chat.mentionPluginOfficial": "官方",
  "chat.mentionPluginMine": "我的插件",
  "chat.linkedFolderRemoveAria": "移除关联文件夹 {path}",
  "chat.linkedFolderNotFound": "文件夹不存在",
  "chat.linkedFolderAlready": "该文件夹已关联",
  "chat.linkedFolderPickError": "无法打开文件夹选择器",
  "chat.queuedEditQueuedTaskAria": "编辑排队任务",
  "chat.queuedSave": "保存",
  "chat.queuedCancel": "取消",
  "chat.queuedReorder": "拖动调整顺序",
  "chat.queuedEdit": "编辑",
  "chat.queuedHeader": "已排队",
  "chat.queuedSteer": "引导对话",
  "chat.queuedSteerInterrupts": "引导对话:会中断当前运行",
  "chat.queuedSteerUnsupported": "当前 agent 不支持中途引导",
  "chat.queuedSteerClosed": "这一轮已经停止接收消息",
  "chat.queuedSteerFailed": "引导对话失败",
  "chat.queuedSteerTextOnly": "正在跑的这一轮只接得住纯文字,这条带了附件,请单独发",
  "chat.queuedFollowUpFallback": "已排队的后续任务",
  "chat.send": "发送",
  "chat.stop": "停止",
  "chat.removeAria": "移除 {name}",
  "chat.example1Title": "编辑风路演 PPT",
  "chat.example1Tag": "杂志",
  "chat.example1Prompt":
    "为一家正在融种子轮的设计工作室制作 10 张编辑风路演 PPT —— 瑞士网格布局，超大号衬线标题加粗体首字下沉，等宽字体的章节编号，留白充足，整页大图与文字密集页穿插出现。封面、愿景、市场、产品、增长、团队、融资诉求、联系方式。",
  "chat.example2Title": "SaaS 分析仪表盘",
  "chat.example2Tag": "数据",
  "chat.example2Prompt":
    "为一款面向开发者的 SaaS 设计一份信息密度高的分析仪表盘 —— 顶部 KPI 条带（含周环比变化）、两张堆叠折线图（MRR 与活跃工作区）、全球使用热力图、留存矩阵、客户排行榜以及实时事件流。深色主题，等宽数字，迷你图作为点缀。",
  "chat.example3Title": "长滚动年度报告",
  "chat.example3Tag": "编辑",
  "chat.example3Prompt":
    "为一家关注气候议题的非营利机构制作互动式年度报告 —— 长滚动编辑式布局，混合大段引言区块、数据可视化（堆叠柱状图、动态计数器、项目地点分布的等值线地图）、摄影分隔页、捐赠者墙，以及最终行动号召。现代衬线正文、无衬线图表标签、大地纸张配色。",
  'home.recommendation.eyebrow': '为你推荐',
  'home.recommendation.primaryCta': '开始创作',
  'home.recommendation.change': '换一换',
  'home.recommendation.browseAll': '全部类型',
  'home.recommendation.defaultProjectName': '新建项目',
  'home.recommendation.startFailed': '无法开始创建，请重试。',
  'studio.firstArtifactHint.title': '你的第一个设计已就绪',
  'studio.firstArtifactHint.body': '试试直接编辑和标注，满意后随时导出分享。',
  'studio.firstArtifactHint.dismiss': '知道了',
  'home.starter.product_ui_prototype.title': '从可编辑的产品原型开始',
  'home.starter.product_ui_prototype.desc': '基于你的目标，从一个可点击、可反复打磨的界面开始。',
  'home.starter.product_ui_prototype.firstPrompt': '为 [你的产品] 设计一个可编辑的产品原型，包含关键页面和清晰的核心流程。',
  'home.starter.product_ui_component.title': '从可复用组件开始',
  'home.starter.product_ui_component.desc': '先做一个组件，再把它组合成完整页面。',
  'home.starter.product_ui_component.firstPrompt': '设计一个可复用的 [组件名称] 组件，包含它的主要状态和变体。',
  'home.starter.product_ui_lowfi.title': '从低保真原型开始',
  'home.starter.product_ui_lowfi.desc': '先勾勒结构，再逐步提升保真度。',
  'home.starter.product_ui_lowfi.firstPrompt': '为 [你的产品] 制作主要页面的低保真线框图。',
  'home.starter.marketing_landing.title': '从落地页开始',
  'home.starter.marketing_landing.desc': '把你的营销活动变成一个可直接上线的落地页。',
  'home.starter.marketing_landing.firstPrompt': '为 [你的产品] 设计一个落地页，包含主视觉、核心卖点和清晰的行动号召。',
  'home.starter.marketing_multivariant.title': '从多个落地页版本开始',
  'home.starter.marketing_multivariant.desc': '在确定方案前，先生成几个版本进行对比。',
  'home.starter.marketing_multivariant.firstPrompt': '为 [你的产品] 制作 3 个落地页版本，采用不同的主视觉文案以便对比。',
  'home.starter.internal_dashboard.title': '从内部仪表盘开始',
  'home.starter.internal_dashboard.desc': '从贴合你工作流程的仪表盘布局开始。',
  'home.starter.internal_dashboard.firstPrompt': '设计一个内部仪表盘，展示 [关键指标]，并配有筛选器和数据表格。',
  'home.starter.internal_report.title': '从报表开始',
  'home.starter.internal_report.desc': '描述你想看到的数据和字段。',
  'home.starter.internal_report.firstPrompt': '制作一个报表页面，汇总 [描述你关心的数据、字段和指标]。',
  'home.starter.general_menu.title': '从你的第一个项目开始',
  'home.starter.general_menu.desc': '描述你想要的内容，我们会生成一个可编辑的初始版本。',
  'home.starter.general_menu.firstPrompt': '为 [描述你想制作的内容] 生成一个可编辑的初始版本。',
  "chat.example4Title": "产品动效视频",
  "chat.example4Tag": "视频",
  "chat.example4Prompt":
    "为一款生产力 App 发布制作 15 秒动效视频分镜：开场钩子、UI 局部特写、动态排版、功能转场、结尾 logo 和 CTA。请写清时间轴、镜头描述、转场方式、画面文案和节奏感。",
  "preview.usePlugin": "使用插件",
  "preview.usePluginOnly": "不带提示词使用",
  "preview.usePluginOnlyDesc": "使用插件结构，但不加载示例提示词",
  "preview.replicateContent": "使用",
  "preview.replicateContentDesc": "使用示例提示词复现预览",
  "preview.duplicateTemplate": "Remix",
  "preview.duplicateTemplateDesc": "将这个示例 Remix 成可编辑的新项目",
  "preview.shareMenu": "分享",
  "preview.exportMenu": "导出",
  "preview.shareTemplateBadge": "模板",
  "preview.shareToX": "X / Twitter",
  "preview.shareToReddit": "Reddit",
  "preview.shareToFacebook": "Facebook",
  "preview.shareToLinkedIn": "LinkedIn",
  "preview.shareToInstagram": "Instagram",
  "preview.shareToXiaohongshu": "小红书",
  "preview.copyTemplateLink": "复制模板链接",
  "preview.copyShareText": "复制分享文案",
  "preview.shareSocialGroup": "分享到社媒",
  "preview.shareCopyGroup": "复制",
  "preview.shareExportGroup": "导出文件",
  "preview.shareCopied": "已复制",
  "preview.shareCopyFailed": "复制失败",
  "preview.shareTextDefault": "OpenDesign 模板：{title}",
  "preview.openInNewTab": "在新标签页中打开",
  "preview.exit": "⤓ 退出",
  "preview.fullscreen": "⤢ 全屏",
  "preview.closeTitle": "关闭（Esc）",
  "preview.loading": "正在加载{label}…",
  "preview.errorTitle": "无法加载此示例。",
  "preview.errorBody":
    "示例 HTML 加载失败。请确认 OpenDesign 正在运行后重试。",
  "preview.retry": "重试",
  "preview.unavailableTitle": "{noun}暂未附带预览样例。",
  "preview.unavailableBody": "请在对话中运行此 Prompt 来生成 {kind} 产物。",
  "preview.nounSkill": "此技能",
  "preview.nounPlugin": "此插件",
  "preview.nounTemplate": "此模板",
  "preview.showSidebar": "展开{label}",
  "preview.hideSidebar": "收起{label}",
  "misc.savedTemplate": "已保存的模板",
  "misc.primary": "主体系",
  "misc.designSystem": "设计体系",
  "workspace.designFiles": "设计文件",
  "workspace.focusMode": "专注工作区",
  "workspace.showChat": "显示聊天",
  "workspace.closeTab": "关闭标签页",
  "workspace.fileSyncDownloading": "正在从团队下载…",
  "workspace.fileSyncUploading": "正在同步到团队…",
  "workspace.deleteFileConfirm": "从项目文件夹中删除「{name}」？",
  "workspace.readonlyNotice": "这是共享项目，你可以查看和评论，但不能通过 Chat 或编辑工具修改 Artifact。",
  "workspace.readonlyNoticeBy": "这是 {owner} 创建的共享项目，你可以查看和评论，但不能通过 Chat 或编辑工具修改 Artifact。",
  "workspace.deleteSelectedFilesConfirm":
    "从项目文件夹中删除选中的 {n} 个文件？",
  "workspace.deleteSelectedFilesPartial": "有 {n} 个文件删除失败。",
  "workspace.openFromDesignFiles": "请从",
  "workspace.designFilesLink": "设计文件",
  "workspace.loadingSketch": "正在加载草图…",
  "workspace.newTab": "新建标签页",
  "workspace.searchFilesPlaceholder": "搜索标签页或文件…",
  "workspace.openTabs": "打开标签页",
  "workspace.searchTabs": "搜索标签页",
  "workspace.noTabsFound": "没有匹配的标签页",
  "workspace.openFile": "打开文件",
  "workspace.noFilesMatch": "没有匹配的文件",
  "workspace.allFiles": "全部",
  "workspace.createNew": "新建",
  "workspace.tabOpen": "已打开",
  "workspace.sideChatContextBanner": "已集成当前会话上下文",
  "workspace.sideChatDefaultTitle": "侧边对话",
  "workspace.newTerminal": "新建终端",
  "workspace.newTerminalDescription": "在新标签页中打开项目目录的终端",
  "workspace.newBrowser": "新建浏览器",
  "workspace.newBrowserDescription":
    "在新标签页中打开内置浏览器，用于参考站点和设计研究",
  "workspace.newSketchDescription":
    "绘制粗略布局和标注，作为 agent 的设计上下文",
  "workspace.terminalStarting": "正在启动项目终端…",
  "workspace.terminalStartingDescription": "正在连接项目目录，通常只需几秒。",
  "workspace.terminalSessionEnded": "会话已结束",
  "workspace.terminalReconnecting": "正在重新连接…",
  "workspace.terminalStartFailed": "无法启动终端会话",
  "workspace.terminalRestart": "重新启动",
  "designFiles.title": "设计文件",
  "designFiles.upload": "上传文件",
  "designFiles.pasteText": "粘贴为文本文件",
  "designFiles.newSketch": "新建草图",
  "designFiles.newDocument": "新建文档",
  "designFiles.newDocumentTitle": "新建一份 Markdown 文档",
  "designFiles.empty": "生成的设计会出现在这里",
  "designFiles.buildingPreview": "全屏预览",
  "designFiles.syncing": "正在同步团队共享的文件…",
  "designFiles.refresh": "刷新",
  "designFiles.delete": "删除",
  "designFiles.searchPlaceholder": "搜索文件…",
  "designFiles.up": "上一级",
  "designFiles.back": "返回",
  "designFiles.crumbs": "项目",
  "designFiles.rowMenu": "行菜单",
  "designFiles.openInTab": "在标签页中打开",
  "designFiles.download": "下载",
  "designFiles.downloadSelected": "下载选中的 {n} 个文件为 ZIP",
  "designFiles.deleteSelected": "删除 {n} 个",
  "designFiles.clearSelection": "取消选择",
  "designFiles.selectPage": "全选此页",
  "designFiles.selectAll": "全选",
  "designFiles.dropTitle": "⤓ 把文件拖到这里",
  "designFiles.dropDesc":
    "图片、文档、参考资料或文件夹 — 智能体都会用作上下文。",
  "designFiles.dropLabel": "拖拽文件到这里",
  "designFiles.upload.title": "上传文件",
  "designFiles.paste.title": "将文本粘贴为文件",
  "designFiles.upload.label": "上传",
  "designFiles.paste.label": "粘贴",
  "designFiles.documentTemplate.titleFallback": "文档",
  "designFiles.documentTemplate.goalHeading": "目标",
  "designFiles.documentTemplate.goalBody":
    "说明希望 OpenDesign 基于这份文档生成、修改或判断什么。",
  "designFiles.documentTemplate.capabilitiesHeading": "如何使用这份文档",
  "designFiles.documentTemplate.capabilityMarkdown":
    "可以自由使用 Markdown：标题、表格、清单、链接、引用、代码块和图片。",
  "designFiles.documentTemplate.capabilityAgent":
    "OpenDesign agent 可以读取、编辑这份文件，并把它作为项目上下文。",
  "designFiles.documentTemplate.capabilityImages":
    "可以粘贴图片，或把图片拖到编辑器里；上传后的图片会插入到当前光标位置。",
  "designFiles.documentTemplate.scenarioHeading": "场景说明",
  "designFiles.documentTemplate.scenario.prototype":
    "做原型时，写清楚产品目标、目标用户、流程、页面、模块、交互状态、响应式断点，以及颜色、字体、间距、圆角、动效等 design tokens。",
  "designFiles.documentTemplate.scenario.wireframe":
    "做线框图时，描述用户流程、页面清单、布局层级、内容区块、低保真约束，以及视觉设计前需要验证的问题。",
  "designFiles.documentTemplate.scenario.mobile":
    "做移动应用时，列出目标平台、页面、导航模型、手势、原生模式、设备尺寸、状态和移动端 design tokens。",
  "designFiles.documentTemplate.scenario.slideDeck":
    "做幻灯片时，写成分页 PPT 大纲：每页包含标题、目的、核心信息、证据、视觉方向、讲稿备注和导出要求。",
  "designFiles.documentTemplate.scenario.document":
    "做文档时，定义受众、语气、章节结构、资料来源、引用或数据、版式预期和 PDF/导出要求。",
  "designFiles.documentTemplate.scenario.image":
    "做图片时，说明主体、比例、构图、视觉风格、品牌 tokens、参考文件和负向约束。",
  "designFiles.documentTemplate.scenario.video":
    "做视频时，写出分镜：场景、时长、字幕、动效、素材、音频备注和输出格式。",
  "designFiles.documentTemplate.scenario.hyperframes":
    "做 HyperFrames 时，描述 HTML 动态内容：场景、时间线、字幕、音频响应点、转场和录制/导出要求。",
  "designFiles.documentTemplate.scenario.audio":
    "做音频时，定义人声或音乐方向、时长、情绪、脚本或文案、节奏、发音备注和最终用途。",
  "designFiles.documentTemplate.scenario.liveArtifact":
    "做实时看板时，说明数据源、刷新频率、组件、筛选、交互、空/加载/错误状态，以及提醒或自动化要求。",
  "designFiles.documentTemplate.scenario.designSystem":
    "做设计系统时，列出品牌目标、tokens、字体、颜色、间距、组件、素材、参考和需要遵守/避免的规则。",
  "designFiles.documentTemplate.scenario.default":
    "描述受众、交付物、必需内容、参考、约束，以及什么状态算完成。",
  "designFiles.documentTemplate.nextHeading": "下一步",
  "designFiles.documentTemplate.nextBody":
    "检查并编辑这份文档，然后让 OpenDesign 基于它生成、修改或执行操作。",
  "designFiles.previewOpen": "打开",
  "designFiles.previewClose": "关闭预览",
  "designFiles.modified": "修改于 {time} · {size}",
  "designFiles.weeksAgo": "{n} 周前",
  "designFiles.groupBy": "分组方式",
  "designFiles.groupByKind": "类型",
  "designFiles.groupByModified": "修改时间",
  "designFiles.filterBy": "按类型筛选",
  "designFiles.filterClear": "清除",
  "designFiles.filterCount": "{n} 种类型",
  "designFiles.expandGroup": "展开",
  "designFiles.collapseGroup": "折叠",
  "designFiles.sectionPages": "页面",
  "designFiles.sectionScripts": "脚本",
  "designFiles.sectionImages": "图片",
  "designFiles.sectionSketches": "草图",
  "designFiles.sectionLiveArtifacts": "实时看板",
  "designFiles.sectionOther": "其它",
  "designFiles.modifiedToday": "今天",
  "designFiles.modifiedYesterday": "昨天",
  "designFiles.modifiedPrevious7Days": "最近 7 天",
  "designFiles.modifiedPrevious30Days": "最近 30 天",
  "designFiles.modifiedOlder": "更早",
  "designFiles.showMore": "再显示 {n} 个",
  "designFiles.kindHtml": "HTML 页面",
  "designFiles.kindImage": "图片",
  "designFiles.kindSketch": "草图",
  "designFiles.kindText": "文本",
  "designFiles.kindCode": "脚本",
  "designFiles.kindPdf": "PDF",
  "designFiles.kindDocument": "文档",
  "designFiles.kindPresentation": "演示文稿",
  "designFiles.kindSpreadsheet": "电子表格",
  "designFiles.kindLiveArtifact": "实时看板",
  "designFiles.kindBinary": "二进制",
  "designFiles.kindFolder": "文件夹",
  "designFiles.folderCount": "{n} 个文件",
  "designFiles.newFolderTitle": "新建文件夹",
  "designFiles.newFolderLabel": "文件夹名称",
  "designFiles.moveTitle": "移动到文件夹",
  "designFiles.moveLabel": "目标文件夹",
  "designFiles.moveRoot": "项目根目录",
  "designFiles.moveNewFolder": "新建文件夹…",
  "designFiles.move": "移动",
  "designFiles.copyPath": "复制文件地址",
  "designFiles.copiedPath": "已复制路径",
  "designFiles.copyLocalPath": "复制本地文件路径",
  "designFiles.copiedLocalPath": "已复制本地文件路径",
  "designFiles.deleteFolderConfirm": "删除文件夹「{name}」及其全部内容?",
  "designFiles.folderCreated": "已创建文件夹「{name}」",
  "designFiles.folderDeleted": "已删除文件夹「{name}」",
  "designFiles.filesMoved": "已移动 {n} 项到 {dest}",
  "designFiles.colName": "名称",
  "designFiles.colKind": "类型",
  "designFiles.colModified": "修改时间",
  "designFiles.perPage": "显示",
  "designFiles.all": "全部",
  "designFiles.prev": "上一页",
  "designFiles.next": "下一页",
  "designFiles.jumpToPage": "跳转到页面",
  "designFiles.pageInfo": "{start}–{end} / {total}",
  "designFiles.sectionFolders": "文件夹",
  "designFiles.sectionStylesheets": "样式表",
  "designFiles.sectionDocuments": "文档",
  "designFiles.kindStylesheet": "样式表",
  "designFiles.modifiedExt": "修改于 {time} · {size} · {ext}",
  "designFiles.usefulInfoLabel": "使用提示",
  "designFiles.usefulInfoTip": "双击任意文件可在独立标签页中打开。",
  "designFiles.usefulInfoTip2": "在聊天中输入 @ 即可把文件引用为上下文。",
  "designFiles.usefulInfoTip4":
    "选好设计系统再生成，结果会与品牌风格保持一致。",
  "designFiles.usefulInfoTip5":
    "没有想法？试试首页 Community 的插件模板，一键生成同款。",
  "designFiles.usefulInfoTip6": "遇到问题或有建议？加入 Discord 和我们聊聊。",
  "designFiles.usefulInfoTip7": "觉得好用？在 GitHub 给我们点个 Star。",
  "designFiles.usefulInfoTip8":
    "在 X 上关注 @OpenDesignHQ，第一时间了解新功能。",
  "designFiles.usefulInfoTip9":
    "把图片、文档甚至整个文件夹拖到当前面板，智能体都会用作上下文。",
  "designFiles.usefulInfoTip10":
    "点「新建草图」手绘一个布局，让智能体照着生成。",
  "designFiles.usefulInfoTip11":
    "在预览中圈选任意元素发表评论，智能体会针对性修改。",
  "designFiles.usefulInfoTip12": "生成结果不满意？直接圈选标注比重新描述更快。",
  "designFiles.usefulInfoTip13": "设计可以一键导出为 PDF、图片或独立 HTML。",
  "designFiles.usefulInfoTip14":
    "满意的项目可通过「分享」菜单保存为模板，下次直接复用。",
  "designFiles.usefulInfoTip15": "部署后可以直接生成社媒分享卡片。",
  "designFiles.usefulInfoTip16":
    "在 Threads 上关注 @opendesign.ai，看团队幕后动态。",
  "designFiles.usefulInfoTip17":
    "在 Instagram 上关注 @opendesign.ai，获取设计灵感。",
  "designFiles.usefulInfoTip18":
    "在 YouTube 上订阅 OpenDesign，观看教程和演示。",
  "designFiles.usefulInfoTip19":
    "在 LinkedIn 上关注 OpenDesign，了解产品动态。",
  "designFiles.usefulInfoTip20":
    "在小红书上关注 OpenDesign，获取技巧和灵感。",
  "quickSwitcher.placeholder": "打开标签页或文件…",
  "quickSwitcher.empty": "此项目中没有文件",
  "quickSwitcher.noMatches": "无匹配项",
  "quickSwitcher.navigate": "导航",
  "quickSwitcher.open": "打开",
  "quickSwitcher.close": "关闭",
  "sketch.save": "保存草图",
  "sketch.cancel": "取消",
  "sketch.saving": "保存中…",
  "sketch.saved": "已保存",
  "sketch.tooltipMainMenu": "主菜单：保存、导出、帮助和画布设置",
  "sketch.tooltipLock": "锁定当前工具，连续绘制同一种元素",
  "sketch.tooltipHand": "抓手工具：拖动画布视图，不选择元素",
  "sketch.tooltipSelection": "选择工具：选中、移动、缩放或编辑画布元素",
  "sketch.tooltipRectangle": "矩形工具：绘制矩形或卡片区域",
  "sketch.tooltipDiamond": "菱形工具：绘制判断节点或分支结构",
  "sketch.tooltipEllipse": "椭圆工具：绘制圆形或椭圆",
  "sketch.tooltipArrow": "箭头工具：绘制方向关系或流程连接",
  "sketch.tooltipLine": "直线工具：绘制分隔线或简单连接线",
  "sketch.tooltipFreedraw": "手绘工具：自由绘制线条",
  "sketch.tooltipText": "文本工具：在画布上添加可编辑文字",
  "sketch.tooltipImage": "图片工具：插入图片素材",
  "sketch.tooltipEraser": "橡皮擦：删除画布上的元素",
  "sketch.tooltipFrame": "框架工具：把一块画布区域组织成框架",
  "sketch.tooltipEmbeddable": "Web 嵌入仅支持有效的 https:// 或 http:// 链接",
  "sketch.tooltipLaser": "激光笔：临时指示画布内容，不修改元素",
  "sketch.tooltipMoreTools": "更多工具：打开框架、Web 嵌入、激光笔等工具",
  "sketch.tooltipDirty": "尚未保存",
  "sketch.tooltipClean": "已保存",
  "fileViewer.empty": "请选择一个文件查看。",
  "fileViewer.loading": "加载中…",
  "fileViewer.exportPptx": "导出为 PPTX",
  "fileViewer.openInNewTab": "在新标签页中打开",
  "fileViewer.copyPath": "复制路径",
  "fileViewer.copied": "已复制！",
  "fileViewer.share": "分享",
  "fileViewer.binaryMeta": "二进制 · {size}",
  "fileViewer.binaryNote":
    "二进制文件（{size} 字节）。请下载或在本地打开查看。",
  "fileViewer.pdfMeta": "PDF · {size}",
  "fileViewer.documentMeta": "文档",
  "fileViewer.presentationMeta": "演示文稿",
  "fileViewer.spreadsheetMeta": "电子表格",
  "fileViewer.previewUnavailable": "无法生成预览，请下载或打开文件查看。",
  "fileViewer.download": "下载",
  "fileViewer.open": "打开",
  "fileViewer.imageMeta": "图片 · {size}",
  "fileViewer.reactMeta": "React 组件 · {size}",
  "fileViewer.sketchMeta": "草图 · {size}",
  "fileViewer.markdownStreamingMeta": "正在流式预览…",
  "fileViewer.markdownErrorMeta": "预览可能不完整（生成错误）。",
  "fileViewer.markdownStreamingStatus": "正在流式生成…显示部分 Markdown。",
  "fileViewer.markdownErrorStatus": "生成错误。正在显示最后可用内容。",
  "fileViewer.markdownSaving": "保存中...",
  "fileViewer.markdownSaveFailed": "保存失败",
  "fileViewer.markdownSaved": "已保存",
  "fileViewer.markdownAutoSaved": "已自动保存 · {time}",
  "fileViewer.markdownAutoSaveHint": "自动保存已开启",
  "fileViewer.markdownViewMode": "Markdown 视图模式",
  "fileViewer.split": "分栏",
  "fileViewer.markdownEditor": "Markdown 编辑器",
  "fileViewer.markdownEditorPlaceholder": "输入这份文档的备注、需求或说明...",
  "fileViewer.markdownPreview": "Markdown 预览",
  "fileViewer.videoMeta": "视频 · {size}",
  "fileViewer.audioMeta": "音频 · {size}",
  "fileViewer.reload": "重新加载",
  "fileViewer.reloadDisk": "从磁盘重新加载",
  "fileViewer.copy": "复制",
  "fileViewer.copyTitle": "复制文件内容",
  "fileViewer.saveDisabled": "保存（只读预览）",
  "fileViewer.save": "保存",
  "fileViewer.preview": "预览",
  "fileViewer.source": "代码",
  "fileViewer.tweaks": "调整",
  "fileViewer.tweaksUnavailable": "此作品中没有调整面板",
  "fileViewer.jsxModuleTitle": "无独立预览",
  "fileViewer.jsxModuleBody": "此文件是由其他页面加载的组件模块。",
  "fileViewer.jsxModuleCta": "请打开渲染它的页面：",
  "fileViewer.comment": "注释",
  "fileViewer.edit": "编辑",
  "fileViewer.draw": "绘制",
  "fileViewer.mark": "标记",
  "fileViewer.markTool": "标记工具",
  "fileViewer.boxSelect": "框选",
  "fileViewer.textTool": "文本",
  "fileViewer.textAnnotationRemove": "删除文本",
  "fileViewer.screenshot": "截图",
  "manualEdit.layers": "图层",
  "manualEdit.editableCount": "{count} 个可编辑元素",
  "manualEdit.hiddenBadge": "隐藏",
  "manualEdit.title": "手动编辑器",
  "manualEdit.fallbackTitle": "编辑",
  "manualEdit.movePanel": "移动编辑面板",
  "manualEdit.editParams": "编辑参数",
  "manualEdit.closePanel": "关闭编辑面板",
  "manualEdit.selectLayer": "选择图层",
  "manualEdit.empty": "在预览中点击元素,或选择一个图层。",
  "manualEdit.noEditableLayers": "未找到可编辑图层。",
  "manualEdit.noClass": "无类名",
  "manualEdit.tabsAria": "手动编辑选项卡",
  "manualEdit.tabContent": "内容",
  "manualEdit.tabStyle": "样式",
  "manualEdit.tabAttributes": "属性",
  "manualEdit.tabHtml": "HTML",
  "manualEdit.tabSource": "源码",
  "manualEdit.attributesJson": "属性 JSON",
  "manualEdit.selectedHtml": "选中元素的 HTML",
  "manualEdit.fullSource": "完整作品源码",
  "manualEdit.applyContent": "应用内容",
  "manualEdit.applyStyle": "应用样式",
  "manualEdit.applyAttributes": "应用属性",
  "manualEdit.applyHtml": "应用 HTML",
  "manualEdit.applySource": "应用源码",
  "manualEdit.invalidAttributes": "属性 JSON 格式无效。",
  "manualEdit.changes": "修改记录",
  "manualEdit.undo": "撤销",
  "manualEdit.redo": "重做",
  "manualEdit.noChanges": "尚未进行手动修改。",
  "manualEdit.imageUrl": "图片 URL",
  "manualEdit.altText": "替代文本",
  "manualEdit.label": "标签",
  "manualEdit.text": "文本",
  "manualEdit.href": "链接地址",
  "manualEdit.textColor": "文本颜色",
  "manualEdit.background": "背景",
  "manualEdit.fontSize": "字号",
  "manualEdit.weight": "字重",
  "manualEdit.align": "对齐方式",
  "manualEdit.padding": "内边距",
  "manualEdit.margin": "外边距",
  "manualEdit.radius": "圆角",
  "manualEdit.referenceValues": "参考值",
  "manualEdit.referenceValuesEmpty": "没有匹配的参考值",
  "manualEdit.referenceValuesLoading": "加载中…",
  "manualEdit.lineHeight": "行高",
  "manualEdit.letterSpacing": "字距",
  "manualEdit.borderStyle": "边框样式",
  "manualEdit.borderStyleSolid": "实线",
  "manualEdit.borderStyleDashed": "虚线",
  "manualEdit.borderStyleDotted": "点线",
  "manualEdit.borderStyleDouble": "双线",
  "manualEdit.borderStyleNone": "无",
  "manualEdit.border": "边框",
  "manualEdit.width": "宽度",
  "manualEdit.minHeight": "最小高度",
  "manualEdit.deleteElement": "删除元素",
  "manualEdit.deleteElementConfirm": "删除选中元素？可以使用撤销恢复。",
  'manualEdit.alignCenter': "居中",
  'manualEdit.opacity': "不透明度",
  "manualEdit.uploadImage": "上传图片",
  "manualEdit.uploadingImage": "正在上传图片…",
  "manualEdit.uploadImageFailed": "无法上传图片。",
  "manualEdit.focusSlides": "聚焦幻灯片",
  "manualEdit.showPanels": "显示面板",
  "fileViewer.zoomOut": "缩小",
  "fileViewer.zoomIn": "放大",
  "fileViewer.resetZoom": "重置缩放",
  "fileViewer.viewportAria": "预览视口",
  "fileViewer.viewportDesktop": "桌面端",
  "fileViewer.viewportDesktopTitle": "全宽桌面预览",
  "fileViewer.viewportTablet": "平板端",
  "fileViewer.viewportTabletTitle": "平板预览 820 × 1180(现代竖屏基线)",
  "fileViewer.viewportMobile": "移动端",
  "fileViewer.viewportMobileTitle": "移动端预览 390 × 844",
  "fileViewer.reloadAria": "重新加载",
  "fileViewer.previousSlide": "上一张",
  "fileViewer.nextSlide": "下一张",
  "fileViewer.slideNavAria": "幻灯片导航",
  "fileViewer.speakerNotes": "演讲者备注",
  "fileViewer.speakerNotesSlide": "第 {current} / {total} 页",
  "fileViewer.speakerNotesEmpty": "这一页还没有演讲者备注。",
  "fileViewer.speakerNotesEdit": "编辑",
  "fileViewer.speakerNotesSave": "保存备注",
  "fileViewer.speakerNotesSaving": "保存中...",
  "fileViewer.speakerNotesSaved": "已保存",
  "fileViewer.speakerNotesSaveFailed": "无法保存演讲者备注。",
  "fileViewer.speakerNotesPlaceholder": "为这一页添加演讲者备注...",
  "fileViewer.previewAssetBlockedTitle": "预览资源已被阻止",
  "fileViewer.previewAssetBlockedDetail": "无法加载 {filePath}。请将外部符号链接替换为此项目内的文件。",
  "fileViewer.presenterReset": "重置",
  "fileViewer.present": "演示",
  "fileViewer.presentInTab": "在当前标签页",
  "fileViewer.presentFullscreen": "全屏",
  "fileViewer.presentNewTab": "新标签页",
  "fileViewer.presentFromBeginning": "从头播放",
  "fileViewer.presentFromCurrentSlide": "从当前页播放",
  "fileViewer.presenterMode": "演讲者模式",
  "fileViewer.exitPresentation": "退出演示",
  "fileViewer.shareLabel": "分享",
  "fileViewer.shareMenuShareLink": "分享",
  "fileViewer.shareMenuPublishOnline": "分享到自有平台",
  "fileViewer.shareMenuDownload": "下载",
  "fileViewer.shareMenuPresentation": "演示文稿",
  "fileViewer.shareMenuSourceFiles": "源文件",
  "fileViewer.shareMenuSave": "保存",
  "fileViewer.shareMenuPublishViaOd": "快速分享（OpenDesign 托管）",
  "fileViewer.unifiedShareAria": "分享和导出操作",
  "fileViewer.unifiedShareTab": "分享",
  "fileViewer.unifiedExportTab": "导出",
  "fileViewer.unifiedSendTab": "发送到...",
  "fileViewer.openFileForHistory": "打开文件后查看历史版本",
  "fileViewer.workspaceShareTitle": "在工作空间中分享项目",
  "fileViewer.workspaceSharePrivateDescription": "仅你可以访问此项目。选择工作空间成员后，即可分享给团队。",
  "fileViewer.workspaceShareWorkspaceDescription": "此工作空间的成员可以访问此项目。",
  "fileViewer.workspaceAccessPrivate": "仅自己",
  "fileViewer.workspaceAccessMembers": "工作空间成员",
  "fileViewer.publishSingleFileTitle": "生成分享链接",
  "fileViewer.publishSingleFileDescription": "任何拿到链接的人都可在线查看。目前仅支持分享单个文件，内嵌图片等本地资源暂不支持。",
  "fileViewer.openFileRequired": "打开文件后可用。",
  "fileViewer.publishFile": "发布文件",
  "fileViewer.publishingFile": "生成中…",
  "fileViewer.unpublishFile": "停止分享",
  "fileViewer.shareEmptyStateTitle": "暂时无法分享",
  "fileViewer.shareEmptyStateDescription": "创建或加入一个团队,就能把这个文件分享给同事",
  "fileViewer.shareEmptyStateCreateTeam": "创建团队",
  "fileViewer.shareTeamMissingTitle": "还没有团队可以分享",

  "fileViewer.publishFileRequiresTeam": "发布公开链接需要团队工作区。请切换到团队工作区，或使用「部署」发布此文件。",
  "fileViewer.publishFileRequiresWorkspace": "生成分享链接需要登录工作区。请登录 OpenDesign Cloud，或改用「部署」分享此文件。",
  "fileViewer.publishFileFailed": "生成分享链接失败，请稍后重试，或改用下方的部署方式。",
  "fileViewer.workspaceShareSuccess": "已分享给工作空间成员",
  "fileViewer.workspaceShareFailed": "分享到工作空间失败",
  "fileViewer.workspaceUnshareSuccess": "已移回仅自己可见",
  "fileViewer.workspaceUnshareFailed": "移回仅自己可见失败",
  "fileViewer.readonlySharedNoExport": "共享项目只读：可以评论，不能编辑或导出",
  "fileViewer.copyShareLink": "复制分享链接",
  "fileViewer.openSharePage": "打开分享页面",
  "fileViewer.shareLinkRequiresDeploy": "先发布到线上以获取链接",
  "fileViewer.shareLinkPublishGuide": "先发布线上，即可分享 ↑",
  "fileViewer.shareAfterGenerationComplete": "生成完成后可分享",
  "fileViewer.copyProviderLink": "复制 {provider} 链接",
  "fileViewer.copyCloudflareLink": "复制 Cloudflare 链接",
  "fileViewer.screenshotCopying": "正在复制截图…",
  "fileViewer.screenshotCopied": "截图已保存到剪贴板",
  "fileViewer.screenshotClipboardDenied": "浏览器拒绝写入剪贴板",
  "fileViewer.screenshotPreviewLoading": "预览还在加载，请稍后再试",
  "fileViewer.screenshotCaptureFailed": "无法截取预览，请重试",
  "fileViewer.exportPdf": "导出为 PDF",
  "fileViewer.exportPdfAllSlides": "导出为 PDF（全部幻灯片）",
  "fileViewer.exportPptxBusy": "请等待当前任务完成。",
  "fileViewer.exportPptxHint": "请求代理将此设计转换为 PPTX。",
  "fileViewer.exportPptxNa": "此处暂不支持导出 PPTX。",
  'fileViewer.exportDaemonUnreachable': '无法连接到 daemon，请重试。',
  "fileViewer.exportZip": "下载为 .zip",
  "fileViewer.exportHtml": "导出为独立 HTML",
  "fileViewer.exportMd": "导出为 Markdown",
  "fileViewer.exportImage": "导出为图片",
  "fileViewer.exportPptxImages": "导出为 PPTX（图片）",
  "fileViewer.exportPptxEditable": "导出为 PPTX（可编辑）",
  "fileViewer.exportPptxEditableHint": "原生可编辑形状与文字(非像素级还原)",
  "fileViewer.exportPptxModalSubtitle": "选择导出方式后点击导出。",
  "fileViewer.exportPptxScreenshot": "截图 PPTX",
  "fileViewer.exportPptxScreenshotHint":
    "每页一张图,像素级 100% 还原,但不可编辑。",
  "fileViewer.exportPptxConfirm": "导出",
  "fileViewer.exportPptxRecommended": "推荐",
  "fileViewer.exportingProgress": "正在导出…",
  "fileViewer.exportSlideProgress": "正在导出第 {current}/{total} 页…",
  "fileViewer.exportingElapsed": "正在导出… {seconds} 秒",
  "fileViewer.exportSlideEta":
    "正在导出第 {current}/{total} 页 · 约剩 {seconds} 秒",
  "fileViewer.exportFailedTitle": "导出失败",
  "fileViewer.exportFailedDescription": "本次导出未完成，请重新尝试。",
  "fileViewer.exportDone": "导出完成",
  "fileViewer.exportImageFailed":
    "图片捕获失败，请重试或使用浏览器的截图工具。",
  "fileViewer.exportImageModalSubtitle":
    "选择图片格式后，将当前预览下载为图片。",
  "fileViewer.exportImageFormatLabel": "格式",
  "fileViewer.exportImageSaving": "正在保存图片…",
  "fileViewer.exportImageSaved": "图片已保存",
  "fileViewer.exportImageDownloadStarted": "已开始下载",
  "fileViewer.exportImageDownloadDetails":
    "如果没有弹出保存窗口，请在浏览器下载目录中查看 {filename}。",
  "fileViewer.exportJsx": "导出为 JSX",
  "fileViewer.exportReactHtml": "导出预览 HTML",
  "fileViewer.exportStarted": "已开始导出",
  "fileViewer.saveAsTemplate": "保存为模板…",
  "fileViewer.savingTemplate": "正在保存模板…",
  "fileViewer.savedTemplate": "已保存为「{name}」",
  "fileViewer.savedTemplateFail": "保存模板失败，请重试。",
  "fileViewer.templateNamePrompt": "模板名称",
  "fileViewer.templateNameDefault": "未命名模板",
  "fileViewer.templateDescPrompt": "简短描述（可选 — 这个模板用于什么场景？）",
  "liveArtifact.refresh.button": "刷新",
  "liveArtifact.refresh.buttonTitle": "刷新此实时看板",
  "liveArtifact.refresh.loadingTitle": "正在加载实时看板…",
  "liveArtifact.refresh.noSourceTitle": "暂无可刷新来源。",
  "liveArtifact.refresh.running": "刷新中…",
  "liveArtifact.refresh.runningMessage":
    "正在刷新数据和预览，可能需要一点时间。",
  "liveArtifact.refresh.runningAction": "刷新成功前会继续显示上一次预览。",
  "liveArtifact.refresh.successOne": "刷新完成，数据已更新。",
  "liveArtifact.refresh.successMany": "刷新完成，数据已更新。",
  "liveArtifact.refresh.successAction": "预览已使用最新提交的数据重新加载。",
  "liveArtifact.refresh.previousFailure": "上次刷新失败：{message}",
  "liveArtifact.refresh.failureAction":
    "请检查「刷新历史」，修复来源或权限问题后重试。",
  "liveArtifact.refresh.networkFailure": "刷新请求失败。请检查网络连接后重试。",
  "liveArtifact.refresh.genericFailure": "刷新失败。",
  "liveArtifact.refresh.statusNever": "不可刷新",
  "liveArtifact.refresh.statusReady": "可刷新",
  "liveArtifact.refresh.statusSucceeded": "已是最新",
  "liveArtifact.refresh.statusFailed": "刷新失败",
  "liveArtifact.refresh.statusRunning": "正在刷新",
  "liveArtifact.refresh.statusRunningDescription": "刷新任务正在进行中。",
  "liveArtifact.refresh.statusSucceededDescription": "上次刷新已成功完成。",
  "liveArtifact.refresh.statusFailedDescription": "上次刷新未能成功完成。",
  "liveArtifact.refresh.statusReadyDescription":
    "已配置可刷新的数据源，但暂无正在进行的任务。",
  "liveArtifact.refresh.statusNeverDescription":
    "该实时看板尚未配置刷新数据源。",
  "liveArtifact.refresh.eventStarted": "已开始",
  "liveArtifact.refresh.eventSucceeded": "已成功",
  "liveArtifact.refresh.eventFailed": "失败",
  "liveArtifact.refresh.eventStartedDetail": "刷新已开始…",
  "liveArtifact.refresh.sourcesUpdatedOne": "已更新 {n} 个数据源",
  "liveArtifact.refresh.sourcesUpdatedMany": "已更新 {n} 个数据源",
  "liveArtifact.refresh.timelineEmpty":
    "本次会话还没有刷新记录。点击「刷新」即可记录时间线，或等待自动任务完成。",
  "liveArtifact.refresh.heroLastRefreshedLabel": "上次刷新",
  "liveArtifact.refresh.heroLastRefreshedNever": "从未",
  "liveArtifact.refresh.justNow": "刚刚",
  "liveArtifact.refresh.factCreated": "创建时间",
  "liveArtifact.refresh.factLastUpdated": "最后更新",
  "liveArtifact.refresh.factUnknown": "未知",
  "liveArtifact.refresh.persistedTitle": "持久化刷新记录",
  "liveArtifact.refresh.persistedHint": "来自 refreshes.jsonl 的条目",
  "liveArtifact.refresh.persistedEmpty": "尚无持久化的刷新记录。",
  "liveArtifact.refresh.persistedStatusSucceeded": "成功",
  "liveArtifact.refresh.persistedStatusRunning": "进行中",
  "liveArtifact.refresh.persistedStatusFailed": "失败",
  "liveArtifact.refresh.persistedStatusCancelled": "已取消",
  "liveArtifact.refresh.persistedStatusSkipped": "已跳过",
  "liveArtifact.refresh.sessionTitle": "会话活动",
  "liveArtifact.refresh.sessionHint": "本标签页打开期间观察到的事件",
  "liveArtifact.refresh.docSourceTitle": "文档来源",
  "liveArtifact.refresh.docSourceHint": "已配置的数据源",
  "liveArtifact.refresh.docSourceType": "类型",
  "liveArtifact.refresh.docSourceTool": "工具",
  "liveArtifact.refresh.docSourceConnector": "连接器",
  "liveArtifact.refresh.debugSummary": "高级调试元数据",
  "liveArtifact.refresh.debugNote":
    "可能包含连接器 ID、文件名、来源元数据以及内部 artifact 路径。",
  "liveArtifact.viewer.tabPreview": "预览",
  "liveArtifact.viewer.tabCode": "代码",
  "liveArtifact.viewer.tabData": "数据",
  "liveArtifact.viewer.tabRefreshHistory": "刷新历史",
  "liveArtifact.viewer.dataEmpty": "没有可用的 data.json 缓存。",
  "liveArtifact.viewer.code.templateHeading": "模板 HTML",
  "liveArtifact.viewer.code.renderedHeading": "渲染后 HTML",
  "liveArtifact.viewer.code.templateHelp":
    "用于配合 data.json 生成预览的可编辑模板。",
  "liveArtifact.viewer.code.renderedHelp":
    "Preview 当前加载的已生成 index.html。",
  "liveArtifact.viewer.code.variantAria": "代码版本",
  "liveArtifact.viewer.code.variantTemplate": "模板",
  "liveArtifact.viewer.code.variantRendered": "已渲染",
  "liveArtifact.viewer.code.loading": "正在加载代码…",
  "liveArtifact.viewer.code.unavailable": "代码尚不可用。",
  "liveArtifact.viewer.code.empty": "此代码文件为空。",
  "fileViewer.deployToVercel": "部署到 Vercel",
  "fileViewer.redeployToVercel": "重新部署",
  "fileViewer.deployingToVercel": "正在部署到 Vercel…",
  "fileViewer.deployProviderLabel": "部署平台",
  "fileViewer.vercelProvider": "Vercel",
  "fileViewer.cloudflarePagesProvider": "Cloudflare Pages",
  "fileViewer.deployTargetLabel": "目标",
  "fileViewer.deployTargetPreview": "预览",
  "fileViewer.deployTargetProduction": "生产环境",
  "fileViewer.deployToProvider": "部署到 {provider}",
  "fileViewer.redeployToProvider": "重新部署到 {provider}",
  "fileViewer.deployingToProvider": "正在部署到 {provider}…",
  "fileViewer.preparingPublicLink": "正在准备公开链接…",
  "fileViewer.copyDeployLink": "复制链接",
  "fileViewer.deployModalTitle": "部署",
  "fileViewer.deployModalSubtitle": "使用所选平台账号部署当前 HTML 预览。",
  "fileViewer.vercelToken": "Vercel 令牌",
  "fileViewer.vercelTokenGetLink": "获取 Vercel token",
  "fileViewer.vercelTokenPlaceholder": "粘贴你的 Vercel token",
  "fileViewer.vercelTokenReuseHint": "将使用已保存的令牌。输入新令牌可替换。",
  "fileViewer.vercelTokenRequired": "请先输入并保存 Vercel 令牌。",
  "fileViewer.cloudflareApiToken": "Cloudflare API 令牌",
  "fileViewer.cloudflareApiTokenGetLink": "获取 API token",
  "fileViewer.cloudflareApiTokenPlaceholder": "粘贴你的 Cloudflare API 令牌",
  "fileViewer.cloudflareApiTokenReuseHint":
    "将使用已保存的 Cloudflare API 令牌。输入新令牌可替换。",
  "fileViewer.cloudflareApiTokenRequired":
    "请先输入并保存 Cloudflare API 令牌。",
  "fileViewer.cloudflareApiTokenScopeHint":
    "创建 API token 时勾选 Pages Edit；自定义域名需 Zone Read / DNS Edit。",
  "fileViewer.vercelTeamId": "团队 ID",
  "fileViewer.vercelTeamSlug": "团队标识",
  "fileViewer.cloudflareAccountId": "账户 ID",
  "fileViewer.cloudflareAccountIdHint": "可在 Cloudflare 控制台中找到账户 ID。",
  "fileViewer.cloudflareAccountIdRequired":
    "请先输入并保存 Cloudflare 账户 ID。",
  "fileViewer.cloudflareZoneLabel": "域名",
  "fileViewer.cloudflareZonePlaceholder": "保存 Cloudflare 设置后加载域名",
  "fileViewer.cloudflareZoneRequired": "请先选择一个 Cloudflare 域名。",
  "fileViewer.cloudflareZonesLoading": "正在加载 Cloudflare 域名…",
  "fileViewer.cloudflareZonesRefresh": "刷新域名",
  "fileViewer.cloudflareZonesLoadFailed": "无法加载 Cloudflare 域名。",
  "fileViewer.cloudflareZonesEmpty":
    "此账号下未找到活跃的完整 Cloudflare 域名。",
  "fileViewer.cloudflareDomainPrefixLabel": "子域名前缀",
  "fileViewer.cloudflareDomainPrefixPlaceholder": "demo",
  "fileViewer.cloudflareDomainPrefixInvalid":
    "请仅使用单个 DNS 标签:小写字母、数字和连字符。",
  "fileViewer.cloudflareHostnamePreview": "自定义域名预览:{hostname}",
  "fileViewer.cloudflareCustomDomainHint":
    "可选：绑定自定义域名。不填也会生成 pages.dev 链接。",
  "fileViewer.cloudflarePagesDevLinkLabel": "pages.dev URL",
  "fileViewer.cloudflareCustomDomainLinkLabel": "自定义域名",
  "fileViewer.optional": "可选",
  "fileViewer.vercelPreviewOnly": "当前仅部署 Preview。",
  "fileViewer.cloudflarePagesPreviewHint":
    "Cloudflare Pages 使用 Direct Upload。",
  "fileViewer.savingConfig": "保存中…",
  "fileViewer.deployConfigSaveFailed": "保存 Vercel 设置失败。",
  "fileViewer.deployFailed": "部署失败，请检查 Vercel 设置后重试。",
  "fileViewer.deployProviderConfigSaveFailed": "无法保存 {provider} 设置。",
  "fileViewer.deployProviderFailed": "{provider} 部署失败。请检查设置后重试。",
  "fileViewer.deployResultLabel": "部署链接",
  "fileViewer.deployLinkReady": "已就绪",
  "fileViewer.deploySuccessToast": "部署已成功上传",
  "fileViewer.deploySuccessToastDetails": "{provider} · {url}",
  "fileViewer.deployLinkPreparingLabel": "公开链接准备中",
  "fileViewer.deployLinkDelayed": "站点已经部署，平台仍在准备公开链接。",
  "fileViewer.deployLinkFailed": "自定义域名失败",
  "fileViewer.deployLinkProtectedLabel": "部署访问保护已开启",
  "fileViewer.deployLinkProtected":
    "站点已部署，但此预览链接要求登录后才能访问。请关闭 Deployment Protection 或使用自定义域名。",
  "fileViewer.retryLink": "立即重试",
  "questionForm.submit": "提交",
  "questionForm.skip": "跳过",
  "questionForm.locked": "已回答",
  "tool.openInTab": "在标签页中打开 {name}",
  "tool.open": "打开",
  "tool.todos": "待办",
  "tool.todosExpand": "展开任务",
  "tool.todosCollapse": "收起任务",
  "tool.todosDone": "完成",
  "tool.todosDismiss": "关闭任务列表",
  "tool.write": "写入",
  "tool.edit": "编辑",
  "tool.read": "读取",
  "tool.delete": "删除",
  "tool.bash": "Bash",
  "tool.glob": "Glob",
  "tool.grep": "Grep",
  "tool.fetch": "抓取",
  "tool.search": "搜索",
  "tool.lines": "{n} 行",
  "tool.changeSingular": "处变更",
  "tool.changePlural": "处变更",
  "tool.in": "于 {path}",
  "tool.hide": "隐藏",
  "tool.output": "输出",
  "tool.running": "运行中…",
  "tool.error": "错误",
  "tool.done": "完成",
  "assistant.role": "助手",
  "assistant.workingLabel": "执行中",
  "assistant.doneLabel": "已完成",
  "assistant.awaitingReplyLabel": "等待回复",
  "assistant.canceledLabel": "任务已停止",
  "assistant.canceledDetail": "本次运行已按你的操作停止。",
  "assistant.copyMarkdown": "复制",
  "assistant.forkConversation": "新会话",
  "assistant.forkingConversation": "正在开始新会话…",
  "assistant.forkNote": "从上一个会话继续",
  "assistant.shareToOpenDesign": "分享到 OpenDesign",
  "assistant.shareToOpenDesignBusy": "正在准备投稿…",
  "assistant.feedbackPrompt": "反馈",
  "assistant.feedbackPositive": "有帮助",
  "assistant.feedbackNegative": "没帮助",
  "assistant.feedbackReasonTitle": "选择原因",
  "assistant.feedbackReasonTitleNegative": "哪里不对?",
  "assistant.feedbackDiscordNegative": "到 {discord} 说说具体情况,团队才能弄清哪里出了问题并跟进。",
  "assistant.feedbackDiscordPositive": "到 {discord} 社区晒晒你做的东西,或者发张截图说说哪里好用。",
  "assistant.feedbackReasonPositiveMatched": "理解了我的需求",
  "assistant.feedbackReasonPositiveVisual": "视觉效果满意",
  "assistant.feedbackReasonPositiveUseful": "结构有帮助",
  "assistant.feedbackReasonPositiveEasy": "方便继续修改",
  "assistant.feedbackReasonPositiveDesignSystem": "严格按照设计系统生成",
  "assistant.feedbackReasonNegativeMissed": "没按我说的改",
  "assistant.feedbackReasonNegativeVisual": "视觉不一致",
  "assistant.feedbackReasonNegativeIncomplete": "产物不完整",
  "assistant.feedbackReasonNegativeHard": "不方便使用",
  "assistant.feedbackReasonNegativeCouldNotRun": "跑不起来",
  "assistant.feedbackReasonNegativeTooSlow": "太慢",
  "assistant.feedbackReasonNegativeDesignSystem": "没有严格按照设计系统生成",
  "assistant.feedbackReasonOther": "其他",
  "assistant.feedbackReasonPlaceholder": "补充点什么(可选)",
  "assistant.feedbackReasonSubmit": "提交",
  "assistant.emptyResponseLabel": "任务未能完成",
  "assistant.emptyResponseMessage": "本次任务运行失败，请重试。如果再次失败，请联系支持。",
  "assistant.unfinishedLabel": "任务尚未完成",
  "assistant.unfinishedDetail": "本次任务仍有 {n} 项内容未完成。",
  "assistant.unfinishedSummary": "剩余 {n} 个任务",
  "assistant.unfinishedMore": "还有 {n} 个",
  "assistant.continueRemaining": "继续剩余任务",
  "chat.resumeRunCta": "继续运行",
  "chat.runError.contactSupportCta": "联系我们",
  "chat.runError.exportLogsCta": "导出日志",
  "chat.runError.switchModelCta": "换个模型",
  "chat.runError.openSettingsCta": "去设置",
  "chat.runError.title.readOnlyAccess": "暂无项目编辑权限",
  "chat.runError.title.messagesUnavailable": "对话内容加载失败",
  "chat.runError.actionBlocked.readOnly": "目前只有对该项目的查看权限，暂时无法运行任务。",
  "chat.runError.actionBlocked.messagesUnavailable": "暂时无法读取对话内容，请重试。如果再次失败，请联系支持。",
  "chat.runError.actionBlocked.billing": "还在确认这个项目由哪个工作区付费，稍后再试。",
  "chat.runError.actionBlocked.busy": "这条对话还有任务在运行，结束后才能重试。",
  "chat.support.channel.feishu": "飞书社群",
  "chat.support.channel.discord": "Discord",
  "chat.amrBalanceOwner.title": "团队额度不足",
  "chat.amrBalanceOwner.message": "当前团队额度不足，请联系团队管理员充值或升级订阅。",
  "chat.amrBalanceOwner.messageNoOwnerName": "当前团队额度不足，请联系团队管理员充值或升级订阅。",
  "chat.amrBalanceOwner.dismissCta": "知道了",
  "assistant.outTokens": "{n} 输出",
  "assistant.producedFiles": "本轮产出的文件",
  "assistant.openFile": "打开",
  "assistant.downloadFile": "下载",
  "nextStep.imageContinue": "继续优化",
  "nextStep.imageVariants": "生成变体/换一批",
  "nextStep.imageStyle": "调整风格/构图",
  "nextStep.title": "下一步",
  "nextStep.suggestionsLabel": "下一步建议",
  "nextStep.more": "更多",
  "nextStep.share": "分享",
  "nextStep.download": "下载",
  "nextStep.contribute": "贡献社区",
  "nextStep.planGenerateTitle": "生成产物",
  "nextStep.planGenerateBody":
    "以已确认的 Markdown 规划文档为依据生成下一版产物。",
  "nextStep.planImproveTitle": "继续优化文档",
  "nextStep.planImproveBody": "先把当前规划文档补完整，再进入最终生成。",
  "nextStep.planGeneratePrompt":
    "以 `{file}` 作为唯一事实来源。先读取这份文档，保留其中已经确定的决策，然后生成与文档匹配的最终设计产物。如果它是逐页大纲，就生成 PPT/Deck；如果它是 PRD 或原型规划，就生成原型或线框图；如果它是分镜或创意 brief，就生成对应的视觉/媒体产物。生成前请指出你无法自行解决的阻塞 TODO 或矛盾点。",
  "nextStep.planImprovePrompt":
    "读取 `{file}`，并直接在原文件中优化这份可编辑规划文档。收紧范围，补齐薄弱章节，增加验收标准；仍需要用户输入的地方保留 TODO / open question。暂时不要生成最终设计产物。",
  "nextStep.planImproveArtifactTitle": "继续优化产物",
  "nextStep.planImproveArtifactBody":
    "基于当前产物继续打磨，而不是回到规划阶段。",
  "nextStep.planImproveArtifactPrompt":
    "直接优化 `{artifact}`。保留当前已经可用的产物和行为，优先改进产品结构、视觉层级、交互细节和内容表达。完成后总结改动文件和仍需注意的风险。",
  "nextStep.planMergeTitle": "融合文档与产物",
  "nextStep.planMergeBody": "把规划意图和已生成产物对齐，让两者一起推进。",
  "nextStep.planMergePrompt":
    "同时读取 `{document}` 和 `{artifact}`。把文档视为意图来源，把产物视为当前实现，然后融合两者：让产物对齐已确认决策，只在文档过时时更新文档，仍未确定的内容保留 TODO / open question。保留当前已可用的行为，最后总结文档和产物分别改了什么。",
  "nextStep.brandAiOptimizeTitle": "深化抽取设计系统",
  "nextStep.brandAiOptimizeBody":
    "启动 agent 消耗模型 token，重新抽取来源内容，并原地更新这个设计系统。",
  "nextStep.brandCreateDesignTitle": "用此系统新建设计",
  "nextStep.brandCreateDesignBody":
    "基于已抽取的颜色、字体、素材和设计规范创建一个新设计。",
  "nextStep.createDesignBusy": "正在新建设计...",
  "assistant.thinking": "思考中",
  "assistant.thought": "思考完毕",
  "assistant.thoughtFor": "已深度思考（用时 {s} 秒）",
  "assistant.designSystemDirectionLocked": "已选择当前设计系统，视觉方向已锁定。",
  "assistant.waitingFirstOutput": "等待首批输出中",
  "assistant.statusBootingAgent": "正在启动代理",
  "assistant.statusPreparing": "准备中…",
  "assistant.statusStarting": "启动中",
  "assistant.statusRequesting": "正在发送请求",
  "assistant.statusThinking": "思考中",
  "assistant.statusStreaming": "流式输出中",
  "assistant.statusCompactingContext": "正在压缩上下文",
  "assistant.slowHint":
    "耗时比平时更久。一般 5–10 秒内会出现表单，可以「停止」后重新表述。",
  "assistant.verbEditing": "编辑",
  "assistant.verbWriting": "写入",
  "assistant.verbReading": "读取",
  "assistant.verbSearching": "搜索",
  "assistant.verbRunning": "运行",
  "assistant.verbTodos": "待办",
  "assistant.verbFetching": "抓取",
  "assistant.verbCalling": "调用",
  "qf.answered": "已回答",
  "qf.unanswered": "未回答",
  "qf.unansweredContinued": "此问题未回复，对话已继续。",
  "qf.answeredConfirmed": "已确认",
  "qf.answeredSkipped": "已跳过",
  "chat.att.cancelUpload": "取消上传 {name}",
  "chat.att.retry": "重试",
  "chat.attachments.scrollNext": "看后面的附件",
  "chat.attachments.scrollPrev": "看前面的附件",
  "chat.input.collapse": "收起",
  "chat.input.expandFull": "展开全文",
  "chat.input.viewAll": "查看全部",
  "chat.artifact.export": "导出",
  "chat.artifact.pending": "生成中…",
  "chat.artifact.publish": "分享",
  "chat.edge.paused": "已手动暂停任务",
  "chat.edge.reconnectCta": "重新连接",
  "chat.edge.reconnectDetail": "查看详情",
  "chat.edge.reconnectFailed": "网络连接未能恢复",
  "chat.edge.reconnectFailedDescription": "请确认网络连接正常后再试。",
  "chat.edge.reconnecting": "正在恢复网络连接",
  "chat.edge.reconnectingDescription": "正在进行第 {attempt}/{max} 次连接尝试，请稍候。",
  "chat.edge.retrying": "正在重试",
  "chat.edge.retryingRateLimitedTitle": "模型服务请求繁忙",
  "chat.edge.retryingRateLimitedDescription": "当前使用该模型服务的请求较多，已达到供应商的请求频率上限，请稍后再试，或者切换其他模型。",
  "qf.visualNext": "下一张",
  "qf.visualPrev": "上一张",
  "qf.visualRandom": "随机",
  "qf.visualReshuffle": "换一批",
  "qf.visualViewFan": "叠回一沓",
  "qf.visualViewGrid": "铺成网格",
  "qf.confirmed": "已确认",
  "qf.picked": "已选 {count}",
  "qf.moreOptions": "更多选项",
  "qf.colorPresets": "预设颜色",
  "qf.colorCustom": "自定义颜色",
  "qf.colorPickerLabel": "打开颜色选择器",
  "qf.colorHexLabel": "十六进制颜色值",
  "qf.colorPreview": "预览:界面里的强调色会这样显示。",
  "qf.colorInvalid": "请输入 6 位十六进制颜色值,例如 #3b82f6",
  "qf.choose": "请选择…",
  "qf.customLabel": "自定义填写",
  "qf.customPlaceholder": "输入你自己的答案…",
  "qf.otherOption": "其他",
  "qf.ownAnswer": "自己填",
  "qf.required": "必填",
  "qf.lockedSubmitted": "答案已发送，代理将在本次会话后续使用。",
  "qf.lockedPrev": "该表单来自此前的对话。",
  "qf.hint": "挑选合适的选项；可选项可以跳过，代理会使用合理的默认值。",
  "qf.submitDefault": "下一步",
  "qf.submitDisabledTitle": "请先填写必填项",
  "qf.submitTitle": "下一步",
  "questions.tabLabel": "问题",
  "questions.banner": "想先跟你确认几个小问题～",
  "questions.bannerAnswered": "已回答这些问题",
  "questions.strategyBlockedNotice": "该任务已被策略质量门拦下，此表单无法再提交。请重新发起一次请求以继续。",
  "questions.continue": "继续",
  "questions.generating": "正在生成问题…",
  "questions.skipAll": "跳过 · 你来判断",
  "questions.autoSkipHint": "倒计时结束后将自动继续",
  "questions.submitting": "正在提交…",
  "sketch.toolSelect": "选择（占位）",
  "sketch.toolPen": "钢笔",
  "sketch.toolText": "文本",
  "sketch.toolRect": "矩形",
  "sketch.toolArrow": "箭头",
  "sketch.toolEraser": "橡皮擦",
  "sketch.color": "颜色",
  "sketch.strokeSize": "描边粗细",
  "sketch.undo": "撤销",
  "sketch.clear": "清空",
  "sketch.close": "关闭",
  "sketch.closeConfirm": "关闭草图并放弃未保存的更改吗？",
  "sketch.textPrompt": "请输入文本：",
  "sketch.textModalTitle": "添加文本",
  "critiqueTheater.userFacingName": "设计评审团",
  "critiqueTheater.roleDesigner": "设计师",
  "critiqueTheater.roleCritic": "评审",
  "critiqueTheater.roleBrand": "品牌",
  "critiqueTheater.roleA11y": "无障碍",
  "critiqueTheater.roleCopy": "文案",
  "critiqueTheater.roundLabel": "第 {n} 轮 / 共 {m} 轮",
  "critiqueTheater.mustFix": "{n} 项必改",
  "critiqueTheater.composite": "综合分",
  "critiqueTheater.threshold": "阈值",
  "critiqueTheater.consensus": "共识",
  "critiqueTheater.interrupt": "中断",
  "critiqueTheater.interrupting": "正在中断…",
  "critiqueTheater.interrupted": "已中断",
  "critiqueTheater.degradedHeading": "本次评审不可用",
  "critiqueTheater.degradedReasonMalformed": "评审块格式错误，解析器已拒绝。",
  "critiqueTheater.degradedReasonOversize": "评审输出超出了安全字节预算。",
  "critiqueTheater.degradedReasonAdapter": "适配器 {adapter} 不支持评审协议。",
  "critiqueTheater.degradedReasonProtocol":
    "适配器 {adapter} 使用了不支持的协议版本。",
  "critiqueTheater.degradedReasonMissingArtifact": "运行结束但未产出最终产物。",
  "critiqueTheater.replay": "回放",
  "critiqueTheater.replaySpeed": "回放速度",
  "critiqueTheater.readOnly": "只读",
  "critiqueTheater.shippedSummary":
    "已于第 {round} 轮发布 · 综合分 {composite}",
  "critiqueTheater.interruptedSummary":
    "已于第 {round} 轮中断 · 最佳综合分 {composite}",
  "critiqueTheater.shippedBadge": "已发布",
  "critiqueTheater.belowThresholdBadge": "低于阈值",
  "critiqueTheater.timedOutBadge": "已超时",
  "critiqueTheater.failedHeading": "运行失败",
  "critiqueTheater.failedReasonCliExit":
    "智能体 CLI 在评审完成前以非零状态退出。",
  "critiqueTheater.failedReasonPerRoundTimeout": "某一轮超出了时间预算。",
  "critiqueTheater.failedReasonTotalTimeout": "整次运行超出了总时间预算。",
  "critiqueTheater.failedReasonOrchestrator": "编排器内部错误。",
  "critiqueTheater.transcriptEmpty":
    "暂无可回放的会话记录。运行一次评审即可记录。",
  "critiqueTheater.transcriptLoading": "正在加载会话记录…",
  "critiqueTheater.transcriptError": "无法加载会话记录：{error}",
  "critiqueTheater.replaySpeedPaused": "暂停",
  "critiqueTheater.replaySpeedInstant": "瞬时",
  "critiqueTheater.replaySpeedLive": "实时",
  "critiqueTheater.replaySpeedFast": "快进",
  "critiqueTheater.settingsNav": "设计评审团",
  "critiqueTheater.settingsNavHint": "为代理运行启用五人设计评审",
  "critiqueTheater.settingsEnabledLabel": "在代理运行期间显示设计评审团",
  "critiqueTheater.settingsEnabledDescription":
    "启用后，五人评审面板会在代理生成时同时显示，并在交付前对结果评分。你可以随时中断。",
  "critiqueTheater.settingsEnabledProjectHint":
    "已为该项目保存。该项目的新运行将在服务端经过设计评审团。",
  "critiqueTheater.settingsEnabledNoProjectHint":
    "打开项目后此设置才会服务端持久化；目前仅修改浏览器本地偏好。",
  "pet.title": "宠物",
  "pet.subtitle":
    "「显示宠物」控制它是否出现在工作区；下方可以选择内置、自定义或社区宠物。",
  "pet.navTitle": "宠物",
  "pet.navHint": "领养与自定义",
  "pet.tabBuiltIn": "内置",
  "pet.tabBuiltInHint": "OpenDesign 内置的精选宠物 — 一键领养。",
  "pet.builtInEmpty":
    "暂时无法加载内置宠物。等本地服务恢复后,刷新「社区」页签再试。",
  "pet.tabCustom": "自定义",
  "pet.tabCustomHint": "自己取名、选符号或上传精灵图。",
  "pet.tabCommunity": "社区",
  "pet.tabCommunityHint": "来自 Codex 的孵化宠物 — 领养或用 AI 生成新的。",
  "pet.tabsAria": "选择宠物",
  "pet.adopt": "领养",
  "pet.adoptedBadge": "已领养",
  "pet.adoptCallout": "领养一只宠物",
  "pet.changePet": "更换宠物",
  "pet.wake": "显示宠物",
  "pet.tuck": "隐藏宠物",
  "pet.wakeTitle": "在工作区显示宠物。尚未选择时，会默认使用第一只内置宠物。",
  "pet.tuckTitle": "从工作区隐藏宠物。",
  "pet.settingsTitle": "打开宠物设置",
  "pet.useCustom": "使用我的宠物",
  "pet.customTitle": "自定义你的宠物",
  "pet.customHint": "挑一个名字、表情和主题色，浮窗会即时更新。",
  "pet.customGreetingPlaceholder": "来自宠物的问候…",
  "pet.fieldName": "名字",
  "pet.fieldGlyph": "表情",
  "pet.fieldGlyphHint": "建议使用单个 emoji（例如 🐝、🦄、🐢）。",
  "pet.fieldGreeting": "问候语",
  "pet.fieldAccent": "主题色",
  "pet.fieldAccentCustom": "自定义颜色",
  "pet.fieldAccentDefault": "默认主题色",
  "pet.overlayAria": "宠物伙伴",
  "pet.spriteAria": "{name} — 拖动可移动，点击与它互动",
  "pet.spriteTitle": "{name} 来打招呼啦！点击聊天。",
  "pet.taskSummarySingle": "正在执行 {count} 个 Agent 任务。",
  "pet.taskSummaryMultiple":
    "正在执行 {count} 个 Agent 任务，分布在 {projects} 个项目。",
  "pet.taskSummaryRecentSingle": "最近完成 {count} 个 Agent 任务。",
  "pet.taskSummaryRecentMultiple": "最近完成 {count} 个 Agent 任务。",
  "pet.taskListAria": "执行中的 Agent 任务",
  "pet.taskOpenProject": "打开 {project}",
  "pet.taskGroup.running": "正在执行",
  "pet.taskGroup.queued": "等待中",
  "pet.taskGroup.recent": "最近完成",
  "pet.idleQuote.leonardo.text": "学习从不会使心灵疲惫。",
  "pet.idleQuote.leonardo.author": "列奥纳多·达·芬奇",
  "pet.idleQuote.michelangelo.text":
    "我看见天使在大理石中，于是不断雕刻，直到让他自由。",
  "pet.idleQuote.michelangelo.author": "米开朗基罗",
  "pet.idleQuote.bernini.text": "有两样东西能帮助雕塑家：光与影。",
  "pet.idleQuote.bernini.author": "吉安·洛伦佐·贝尼尼",
  "pet.idleQuote.raphael.text": "作画时，人并不思考。",
  "pet.idleQuote.raphael.author": "拉斐尔",
  "pet.idleQuote.caravaggio.text": "作品若不是从生活中来，终究只是细枝末节。",
  "pet.idleQuote.caravaggio.author": "卡拉瓦乔",
  "pet.idleQuote.rodin.text":
    "最重要的是被打动、去爱、去希望、去颤抖、去生活。",
  "pet.idleQuote.rodin.author": "奥古斯特·罗丹",
  "pet.composerTitle": "宠物 — 唤醒、收起或选一只",
  "pet.composerMenuTitle": "宠物",
  "pet.composerMenuHint": "小贴士：输入 /pet 即可切换",
  "pet.composerOpenSettings": "管理宠物",
  "pet.welcomeTeaserTitle": "领养一只宠物",
  "pet.welcomeTeaserBody": "一只小小的浮窗伙伴，会陪着你工作。",
  "pet.welcomeTeaserCta": "挑一只",
  "pet.imageUpload": "上传形象",
  "pet.imageReplace": "替换形象",
  "pet.imageRemove": "改用 emoji",
  "pet.imageHintIdle":
    "支持 PNG / JPG / WebP / GIF / SVG。要做精灵动画？传一张横向序列图并设置帧数。",
  "pet.imageHintActive":
    "正在使用你上传的形象。把帧数设为 > 1 即可让横向序列图动起来。",
  "pet.fieldFrames": "帧数",
  "pet.fieldFramesHint": "1 = 静态；> 1 = 横向序列图。",
  "pet.fieldFps": "速度 (fps)",
  "pet.fieldFpsHint": "控制序列图的播放速度。",
  "pet.atlasImport": "导入 Codex 精灵图",
  "pet.atlasImportTitle": "导入 hatch-pet 8x9 / 192x208 精灵图(PNG 或 WebP)。",
  "pet.atlasPickerTitle": "选择动画行",
  "pet.atlasPickerHint":
    "Codex 宠物自带 9 个动画状态。默认会保留完整精灵图,这样宠物会根据悬停、拖拽方向、长时间空闲自动切换动画。也可以只保留一个循环。",
  "pet.atlasCancel": "丢弃精灵图",
  "pet.atlasAdopt": "锁定这一行",
  "pet.atlasAdoptFull": "使用完整精灵图(动态)",
  "pet.atlasAdoptFullTitle":
    "保留全部动画行,让宠物对悬停、拖拽方向以及长时间空闲做出反应。",
  "pet.atlasAdoptRowTitle": "只把高亮的这一行切成单循环条带。",
  "pet.atlasActiveHint":
    "动态精灵图已启用 — 宠物会根据你的交互(悬停、拖拽、空闲)自动切换动画。",
  "pet.atlasRow.idle": "待机",
  "pet.atlasRow.running-right": "向右跑",
  "pet.atlasRow.running-left": "向左跑",
  "pet.atlasRow.waving": "挥手",
  "pet.atlasRow.jumping": "跳跃",
  "pet.atlasRow.failed": "失败",
  "pet.atlasRow.waiting": "等待",
  "pet.atlasRow.running": "奔跑",
  "pet.atlasRow.review": "审视",
  "pet.hatchTitle": "用 AI 孵化新宠物",
  "pet.hatchHint":
    "通过聊天调用内置的 hatch-pet 技能生成 Codex 风格的精灵图,完成后回到这里导入。",
  "pet.hatchConcept": "宠物概念(可选)",
  "pet.hatchConceptPlaceholder": "例如:一只穿着毛衣的像素风柴犬",
  "pet.hatchCopy": "复制提示词",
  "pet.hatchCopied": "已复制!",
  "pet.hatchFoot": "技能保存好宠物后,回到这里点击「导入 Codex 精灵图」即可。",
  "pet.slashPopoverAria": "斜杠命令",
  "pet.slashPopoverTitle": "命令",
  "pet.slashPopoverHint": "↑↓ 切换 · 回车选择 · esc 关闭",
  "pet.slashPet": "切换、领养或跳转到宠物设置。",
  "pet.slashMcp": "打开 MCP 服务器设置，或插入服务器工具提示。",
  "pet.slashPetWake": "唤醒漂浮的宠物。",
  "pet.slashPetTuck": "把宠物收起来。",
  "pet.slashHatch": "调用 hatch-pet 技能生成一只 Codex 宠物。",
  "pet.slashHatchArg": "<概念>",
  "pet.slashSearch": "通过 OD research 命令搜索网页。",
  "pet.slashSearchArg": "<查询>",
  "pet.codexTitle": "最近孵化",
  "pet.codexSubtitle": "hatch-pet 技能打包的宠物会出现在这里,可一键领养。",
  "pet.codexSubtitleWithDir": "正在扫描 {dir},查找 hatch-pet 技能打包的宠物。",
  "pet.codexEmpty": "还没有孵化的宠物。在聊天中输入 /hatch 来生成一只。",
  "pet.codexLoading": "正在查找已孵化的宠物…",
  "pet.codexRefresh": "刷新",
  "pet.codexAdopt": "领养",
  "pet.codexAdopting": "领养中…",
  "pet.communitySync": "下载社区宠物",
  "pet.communitySyncing": "下载中…",
  "pet.communitySyncTitle":
    "从 Codex Pet Share 与 j20 Hatchery 同步最新宠物到 ~/.codex/pets/。",
  "pet.communitySyncDone": "已同步 {wrote} 个新宠物（共 {total} 个）。",
  "pet.communitySyncFailed": "同步失败：{error}",
  "pet.codexBundled": "内置",
  "pet.codexBundledTitle": "OpenDesign 内置宠物，无需下载。",
  "settings.systemPrefsTitle": "系统偏好",
  "settings.systemPrefsHint": "完成提示音、浏览器通知和任务状态提醒。",
  "settings.notifications": "通知",
  "settings.notificationsHint": "任务完成时的声音和桌面通知",
  "settings.notifyCompletionSound": "完成提示音",
  "settings.notifyCompletionSoundHint": "一轮任务结束时播放，默认关闭",
  "settings.notifySuccessSound": "成功音色",
  "settings.notifyFailureSound": "失败音色",
  "settings.notifyDesktop": "桌面通知",
  "settings.notifyDesktopHint": "窗口不在前台时弹出系统通知",
  "settings.notifyDesktopBlocked": "浏览器已拒绝通知权限，请在站点设置中开启",
  "settings.notifyDesktopUnsupported": "当前环境不支持桌面通知",
  "settings.notifyTest": "测试通知",
  "settings.notifyTestSent":
    "测试通知已发送；如果没有弹窗，请检查浏览器和系统通知设置。",
  "settings.notifyTestFailed": "通知调用失败，请检查浏览器和系统通知设置。",
  "settings.notifySoundDing": "叮",
  "settings.notifySoundChime": "风铃",
  "settings.notifySoundTwoToneUp": "上行双音",
  "settings.notifySoundPluck": "拨弦",
  "settings.notifySoundBuzz": "蜂鸣",
  "settings.notifySoundTwoToneDown": "下行双音",
  "settings.notifySoundThud": "低响",
  "settings.skills": "技能",
  "settings.skillsHint": "智能体在任务中可以调用的功能技能",
  "settings.skillsNew": "新建技能",
  "settings.skillsEmpty": "请在左侧选择一个技能，或新建一个。",
  "settings.skillsEdit": "编辑",
  "settings.skillsDelete": "删除",
  "settings.skillsDeleteConfirm": "确认删除",
  "settings.skillsName": "名称",
  "settings.skillsTriggers": "触发词（逗号或换行分隔）",
  "settings.skillsDescription": "描述",
  "settings.skillsBody": "SKILL.md 内容",
  "settings.skillsCreate": "创建",
  "settings.skillsSave": "保存",
  "settings.skillsSaving": "保存中…",
  "settings.skillsOverrideCreate": "创建用户覆盖",
  "settings.skillsOverrideSave": "另存为用户覆盖",
  "settings.skillsBuiltInOverrideWarning":
    "编辑此内置技能会创建一份用户覆盖。在你删除该覆盖之前，内置条目将从列表中隐藏。是否继续？",
  "settings.skillsFiles": "文件",
  "settings.skillsNoFiles": "该技能目录下暂无文件。",
  "settings.skillsNameRequired": "技能名称为必填项。",
  "settings.skillsBodyRequired": "技能内容为必填项。",
  "settings.designSystems": "设计系统",
  "settings.designSystemsHint": "管理首页 Gallery 中显示的设计系统",
  "settings.designSystemsInstalled": "已安装",
  "settings.designSystemsAdd": "添加设计系统",
  "settings.designSystemsHiddenCount": "{count} 个已从首页 Gallery 隐藏",
  "settings.designSystemsShowAll": "显示全部",
  "settings.designSystemsShowHidden": "显示隐藏项",
  "settings.designSystemsSource": "来源",
  "settings.designSystemsSourceLocal": "本地",
  "settings.designSystemsSourceGithub": "GitHub",
  "settings.designSystemsSourceShadcn": "shadcn",
  "settings.designSystemsShadcnReference": "shadcn 注册表引用",
  "settings.designSystemsImportShadcn": "从 shadcn 导入",
  "settings.designSystemsStructure": "结构",
  "settings.designSystemsModeHybrid": "混合",
  "settings.designSystemsModeNormalized": "规范化",
  "settings.designSystemsModeVerbatim": "原样保留",
  "settings.designSystemsCraft": "工艺",
  "settings.designSystemsCraftColor": "颜色",
  "settings.designSystemsCraftAccessibility": "无障碍",
  "settings.designSystemsGithubUrl": "GitHub URL",
  "settings.designSystemsProjectPath": "项目路径",
  "settings.designSystemsImportGithub": "从 GitHub 导入",
  "settings.designSystemsImportProject": "从项目导入",
  "settings.designSystemsImportedStatus": "已导入 {title}",
  "settings.designSystemsViewImported": "查看导入的设计系统",
  "settings.designSystemsCategory": "分类",
  "settings.designSystemsAllCategories": "所有分类",
  "settings.designSystemsShowInHomeGallery": "在首页 Gallery 中显示",
  "settings.projectLocations": "项目位置",
  "settings.projectLocationsHint": "工作区存储根目录",
  "settings.projectLocationsDescription":
    "添加可包含多个 OpenDesign 项目文件夹的工作基目录。新项目会作为所选基目录内的一个文件夹保存。",
  "settings.projectLocationsSaveError":
    "无法保存项目位置。请检查每个路径都是可访问的文件夹。",
  "settings.projectLocationsSaved": "项目位置已保存。",
  "settings.projectLocationsScanError": "无法扫描项目位置。",
  "settings.projectLocationsScanComplete":
    "扫描完成：已导入 {imported} 个，已有 {existing} 个。",
  "settings.projectLocationsNoFolderSelected": "未选择文件夹。",
  "settings.projectLocationsDuplicate": "这个工作基目录已添加。",
  "settings.projectLocationsWorkBaseMeta":
    "工作基目录 · 项目会作为子文件夹创建在这里",
  "settings.projectLocationsAddFolder": "添加文件夹…",
  "settings.projectLocationsDefaultBadge": "默认位置",
  "settings.projectLocationsMakeDefault": "设为默认",
  "settings.projectLocationsDefaultSaved": "默认项目位置已更新。",
  "settings.librarySkills": "技能",
  "settings.libraryDesignSystems": "设计系统",
  "settings.librarySearch": "搜索...",
  "settings.libraryAll": "全部",
  "settings.libraryPreview": "预览",
  "settings.libraryPreviewClose": "关闭",
  "settings.libraryLoading": "加载中...",
  "settings.libraryNoResults": "没有匹配的项目。",
  "settings.libraryEnabled": "已启用",
  "settings.libraryDisabled": "已禁用",
  "settings.connectorsNavHint": "外部系统连接",
  "settings.connectorsHint": "管理此设备的连接器和工具提供商设置。",
  "settings.connectorsComposioApiKey": "Composio API 密钥",
  "settings.connectorsSavedTitle": "已保存到本地 daemon",
  "settings.connectorsSavedWithTail": "已保存 · ••••{tail}",
  "settings.connectorsSaved": "已保存",
  "settings.connectorsGetApiKey": "获取 API 密钥",
  "settings.connectorsReplaceKeyPlaceholder": "输入新 Key 以替换已保存的 Key",
  "settings.connectorsApiKeyPlaceholder": "粘贴 Composio API 密钥",
  "settings.connectorsClear": "清除",
  "settings.connectorsClearConfirmTitle": "清除已保存的 Composio API 密钥？",
  "settings.connectorsClearConfirmBody":
    "删除密钥会断开此工作区下所有的 Composio 连接器。已连接的账号、OAuth 授权和工具访问权限都将被一并移除。",
  "settings.connectorsClearConfirmContinue": "继续",
  "settings.connectorsClearFinalTitle": "此操作会断开所有连接器",
  "settings.connectorsClearFinalBody":
    "该操作无法撤销。粘贴新密钥后，需要从头重新连接每个集成。",
  "settings.connectorsClearFinalConfirm": "删除密钥并断开",
  "settings.connectorsClearArming": "稍等\u2026",
  "settings.connectorsClearCancel": "取消",
  "settings.connectorsSaveKey": "保存密钥",
  "settings.connectorsSaveKeyTitle": "将此密钥发送到本地 daemon",
  "settings.connectorsKeySaving": "保存中…",
  "settings.connectorsKeySaved": "已保存 ✓",
  "settings.connectorsKeyError":
    "保存密钥失败。请确认本地 daemon 已启动后再试。",
  "settings.connectorsHelpSaved":
    "你的密钥会解锁下方目录，并保留在本地 daemon 中。粘贴新密钥可替换，或清除以移除。",
  "settings.connectorsHelpUnsaved":
    "尚未保存 — 点击「保存密钥」即可把它存入本地 daemon，并解锁下方目录。",
  "settings.connectorsHelpEmpty":
    "添加密钥以解锁下方目录。密钥会本地存储在 daemon 中，绝不会通过环境变量发送。",
  "settings.connectorsLoadingSavedKey": "正在从本地 daemon 中检查已保存的密钥…",
  "settings.autosaveSaving": "保存中…",
  "settings.autosaveSaved": "所有更改已保存",
  "settings.autosaveError": "保存更改失败。本地 daemon 可能不在线。",
  "settings.libraryToggleLabel": "切换",
  "settings.memory": "记忆",
  "settings.memoryHint": "后续对话可复用的事实和上下文",
  "settings.customInstructionsTitle": "全局规则",
  "settings.customInstructionsHint":
    "OpenDesign 每次对话都应遵守的固定指令。事实、偏好和项目上下文请保存为记忆。",
  "settings.customInstructionsPlaceholder":
    '例如："始终使用 TypeScript。优先使用函数式组件。保持回复简洁。"',
  "settings.memoryDescription":
    "控制已保存的事实、偏好和项目上下文是否会在后续对话中复用。",
  "settings.memoryEnabled": "已启用",
  "settings.memoryDisabled": "已关闭",
  "settings.memoryEnableLabel": "启用记忆注入",
  "settings.memoryDisabledBanner":
    "记忆当前已关闭。已有的事实文件保留在磁盘上，但不会被注入到新对话，也不会从新对话中提取新事实。",
  "settings.memoryNew": "新建记忆",
  "settings.memoryEdit": "编辑",
  "settings.memoryDelete": "删除",
  "settings.memoryPreview": "预览",
  "settings.memoryEmpty": "还没有记忆。",
  "settings.memoryEmptyHintZh": "记住: 用户偏好深色主题",
  "settings.memoryEmptyHintEn": "I prefer dark mode",
  "settings.memoryName": "例如：UI 偏好",
  "settings.memoryDesc": "一句话 — 这条记忆是关于什么的？",
  "settings.memoryBody": "- 规则一\n- 规则二\n\n为什么：可选\n何时适用：可选",
  "settings.memoryBodyHint":
    "先用 bullet 列出规则，再补「为什么」和「何时适用」（可选）。支持 Markdown。也可以点上方示例直接载入。",
  "settings.memoryStartersLabel": "不知道写什么？点一下填到表单里：",
  "settings.memoryStarterUserName": "我的角色",
  "settings.memoryStarterUserDesc": "我是一名前端工程师，在做 SaaS 设计工具",
  "settings.memoryStarterUserBody":
    "- 角色：高级前端工程师\n- 技术栈：React、TypeScript、Vite\n- 方向：设计 / 协作工具\n- 时区：GMT+8（Asia/Shanghai）\n\n何时适用：任何对话里举例时优先用前端 / Web 场景。",
  "settings.memoryStarterFeedbackName": "UI 偏好",
  "settings.memoryStarterFeedbackDesc": "深色主题、字号偏大、信息密度低",
  "settings.memoryStarterFeedbackBody":
    "- 主题：默认深色\n- 正文字号：≥ 18px\n- 信息密度：留白多一些，一屏不要塞太多东西\n\n为什么：长时间使用眼睛不容易累。\n何时适用：让你画 UI、网页、PPT 时都按这个走。",
  "settings.memoryStarterProjectName": "当前项目",
  "settings.memoryStarterProjectDesc":
    "OpenDesign v0.5 — 聊天驱动的设计编辑器",
  "settings.memoryStarterProjectBody":
    "- 目标：本季度交付聊天驱动的编辑体验\n- 优先级：流式渲染、本地多模态、离线优先\n- 技术栈：Next.js 16、Express daemon、SQLite\n\n何时适用：与本项目相关的所有对话。",
  "settings.memorySaveHint": "不会自动保存 — 点击「创建」/「保存」才生效。",
  "settings.memoryIndexSaveHint":
    "索引不会自动保存 — 改完后点击「保存索引」才生效。",
  "settings.memoryIndexUnsaved": "有未保存的修改",
  "settings.memoryFlashCreated": "✓ 已创建",
  "settings.memoryFlashSaved": "✓ 已保存",
  "settings.memoryFlashDeleted": "✓ 已删除",
  "settings.memoryFlashIndexSaved": "✓ 索引已保存",
  "settings.memoryFlashPathCopied": "✓ 路径已复制",
  "settings.memoryNameLabel": "标题",
  "settings.memoryTypeLabel": "类型",
  "settings.memoryDescLabel": "描述",
  "settings.memoryBodyLabel": "内容",
  "settings.memoryTypeUser": "用户",
  "settings.memoryTypeFeedback": "反馈",
  "settings.memoryTypeProject": "项目",
  "settings.memoryTypeReference": "引用",
  "settings.memoryTypeProfile": "画像",
  "settings.memoryTypeRule": "规则",
  "settings.memoryTabMemories": "记忆",
  "settings.memoryTabMemoriesCaption": "查看和管理已保存的记忆",
  "settings.memoryTabHow": "工作原理",
  "settings.memoryTabHowCaption": "两个循环及其控制项",
  "settings.memoryAddDisclosure": "添加或导入记忆",
  "settings.memoryAddDisclosureHint": "画像、手动录入或已连接的应用",
  "settings.memoryProfileTab": "工作画像",
  "settings.memoryProfileTabCaption": "你是谁以及你的默认偏好",
  "settings.memoryProfileTitle": "你的工作画像",
  "settings.memoryProfileHint":
    "关于你和你默认偏好的几条事实。记忆会在每次任务前注入这些信息，让智能体从一句简短的描述中推断出你的意图。",
  "settings.memoryProfileName": "工作画像",
  "settings.memoryProfileDescription":
    "助手应复用的角色、公司、领域、受众、品味与默认偏好。",
  "settings.memoryProfileSave": "保存画像",
  "settings.memoryProfileSaving": "保存中…",
  "settings.memoryProfileSaved": "画像已保存",
  "settings.memoryProfileRole": "角色",
  "settings.memoryProfileRolePlaceholder": "例如：创始人、设计师、PM",
  "settings.memoryProfileCompany": "公司 / 团队",
  "settings.memoryProfileCompanyPlaceholder": "例如：Acme、增长团队",
  "settings.memoryProfileDomain": "领域",
  "settings.memoryProfileDomainPlaceholder":
    "例如：B2B SaaS、fintech、devtools",
  "settings.memoryProfileAudience": "主要受众",
  "settings.memoryProfileAudiencePlaceholder": "例如：高管、工程师、终端用户",
  "settings.memoryProfileAesthetic": "审美 / 品味",
  "settings.memoryProfileAestheticPlaceholder":
    "例如：简洁有编辑感、浅色背景、充裕留白",
  "settings.memoryProfileDeliverables": "默认交付物",
  "settings.memoryProfileDeliverablesPlaceholder":
    "例如：落地页、幻灯片、单页文档",
  "settings.memoryProfileLocale": "地区 / 语言",
  "settings.memoryProfileLocalePlaceholder":
    "例如：English (US)、Simplified Chinese",
  "settings.memoryProfileGoals": "当前目标",
  "settings.memoryProfileGoalsPlaceholder":
    "例如：上线新的定价页、提升试用流程的转化率",
  "settings.memoryHooksTitle": "记忆钩子",
  "settings.memoryHooksHint":
    "选择记忆的哪些部分自动运行。上方的总开关可以一次性关闭全部。",
  "settings.memoryHooksProfileLabel": "使用我的画像",
  "settings.memoryHooksProfileDesc": "将你的工作画像注入到每个任务中。",
  "settings.memoryHooksRewriteLabel": "改写简短请求",
  "settings.memoryHooksRewriteDesc": "PRE：将简短请求扩写为完整的任务简报。",
  "settings.memoryHooksVerifyLabel": "自检输出",
  "settings.memoryHooksVerifyDesc":
    "POST：依据你的规则核对结果，然后展示评分卡。",
  "settings.memoryHooksExtractionLabel": "从对话中学习",
  "settings.memoryHooksExtractionDesc": "从对话轮次中捕获有用的事实与偏好。",
  "settings.memoryIndex": "MEMORY.md（索引）",
  "settings.memoryIndexSave": "保存索引",
  "settings.memoryIndexReset": "重置",
  "settings.memoryToastChanged": "记忆已更新",
  "settings.memoryToastClickHint": "查看",
  "settings.memoryAll": "全部",
  "settings.memoryExtractions": "抽取历史",
  "settings.memoryExtractionsHint":
    "最近的 LLM 抽取记录。每次对话结束后，启发式正则会先跑，LLM 抽取在后台异步进行。",
  "settings.memoryExtractionsEmpty":
    "暂无抽取记录。下一次对话结束后会出现在这里。",
  "settings.memoryExtractionsRefresh": "刷新",
  "settings.memoryExtractionsRefreshing": "刷新中…",
  "settings.memoryExtractionPhaseRunning": "抽取中…",
  "settings.memoryExtractionPhaseSuccess": "成功",
  "settings.memoryExtractionPhaseSkipped": "已跳过",
  "settings.memoryExtractionPhaseFailed": "失败",
  "settings.memoryExtractionSkipNoProvider": "未配置 API key，LLM 抽取未运行。",
  "settings.memoryExtractionSkipUnsupportedProvider":
    "已保存的媒体 Provider 不能用于 LLM 记忆抽取。",
  "settings.memoryExtractionSkipDisabled": "记忆功能已关闭。",
  "settings.memoryExtractionSkipEmpty": "用户消息为空，没有可抽取的内容。",
  "settings.memoryExtractionSkipNoMatch": "本轮没有命中任何正则规则。",
  "settings.memoryExtractionKindHeuristic": "正则",
  "settings.memoryExtractionKindLlm": "LLM",
  "settings.memoryExtractionProviderEnv": "环境变量",
  "settings.memoryExtractionProviderMediaConfig": "媒体设置",
  "settings.memoryExtractionProviderOverride": "记忆设置",
  "settings.memoryExtractionProposed": "候选",
  "settings.memoryExtractionWritten": "写入",
  "settings.memoryExtractionDuration": "耗时",
  "settings.memoryExtractionDelete": "删除",
  "settings.memoryExtractionsClear": "清空",
  "settings.memoryExtractionsClearTitle": "清空整个抽取历史",
  "settings.memoryExtractionsClearConfirm":
    "确定要清空整个抽取历史吗？此操作无法撤销。",
  "settings.memoryNoProviderBannerTitle": "LLM 抽取未启用",
  "settings.memoryNoProviderBannerBody":
    "未找到可用的 API key，LLM 抽取已跳过。可以在媒体提供商里填入 OpenAI key，或设置环境变量 ANTHROPIC_API_KEY / OPENAI_API_KEY 来启用。启发式抽取仍在运行。",
  "settings.memoryUnsupportedProviderBannerBody":
    "已保存媒体 Provider key，但 Memory 只能复用支持文本抽取的 Provider：OpenAI、MiniMax、AIHubMix 和 SenseAudio。请在媒体提供商中配置其中一个，设置 ANTHROPIC_API_KEY / OPENAI_API_KEY，或在高级设置中选择 Memory model。",
  "settings.libraryInstall": "安装",
  "settings.libraryInstallGithub": "GitHub",
  "settings.libraryInstallLocal": "本地路径",
  "settings.libraryInstallUrl": "https://github.com/owner/repo",
  "settings.libraryInstallPath": "/path/to/skill-folder",
  "settings.libraryInstallButton": "安装",
  "settings.libraryUninstall": "卸载",
  "settings.libraryBuiltIn": "内置",
  "settings.libraryInstalled": "已安装",
  "notify.successTitle": "任务已完成",
  "notify.failureTitle": "任务失败",
  "notify.successBody": "一轮回答已经写完。",
  "notify.failureBody": "本轮任务出错，请查看错误信息。",
  "updater.available": "有可用更新",
  "updater.activeRunsTitle": "OpenDesign 仍在执行任务",
  "updater.activeRunsBody": "仍有 {count} 个任务正在运行。现在重启会中断这些任务。",
  "updater.activeRunsUnknownBody": "OpenDesign 无法确认是否仍有任务运行。现在重启可能会中断正在进行的工作。",
  "updater.availableBody":
    "OpenDesign {version} 可用。下载安装完成后即可打开安装器。",
  "updater.checking": "正在检查更新",
  "updater.download": "下载更新",
  "updater.downloading": "正在下载更新",
  "updater.downloadingPercent": "正在下载更新 {percent}%",
  "updater.done": "完成",
  "updater.failed": "更新失败",
  "updater.installerOpenBody":
    "安装器已打开。OpenDesign 正在退出，以便你完成更新。",
  "updater.installerOpened": "安装器已打开",
  "updater.later": "稍后",
  "updater.allowSilentUpdates": "允许以后自动安装应用内更新",
  "updater.openFailedFallback": "无法打开安装器。",
  "updater.installRestart": "安装并重启",
  "updater.installingRestart": "正在安装并重启…",
  "updater.openInstaller": "安装更新",
  "updater.opening": "正在打开安装器…",
  "updater.dialogAvailableGeneric": "发现新版本。\n下载后即可安装。",
  "updater.dialogAvailableVersion": "v{version} 可供更新。\n下载后即可安装。",
  "updater.dialogCheckFailed": "检查更新失败\n暂时无法获取版本信息，请检查网络连接后重试。",
  "updater.dialogDownloadFailed": "更新下载未完成\n请确认网络连接正常后再试。",
  "updater.downloadFailedTitle": "更新下载未完成",
  "updater.dialogReadyGeneric":
    "新版本已准备就绪。\n更好的体验，更智能的设计，欢迎体验新版本。",
  "updater.dialogReadyVersion":
    "v{version} 已准备就绪。\n更好的体验，更智能的设计，欢迎体验新版本。",
  "updater.dialogUnsupported":
    "当前环境不支持应用内更新。\n可前往发布页手动下载。",
  "updater.payloadReadyGeneric":
    "OpenDesign 更新已就绪。OpenDesign 会关闭并自动重启。",
  "updater.payloadReadyVersion":
    "OpenDesign {version} 已就绪。OpenDesign 会关闭并自动重启。",
  "updater.quitButton": "退出 OpenDesign",
  "updater.quitFailedBody":
    "安装器已打开，但 OpenDesign 无法退出。替换应用前请先退出 OpenDesign。",
  "updater.quitFailedTitle": "无法退出",
  "updater.quitting": "正在退出…",
  "updater.ready": "更新已就绪",
  "updater.readyGeneric": "新版本已就绪。OpenDesign 会关闭并打开安装器。",
  "updater.readyVersion":
    "OpenDesign {version} 已就绪。OpenDesign 会关闭并打开安装器。",
  "updater.upToDate": "您已经是最新版本啦",
  "updater.viewVersionFeatures": "查看新版本特性",
  "updater.manualDownload": "手动下载",
  "updater.reinstallLearnMore": "了解详情",
  "updater.reinstallReadyGeneric": "此更新需要完整重装。OpenDesign 将关闭并打开安装程序。",
  "updater.reinstallReadyVersion": "OpenDesign {version} 需要完整重装。OpenDesign 将关闭并打开安装程序。",
  "updater.restartAnyway": "仍然重启",

  "whatsNew.updatedTitle": "OpenDesign {version} 已更新",
  "whatsNew.cta": "查看更新说明",

  'designBrowser.copyScreenshot': '复制截图',
  'designBrowser.hardReload': '强制刷新',
  'designBrowser.copyUrl': '复制 URL',
  'designBrowser.openExternal': '在外部打开',
  'designBrowser.downloadPage': '下载页面',
  'designBrowser.downloadPageBusy': '正在下载页面...',
  'designBrowser.clearHistory': '清空历史',
  'designBrowser.clearCookies': '清除 Cookie',
  'designBrowser.clearAllData': '清除所有浏览器数据',
  'designBrowser.status.openHttpFirst': '请先打开 http 或 https 页面。',
  'designBrowser.status.openBeforeScreenshot': '请先打开页面再截图。',
  'designBrowser.status.openBeforeBrief': '请先打开页面再保存简报。',
  'designBrowser.status.openBeforeDownload': '请先打开页面再保存快照。',
  'designBrowser.status.pageSnapshotStarted': '正在保存页面快照...',
  'designBrowser.status.pageSnapshotUnsupported': '当前页面无法归档。',
  'designBrowser.status.pageSnapshotFailed': '页面快照保存失败。',
  'designBrowser.status.pageSnapshotSaved': '已保存页面快照（HTML + CSS）。',
  'designBrowser.status.viewDesignFiles': '查看设计文件',
  'designBrowser.status.downloadAssistHint': '页面加载完成后，点击“下载页面”。保存成功后，返回左侧继续提取。',
  'settings.amrBalance': '额度',
  'settings.amrPlan': '套餐',
  'settings.amrUpgrade': '升级',
  'settings.amrModelUpgradeHint': '升级后使用',
  'settings.updateCheck': '检查更新',
  'settings.updateNow': '立即更新',
  'settings.updateRecheck': '重新检查',
  'settings.updateRetry': '重试',
  'settings.updateViewReleases': '查看发布记录',
  'settings.updateActionFailed': '无法完成更新操作。',
  'settings.updateQuitFailed': '安装程序已打开，但 OpenDesign 未能自动退出。',
  'settings.updateStatusNotChecked': '未检查更新',
  'settings.updateStatusDevelopment': '开发环境不支持应用内更新。',
  'settings.updateStatusUnsupported': '当前环境不支持应用内更新。',
  'settings.updateStatusChecking': '正在检查更新…',
  'settings.updateStatusUpToDate': '您已经是最新版本。',
  'settings.updateStatusAvailable': '发现新版本 {version}，正在准备下载',
  'settings.updateStatusAvailableUnknown': '发现新版本，正在准备下载',
  'settings.updateStatusDownloading': '正在下载更新…',
  'settings.updateStatusDownloadingPercent': '正在下载更新 {percent}%。',
  'settings.updateStatusReady': '版本 {version} 已准备好安装。',
  'settings.updateStatusReadyUnknown': '更新已准备好安装。',
  'settings.updateStatusInstalling': '正在安装更新…',
  'settings.updateStatusFailed': '检查失败，请重试',
  'designs.menuDuplicate': '复制项目',
  'project.typePrototype': '原型',
  'project.typeDeck': '幻灯片',
  'project.typeTemplate': '模板',
  'project.typeImage': '图片',
  'project.typeVideo': '视频',
  'project.typeAudio': '音频',
  'chat.brandBrowserLocalSnapshotMissing': '此 URL 没有已保存的页面快照。',
  'chat.brandBrowserLocalSnapshotReadFailed': '无法读取已保存的页面快照。',
  'chat.brandBrowserSnapshotSaveFailed': '无法从浏览器保存页面快照。',
  'chat.brandBrowserAssistDownloadGuideTitle': '已打开 Browser',
  'chat.brandBrowserAssistDownloadGuideDetails': '第 1 步：打开或切到右侧 Browser tab，并完成必要的人机验证。第 2 步：点击 More，再点击“下载页面”。第 3 步：等待页面快照保存成功提示。第 4 步：回到左侧“下一步”卡片，点击“继续提取”继续程序化抽取。',
  'designFiles.projectMenu': '项目操作',
  'designFiles.createDesignSystemFromProject': '基于此项目创建设计系统',
  'designFiles.duplicateProject': '复制项目',
  'fileViewer.versions.entry': '版本',
  'fileViewer.versions.entryFull': '历史版本',
  'fileViewer.versions.title': '版本管理',
  'fileViewer.versions.countOne': '1 个版本',
  'fileViewer.versions.countMany': '{count} 个版本',
  'fileViewer.versions.current': '当前',
  'fileViewer.versions.sourceAi': 'AI 编辑',
  'fileViewer.versions.sourceManual': '手动编辑',
  'fileViewer.versions.sourceRestore': '回退生成',
  'fileViewer.versions.restoredFrom': '从 v{version} 回退',
  'fileViewer.versions.versionLabel': '版本 {version}',
  'fileViewer.versions.listAria': '文件版本',
  'fileViewer.versions.loading': '正在加载版本...',
  'fileViewer.versions.empty': '暂无版本。',
  'fileViewer.versions.loadFailed': '无法加载版本。',
  'fileViewer.versions.previewFailed': '无法加载此版本预览。',
  'fileViewer.versions.previewLoading': '正在加载版本预览...',
  'fileViewer.versions.noPrompt': '未记录提示词',
  'fileViewer.versions.noPromptBody': '此版本没有记录提示词。',
  'fileViewer.versions.promptTitle': '提示词',
  'fileViewer.versions.copyPrompt': '复制提示词',
  'fileViewer.versions.fullscreen': '全屏预览',
  'fileViewer.versions.open': "在新窗口打开预览",
  'fileViewer.versions.currentHelp': '这已经是当前版本。',
  'fileViewer.versions.restoreHelp': '切换会把此 HTML 恢复为新的当前版本。',
  'fileViewer.versions.restore': '切换到此版本',
  'fileViewer.versions.restoreConfirmTitle': '切换到此版本？',
  'fileViewer.versions.restoreConfirmCta': '切换',
  'fileViewer.versions.restoring': '切换中...',
  'fileViewer.versions.restoreFailed': '无法切换到此版本。',
  'fileViewer.versions.restoreSuccess': '已切换到此版本。',
  'nextStep.createDesignSystemTitle': '创建设计系统',
  'nextStep.createDesignSystemBody': '复制当前项目为设计系统工作区，并基于所有当前文件和参考启动 agent 生成。',
  'nextStep.createDesignSystemBusy': '正在创建设计系统...',
  'nextStep.projectContinueTitle': '继续处理',
  'nextStep.projectGenerateArtifactTitle': '生成产物',
  'nextStep.designSystemAiRefineTitle': 'AI 优化设计系统',
  'nextStep.designSystemAuditKitTitle': '审查 tokens 和组件套件',
  'nextStep.brandCreateDesignPrompt': '用「{designSystem}」设计系统创建一个新设计。',
  'nextStep.brandContinueExtractionTitle': '继续抽取',
  'nextStep.brandContinueExtractionBody': 'Browser 标签页完成验证后，读取当前页面并继续填充已保存的设计系统。',
  'nextStep.brandContinueExtractionBusy': '正在继续抽取...',
  'nextStep.brandContinueAiExtractionTitle': '继续 agent 抽取',
  'nextStep.brandContinueAiExtractionProgrammaticBody': '如果程序化抽取仍无法完成，使用当前 agent 从已保存草稿继续抽取。',
  'nextStep.brandContinueAiExtractionAiBody': '从当前品牌脚手架恢复 agent 抽取，并完成同一个设计系统。',
  'nextStep.brandContinueAiExtractionBusy': '正在继续 agent 抽取...',


  "newsletter.label": "邮箱地址（选填）",
  "newsletter.placeholder": "you@studio.com",
  "settings.memoryModelInlineLabel": "Memory 模型",
  "settings.memoryModelInlineSameAsChat": "与聊天一致",
  "settings.memoryModelInlineSameAsChatWithModel": "与聊天一致（{model}）",
  "settings.memoryModelInlineSameAsChatWithProvider":
    "与聊天一致（{provider}）",
  "settings.memoryModelInlineHintCli":
    "可选。支持的情况下会直接使用当前 Local CLI；这里只需要在想覆盖默认模型时选择。",
  "settings.memoryModelInlineHintCliConstrained":
    "可选。支持时会直接使用当前 Local CLI；{provider} 只作为不支持 CLI 时的备用供应商。",
  "settings.memoryModelInlineHintByok":
    "可选。复用你聊天用的 API key，在同供应商上换一个（通常更便宜的）模型来跑后台 memory 提取。",
  "settings.memoryModelInlineHintByokNeutral":
    "Memory 使用独立于聊天的模型，默认沿用当前聊天模型。",
  "settings.memoryModelInlineFlashSaved": "已保存",
  "settings.memoryModelInlineFlashCleared": "已清除",
  "settings.orbit.eyebrow": "自动化",
  "settings.orbit.title": "Orbit",
  "settings.orbit.navHint": "每日连接器摘要",
  "settings.orbit.lede":
    "按计划收集连接器活动，并将结果发布为可刷新的实时看板。",
  "settings.orbit.statusOnTitle": "每日计划运行已开启",
  "settings.orbit.statusOffTitle": "每日计划运行已关闭",
  "settings.orbit.statusActive": "活跃",
  "settings.orbit.statusOff": "关闭",
  "settings.orbit.runTitle": "启动一次 Orbit 运行并打开实时对话",
  "settings.orbit.running": "运行中…",
  "settings.orbit.runOpen": "立即运行",
  "settings.orbit.dailySummaryTitle": "每日摘要",
  "settings.orbit.dailySummarySub": "每天在计划的本地时间运行一次。",
  "settings.orbit.on": "开启",
  "settings.orbit.off": "关闭",
  "settings.orbit.runTimeTitle": "运行时间",
  "settings.orbit.runTimeSub": "默认 08:00。保存后应用到 daemon 计划。",
  "settings.orbit.runTimeAria": "每日 Orbit 运行时间",
  "settings.orbit.nextRun": "下次运行",
  "settings.orbit.nextRunScheduledAfterSave": "保存后计划",
  "settings.orbit.schedule": "计划",
  "settings.orbit.pausedManualOnly": "已暂停 — 仅手动运行",
  "settings.orbit.templateTitle": "提示词模板",
  "settings.orbit.templateMissing": "模板 {id} 未安装。",
  "settings.orbit.templateMissingOption": "{id}（缺失）",
  "settings.orbit.templateMissingInstall": "安装 Orbit skill 以引导提示词。",
  "settings.orbit.templateMissingPickAnother": "从下拉菜单选择另一个模板。",
  "settings.orbit.templateResetTitle": "重置为 {id}",
  "settings.orbit.templateReset": "重置",
  "settings.orbit.templateHelp":
    "用 skill 引导 Orbit — 所选模板的示例提示词会注入每次 Orbit 运行，让摘要遵循该模板结构。",
  "settings.orbit.templateAria": "Orbit 提示词模板",
  "settings.orbit.templatesLoading": "正在加载模板…",
  "settings.orbit.templatesOptgroup": "Orbit skill 模板",
  "settings.orbit.lastRun": "上次运行",
  "settings.orbit.triggerManual": "手动",
  "settings.orbit.triggerScheduled": "计划",
  "settings.orbit.meterAria":
    "已成功 {succeeded}，已跳过 {skipped}，失败 {failed}，共检查 {checked}",
  "settings.orbit.countChecked": "已检查",
  "settings.orbit.countSucceeded": "成功",
  "settings.orbit.countSkipped": "已跳过",
  "settings.orbit.countFailed": "失败",
  "settings.orbit.runError":
    "无法运行 Orbit。请确认本地 daemon 正在运行且连接器已配置。",
  "settings.orbit.gateAriaLabel": "使用 Orbit 需要先配置连接器",
  "settings.orbit.gateEyebrow": "需要先完成设置",
  "settings.orbit.gateTitle": "连接一个工具，让 Orbit 运行起来",
  "settings.orbit.gateBody":
    "Orbit 会汇总你已连接服务的活动。你目前还没有任何连接 —— 至少添加一个集成，让 Orbit 有内容可以报告。",
  "settings.orbit.gateBodyNoKey":
    "Orbit 会汇总连接器的活动，而连接器通过 Composio 运行。在「连接器」中填入 Composio API 密钥即可解锁目录并选择第一个集成。",
  "settings.orbit.gateAction": "打开连接器",
  "settings.orbit.gateActionNoKey": "配置 Composio",
  "settings.orbit.gateLoading": "正在检查连接器…",
  "settings.orbit.controlsLockedBadge": "已锁定",
  "settings.orbit.controlsLockedHint":
    "连接一个工具后即可解锁 Orbit 的排程与模板设置。",
  "settings.orbit.artifactKickerLive": "实时看板",
  "settings.orbit.artifactKickerLegacy": "旧版摘要",
  "settings.orbit.artifactTitle": "每日 Orbit 活动摘要",
  "settings.orbit.artifactMetaLive": "由连接器活动生成的可刷新 HTML artifact。",
  "settings.orbit.artifactMetaLegacy":
    "在启用实时看板支持之前生成 — 再次运行 Orbit 以发布一个。",
  "settings.orbit.copyMarkdownTitle": "复制 Markdown 摘要到剪贴板",
  "settings.orbit.copied": "已复制",
  "settings.orbit.copy": "复制",
  "settings.orbit.openArtifact": "打开 artifact",
  "settings.orbit.sourceMarkdown": "源 Markdown",
  "diagnostics.exportTitle": "导出诊断日志",
  "diagnostics.exportButton": "导出诊断日志",
  "diagnostics.exportHint":
    "将近期的应用日志和机器信息打包成 zip,方便发给我们排查问题。",
  "diagnostics.exporting": "导出中…",
  "diagnostics.exportSuccess": "诊断日志已保存到 {path}",
  "diagnostics.exportFailed": "导出诊断日志失败：{message}",
  "automations.eyebrow": "定时智能体会话",
  "automations.title": "自动化",
  "automations.lede": "为项目工作、Orbit 摘要和实时看板规划周期性会话。",
  "automations.summaryAria": "自动化概览",
  "automations.metricActive": "运行中",
  "automations.metricPaused": "已暂停",
  "automations.metricTemplates": "模板",
  "automations.newAutomation": "新建自动化",
  "automations.yourAutomations": "你的自动化",
  "automations.loading": "加载中",
  "automations.emptyTitle": "还没有自动化",
  "automations.emptyBody": "从模板创建一个，或从空白计划开始。",
  "automations.targetNewEachRun": "每次运行新建项目",
  "automations.targetCreateEachRun": "每次运行新建项目",
  "automations.lastRun": "上次运行 {time}",
  "automations.openResult": "打开结果",
  "automations.run": "运行",
  "automations.runNowTitle": "立即运行并打开会话",
  "automations.history": "历史记录",
  "automations.hideHistory": "隐藏历史记录",
  "automations.edit": "编辑",
  "automations.pause": "暂停",
  "automations.resume": "恢复",
  "automations.deleteAria": "删除自动化",
  "automations.deleteTitle": "删除此自动化",
  "automations.deleteConfirm": "删除此自动化？过去的运行及其项目会保留。",
  "automations.proposalsTitle": "进化提案",
  "automations.proposalsSub":
    "在自动化输出改动记忆、技能或设计体系之前先审阅。",
  "automations.proposalsPending": "{n} 个待处理",
  "automations.apply": "应用",
  "automations.reject": "拒绝",
  "automations.proposalsDismissReason": "在自动化中已忽略",
  "automations.templatesTitle": "模板",
  "automations.templatesSub": "Orbit 和实时看板都是同一自动化流程中的模板。",
  "automations.templatesCount": "{total} 个中的 {filtered} 个",
  "automations.templateFiltersAria": "模板筛选器",
  "automations.templatesEmptyTitle": "此分类下还没有模板。",
  "automations.templatesEmptyBody": "换一个筛选条件，或从空白自动化开始。",
  "automations.useTemplate": "使用模板",
  "automations.promptPlaceholder":
    "告诉代理按此计划运行什么，或用 @ 提及上下文...",
  "automations.runHistoryLoading": "正在加载运行历史…",
  "automations.runHistoryEmpty": "还没有运行记录。",
  "automations.runHistoryTitle": "运行历史",
  "automations.runHistoryLatest": "最近 10 条",
  "automations.crystallize": "沉淀",
  "automations.crystallizing": "沉淀中",
  "automations.crystallizeTitle": "根据本次运行起草技能和记忆提案",
  "automations.crystallizeFailed": "Crystallize failed: {error}",
  "automations.crystallizePartialSuccess":
    "Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.",
  "automations.crystallizeRefreshFailed":
    "Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.",
  "automations.crystallizeNoProposals":
    "Crystallize finished, but no proposals were returned. Try refreshing or check the run details.",
  "automations.openConversation": "打开会话",
  "automations.runHistoryAria": "自动化运行历史",
  "automations.proposalsAria": "自动化进化提案",
  "automations.templatesAria": "自动化模板",
  "automations.runInProgress": "进行中",
  "automations.scheduleStatusPaused": "已暂停",
  "automations.nextRunManualOnly": "仅手动",
  "automations.nextRunScheduled": "已排期",
  "automations.nextRunAt": "下次 {time}",
  "automations.statusSucceeded": "成功",
  "automations.statusFailed": "失败",
  "automations.statusRunning": "运行中",
  "automations.statusQueued": "排队中",
  "automations.statusCanceled": "已取消",
  "automations.kindOrbit": "Orbit",
  "automations.kindLiveArtifact": "实时看板",
  "automations.kindAutomation": "自动化",
  "automations.proposalTargetMemory": "记忆",
  "automations.proposalTargetDesignSystem": "设计体系",
  "automations.proposalTargetSkill": "技能",
  "automations.proposalTargetTemplate": "自动化模板",
  "automations.proposalActionCreate": "创建",
  "automations.proposalActionUpdate": "更新",
  "automations.proposalActionMerge": "合并",
  "automations.proposalActionMove": "移动",
  "automations.proposalActionDelete": "删除",
  "automations.proposalActionPromote": "提升",
  "automations.filterAll": "全部",
  "automations.filterOrbit": "Orbit",
  "automations.filterLiveArtifacts": "实时看板",
  "automations.filterMemory": "记忆",
  "automations.filterDesignSystems": "设计体系",
  "automations.filterSkills": "技能",
  "automations.filterConnectors": "连接器",
  "automations.filterCompression": "压缩",
  "automations.filterRelease": "发布",
  "automations.filterQuality": "质量",
  "automations.tpl.memoryRefresh.title": "根据近期工作刷新项目记忆。",
  "automations.tpl.memoryRefresh.desc":
    "把重复的决策、偏好和反馈转化为可复用的记忆更新。",
  "automations.tpl.designSystemRefresh.title": "根据已交付的制品更新设计体系。",
  "automations.tpl.designSystemRefresh.desc":
    "在近期设计工作中发现可复用的 token、组件和规则。",
  "automations.tpl.liveArtifactRegistry.title": "审计实时看板并刷新过时版本。",
  "automations.tpl.liveArtifactRegistry.desc":
    "让持久的仪表盘、报告和预览保持最新，而不是重复创建。",
  "automations.tpl.orbitDashboard.title": "构建连接器活动仪表盘。",
  "automations.tpl.orbitDashboard.desc":
    "把选定的连接器聚合成 Orbit 风格的实时仪表盘。",
  "automations.tpl.releaseNotes.title": "根据已交付的设计工作起草发布说明。",
  "automations.tpl.releaseNotes.desc":
    "把已合并的 PR、制品和面向产品的改动整合成发布说明。",
  "automations.tpl.qualityRegressionWatch.title": "监测设计与实现的回归问题。",
  "automations.tpl.qualityRegressionWatch.desc":
    "把近期改动与基准、追踪记录和已采纳的参考进行对比。",
  "automations.tpl.orbitDaily.title": "每日连接器摘要。",
  "automations.tpl.orbitDaily.desc": "按计划刷新连接器活动摘要。",
  "automations.tpl.liveStatusBoard.title": "保持实时状态制品始终最新。",
  "automations.tpl.liveStatusBoard.desc":
    "更新同一个持久制品，而不是每次运行都新建报告。",
  "dsManager.areaAria": "设计体系区域",
  "dsManager.tabDesignSystem": "设计体系",
  "dsManager.tabTemplate": "模板",
  "dsManager.sourceAria": "设计体系来源",
  "dsManager.templateSourceAria": "模板来源",
  "dsManager.yourSystems": "你的体系",
  "dsManager.officialPresets": "官方预设",
  "dsManager.shareToTeam": "分享到团队",
  "dsManager.shareToTeamFailed": "分享到团队失败",
  "dsManager.syncToTeam": "同步更新到团队",
  "dsManager.syncToTeamFailed": "同步更新到团队失败",
  "dsManager.unshareFromTeam": "取消团队共享",
  "dsManager.unshareFromTeamFailed": "取消团队共享失败",
  "dsManager.teamSyncedReadOnly": "仅分享者或工作区管理员可更改",
  "dsManager.enterprise": "企业版",
  "dsManager.yourTemplates": "你的模板",
  "dsManager.yourSystemsAria": "你的设计体系",
  "dsManager.eyebrowDesignSystems": "设计体系",
  "dsManager.yourSystemsHeading": "你的体系",
  "dsManager.filterAria": "筛选设计体系",
  "dsManager.filterAll": "全部",
  "dsManager.filterPublished": "已发布",
  "dsManager.filterDraft": "草稿",
  "dsManager.createTitle": "新建设计体系",
  "dsManager.createBody":
    "把你的品牌、产品、代码、素材和设计参考教给 OpenDesign。",
  "dsManager.createAction": "创建",
  "dsManager.emptyMine":
    "还没有设计体系。从真实的产品上下文创建一个，审阅草稿后再发布，供以后的项目使用。",
  "dsManager.badgeDefault": "对话默认",
  "dsManager.rowMetaUpdated": "你 · 更新于 {date}",
  "dsManager.edit": "编辑",
  "dsManager.openSystem": "编辑体系",
  "dsManager.editWithAgent": "用 Agent 编辑",
  "dsManager.downloadTitle": "下载设计体系（.zip + SKILLS.md）",
  "dsManager.downloadAria": "下载 {title} 为 .zip",
  "dsManager.downloadFailed": "无法下载该设计体系，请重试。",
  "dsManager.deleteConfirm":
    "删除「{title}」？这会从本设备移除该草稿设计体系。",
  "dsManager.makeDefault": "设为新对话默认",
  "dsManager.statusPublished": "已发布",
  "dsManager.statusDraft": "草稿",
  "dsManager.openSystemAria": "编辑 {title}",
  "dsManager.deleteSystemAria": "删除 {title}",
  "dsManager.deletePermissionDenied": "你没有权限删除这个设计体系。",
  "dsManager.presetsAria": "官方设计体系预设",
  "dsManager.eyebrowLibrary": "库",
  "dsManager.eyebrowTemplates": "模板",
  "dsManager.yourTemplatesAria": "你的模板",
  "dsManager.emptyTemplates":
    "还没有模板。启用模板发布后，可通过任意已生成项目的「分享」来创建。",
  "dsManager.templateDescFallback": "从项目创建",
  "dsManager.comingSoonBadge": "敬请期待",
  "dsManager.enterpriseDsTitle": "企业设计体系",
  "dsManager.enterpriseDsBody": "团队共享的设计体系和受管控的品牌库即将推出。",
  "dsManager.enterpriseTplTitle": "企业模板",
  "dsManager.enterpriseTplBody": "团队批准的模板和组织级发布即将推出。",
  "settings.instructionsTitle": "指令与规则",
  "settings.instructionsSubtitle": "助手应始终遵循的固定行为",
  "settings.instructionsNavSub": "固定的助手行为",
  "settings.customInstructionsDesc":
    "OpenDesign 在每次对话中都会遵循的固定指令。它们不是保存的记忆；事实、偏好和项目上下文请使用「记忆」。",
  "mcpClient.forwardedToLabel": "已转发给：",
  "mcpClient.notForwardedToLabel": "未转发给：",
  "mcpClient.forwardedAcpNote":
    "标记为 stdio only 的 ACP 适配器只会从此列表接收 stdio 类型的 MCP 服务器；HTTP 和 SSE 条目会在启动时被丢弃。",
  "mcpClient.notForwardedNote":
    "对于这些智能体，请在其各自的配置文件中配置 MCP 服务器（例如 ~/.codex/config.toml、~/.gemini/settings.json）；下方的服务器在那里不会生效。",

  // Design systems library + extraction
  "brand.libraryTitle": "设计系统",
  "brand.librarySubtitle":
    "把你的设计系统教给 OpenDesign——从网站提取一个设计系统，然后在任意对话中应用它。",
  "brand.newBrand": "新建设计系统",
  "brand.searchPlaceholder": "搜索你的设计系统…",
  "brand.empty": "还没有设计系统。从一个网站提取一个设计系统即可开始。",
  "brand.colorsCount": "{count} 种颜色",
  "brand.extracting": "提取中…",
  "brand.failed": "提取失败",
  "brand.needsInput": "需要操作",
  "brand.needsInputHint": "提取已暂停 —— 打开项目完成验证或回答问题。",
  "brand.appliedToChat": "正在使用 {name}",
  "brand.previewEmpty": "选择一个设计系统进行预览",
  "brand.viewDetails": "查看详情",
  "newBrand.title": "新建设计系统",
  "newBrand.subtitle":
    "粘贴一个网站，或在下方挑选一个品牌，我们会提取它的颜色、字体和标识。",
  "newBrand.urlLabel": "品牌网站",
  "newBrand.urlPlaceholder": "yourcompany.com",
  "newBrand.extract": "提取设计系统",
  "newBrand.cancel": "取消",
  "newBrand.close": "关闭",
  "newBrand.stage1": "正在抓取网站并测量其设计",
  "newBrand.stage2": "正在构建设计系统预览",
  "newBrand.stage3": "正在推导并注册设计系统",
  "newBrand.measured": "{colors} 种颜色 · {fonts} 种字体 · {logos} 个标识",
  "newBrand.done": "设计系统已就绪",
  "brandDetail.identity": "品牌标识",
  "brandDetail.designLanguage": "设计语言",
  "brandDetail.colors": "颜色",
  "brandDetail.fonts": "字体",
  "brandDetail.tone": "语气",
  "brandDetail.aesthetic": "审美风格",
  "brandDetail.tagline": "标语",
  "brandDetail.voice": "声音",
  "brandDetail.useInChat": "在新对话中使用",
  "brandDetail.delete": "删除设计系统",
  "brandDetail.back": "设计系统",
  "brandDetail.refining": "正在优化此设计系统…",
  "brandDetail.notFound": "未找到设计系统。",
  "brandDetail.logo": "Logo",
  "brandDetail.typography": "字体排版",
  "brandDetail.palette": "调色板",
  "brandDetail.voiceTone": "语气与调性",
  "brandDetail.imageryLayout": "图像与布局",
  "brandDetail.images": "图像",
  "brandDetail.designSystem": "设计系统",
  "brandDetail.brandAssets": "设计系统素材",
  "brandDetail.openProject": "打开项目",
  "brandDetail.themeLight": "浅色",
  "brandDetail.themeDark": "深色",
  "brandDetail.subjects": "主题",
  "brandDetail.treatment": "处理方式",
  "brandDetail.useLabel": "使用",
  "brandDetail.avoidLabel": "避免",
  "brandDetail.layoutPosture": "布局准则",
  "brandDetail.deleteConfirm": '删除"{name}"？这会移除该设计系统。',
  "brandDetail.viewMore": "查看全部 {count} 张",
  "brandDetail.viewLess": "收起",
  "settings.resetOnboarding": "重置引导流程",
  "settings.resetOnboardingDesc": "重新进行首次设置，包括品牌提取。",
  "settings.resetOnboardingButton": "重置",
  "settings.clearUpdaterCacheTitle": "清理更新缓存",
  "settings.clearUpdaterCacheHint": "删除已下载的更新与残留的更新缓存，并重置更新状态。当更新疑似卡住时使用。",
  "settings.clearUpdaterCacheButton": "清理缓存",
  "settings.clearUpdaterCacheConfirmButton": "确认清理",
  "settings.clearUpdaterCacheSuccess": "更新缓存已清理。",
  "settings.clearUpdaterCacheFailed": "更新缓存清理失败。",
  "onboarding.brandTitle": "提取你的设计系统",
  "onboarding.brandSubtitle":
    "粘贴品牌网站，我们会把品牌线索转成后续可复用的设计系统。",
  "onboarding.brandSkip": "暂时跳过",
  "onboarding.brandDone": "设计系统已提取",
  "onboarding.buildTitle": "一次创建,处处复用",
  "onboarding.buildBody":
    "OpenDesign 把你的品牌沉淀为可复用的设计系统,让你之后构建的一切都保持品牌一致。",
  "onboarding.buildBenefitMemoryTitle": "一份品牌记忆",
  "onboarding.buildBenefitMemoryBody":
    "颜色、字体、间距、组件和语气会沉淀成可复用的 DESIGN.md。",
  "onboarding.buildBenefitAlignedTitle": "每个产出都保持一致",
  "onboarding.buildBenefitAlignedBody":
    "原型、幻灯片、PDF、看板和营销物料都会使用同一套规则。",
  "onboarding.buildBenefitSourcesTitle": "从已有材料开始",
  "onboarding.buildBenefitSourcesBody":
    "可以使用 GitHub 仓库、网站、现有 DESIGN.md、截图、字体或 Figma 文件。",
  "onboarding.buildPreviewLabel": "品牌系统",
  "onboarding.buildStart": "创建设计系统",
  "onboarding.buildHome": "直接进入主页",
  "dsCreate.referenceLabel": "从现有设计系统复制",
  "dsCreate.referenceLoading": "正在加载 DESIGN.md...",
  "dsCreate.referenceLoadFailed": "无法加载该设计系统。",
  "dsCreate.heroShowGuideAria": "显示设计系统指南",
  "dsCreate.heroHideGuideAria": "隐藏设计系统指南",
  "dsCreate.heroShowGuideTitle": "显示指南",
  "dsCreate.heroHideGuideTitle": "隐藏指南",
  "dsCreate.heroGuide": "指南",
  "dsCreate.missingSourceError":
    "请添加网站、DESIGN.md、描述、文件、Figma 来源或备注来创建设计系统。",
  "dsCreate.continueToGeneration": "继续生成",
  "dsCreate.embeddedTitle": "从你的素材生成",
  "dsCreate.embeddedBody": "先添加网站或品牌参考，再补充你已有的源文件。",
  "dsCreate.sourceSectionTitle": "从 GitHub、网站或源素材提取",
  "dsCreate.sourceSectionBody":
    "从 GitHub 仓库、网站、DESIGN.md 或能体现风格的文件开始。OpenDesign 会先快速创建一套可用系统，然后 AI 可在项目中继续细化。",
  "dsCreate.githubWebsiteLabel": "GitHub 或网站",
  "dsCreate.add": "添加",
  "dsCreate.startFromBrand": "从品牌开始",
  "dsCreate.brandPickerSubtitle":
    "搜索数百个品牌，选择一个后我们会把它的网站作为风格参考加入。",
  "dsCreate.brandPickerQuickPicks": "热门品牌 · 点击添加",
  "dsCreate.addedSourceLinks": "已添加的来源链接",
  "dsCreate.openSourceLabel": "打开 {label}",
  "dsCreate.removeSourceLabel": "移除 {label}",
  "dsCreate.addFiles": "添加文件",
  "dsCreate.describeBrand": "描述品牌",
  "dsCreate.optional": "可选",
  "dsCreate.describeBrandHelp":
    "品牌语气、简介和产品上下文。会用于快速生成和 AI 细化。",
  "dsCreate.companyPlaceholder":
    "例如：Mission Impastabowl，一个支持自助点餐、移动应用和网站的快休闲意面餐厅",
  "dsCreate.pasteDesignMd": "粘贴 DESIGN.md",
  "dsCreate.pasteDesignMdHelp":
    "粘贴 DESIGN.md，即可直接从 token、设计理由和组件指南创建设计系统。",
  "dsCreate.reference": "参考",
  "dsCreate.designMdViewMode": "DESIGN.md 查看模式",
  "dsCreate.advancedToggle": "高级 · 仓库、本地代码、Figma",
  "dsCreate.githubRepo": "GitHub 仓库",
  "dsCreate.localCodeLabel": "关联本地代码",
  "dsCreate.localCodeHelper": "使用此电脑上的文件夹或选中的文件。",
  "dsCreate.localCodePrompt": "拖入文件夹或浏览",
  "dsCreate.uploadFigLabel": "上传 .fig",
  "dsCreate.uploadFigHelper":
    "在你的设备上解码为真实 token、组件和素材，无需 Figma 账号。",
  "dsCreate.uploadFigPrompt": "拖入 .fig 或浏览",
  "dsCreate.figmaUrl": "Figma URL",
  "dsCreate.figmaPlaceholder": "https://figma.com/design/… 或 /file/…",
  "dsCreate.addedFigmaUrls": "已添加的 Figma URL",
  "dsCreate.savedFigmaHelp":
    "已保存为 Figma 设计来源。Agent 会把它作为标准参考；如需完整离线解码，请在上方导出 .fig。",
  "dsCreate.notes": "备注",
  "dsCreate.notesPlaceholder":
    "例如：我们使用温暖自然的配色和圆角。品牌语气有趣但专业...",
  "dsCreate.back": "返回",
  "dsCreate.generate": "生成",
  "dsCreate.libraryPickerTitle": "从资料库选择",
  "dsCreate.libraryPickerConfirm": "添加到素材",
  "dsCreate.designMdPreviewKicker": "设计系统",
  "dsCreate.designMdPreviewTitle": "DESIGN.md 预览",
  "dsCreate.componentKit": "组件套件",
  "dsCreate.defaultTheme": "默认主题",
  "dsCreate.componentKitTitle": "{name} · 组件套件",
  "dsCreate.designMdGeneratedDescription":
    "由粘贴的 DESIGN.md token、设计理由和组件指南生成。",
  "dsCreate.previewButtons": "按钮",
  "dsCreate.previewButtonsHelp": "五种类型，三种尺寸。",
  "dsCreate.buttonPrimary": "主要",
  "dsCreate.buttonDashed": "虚线",
  "dsCreate.buttonText": "文本",
  "dsCreate.buttonLink": "链接",
  "dsCreate.sizeSmall": "小",
  "dsCreate.sizeMedium": "中",
  "dsCreate.sizeLarge": "大",
  "dsCreate.previewTypeScale": "字体层级",
  "dsCreate.extractedTokens": "提取的 DESIGN.md token",
  "brandPicker.categorySoftware": "软件",
  "brandPicker.categoryFinance": "金融",
  "brandPicker.categoryFashion": "时尚",
  "brandPicker.categoryActivewear": "运动服饰",
  "brandPicker.categoryBeauty": "美妆",
  "brandPicker.categoryWellness": "健康养护",
  "brandPicker.categoryFood": "食品",
  "brandPicker.categoryBeverage": "饮料",
  "brandPicker.categoryMedia": "媒体",
  "brandPicker.categoryEducation": "教育",
  "brandPicker.categoryElectronics": "电子产品",
  "brandPicker.categoryAutomotive": "汽车",
  "brandPicker.categoryHealthcare": "医疗健康",
  "brandPicker.categoryTravel": "旅行",
  "brandPicker.heading": "从你喜欢的品牌开始",
  "brandPicker.subtext": "点击任意品牌，即可直接从其网站提取设计系统。",
  "brandPicker.quickPicksLabel": "热门品牌 · 点击即可提取",
  "brandPicker.searchPlaceholder": "搜索品牌…",
  "brandPicker.allCategories": "全部",
  "brandPicker.extractAction": "提取",
  "brandPicker.showMore": "显示更多",
  "brandPicker.opening": "正在开始提取 — 正在打开 {brand}…",
  "ds.kitVisualize": "可视化",
  "ds.kitEdit": "编辑",
  "ds.kitSource": "源码",
  "ds.saveDesignMd": "保存 DESIGN.md",
  "ds.saving": "保存中…",
  "ds.copyDesignMd": "复制 DESIGN.md",
  "ds.editDesignMd": "编辑 DESIGN.md",
  "ds.openDesignMd": "打开 DESIGN.md",
  "ds.copyDesignMdModule": "复制{module}段落",
  "ds.editDesignMdModule": "编辑{module}段落",
  "ds.openDesignMdModule": "打开{module}段落",
  "ds.uploadMd": "上传 MD",
  "ds.uploadFont": "添加字体文件",
  "ds.pasteImage": "粘贴图片",
  "ds.refresh": "刷新",
  "ds.download": "下载",
  "ds.importFolder": "导入文件夹",
  "ds.reset": "重置",
  "ds.editingDesignMdHint": "编辑这份 Markdown 会更新已渲染的套件模块。",
  "ds.editingModuleHint": "仅编辑{module}模块。",
  "ds.manualEditModuleHint": "在这里编辑{module}。悬停此模块可显示修改控件。",
  "ds.saveModule": "保存模块",
  "ds.uploadLogo": "上传 Logo",
  "ds.uploadImage": "上传图片",
  "ds.uploading": "上传中…",
  "ds.moduleEmptyLogo": "暂无 Logo",
  "ds.moduleEmptyFonts": "暂无字体文件。",
  "ds.actionDone": "完成",
  "ds.actionFailed": "出错了，请重试。",
  "ds.uploadDone": "已上传",
  "ds.uploadFailed": "上传失败，请重试。",
  "ds.deleteLogo": "删除 Logo",
  "ds.deleteImage": "删除 {caption}",
  "ds.deleteProjectConfirm":
    "删除「{title}」？这会从本设备永久移除该设计体系及其项目。",
  "ds.deleteProjectAction": "删除 {title}",
  "ds.editColor": "编辑{name}",
  "ds.colorLabel": "颜色",
  "ds.hexLabel": "Hex",
  "ds.hexValueLabel": "Hex 值",
  "ds.saveColor": "保存颜色",
  "ds.invalidHexColor": "请输入有效的 Hex 颜色，例如 #FF6A3D。",
  "ds.colorSaveFailed": "无法保存该颜色。",
  "ds.colorResetFailed": "无法重置该颜色。",
  "ds.designMdSectionLabel": "{module} DESIGN.md 段落",
  "ds.kitErrorTitle": "此视图遇到问题。",
  "ds.kitErrorRetry": "重新加载",
  "ds.shortcutsLabel": "键盘快捷键",
  "ds.shortcutsHint": "快捷键：E 编辑 · C 复制 · U 上传 · R 刷新 · ⌫ 删除 Logo",
  "ds.moduleEmptyImages": "暂无图片",
  "ds.noOriginalColor": "暂无可用于该色板的原始颜色。",
  "ds.manifestReadFailed": "无法读取 _ds_manifest.json。",
  "ds.reviewCollapseSection": "收起{title}",
  "ds.reviewExpandSection": "展开{title}",
  "ds.reviewNeedsReview": "待审阅",
  "ds.reviewLooksGood": "看起来不错",
  "ds.reviewActionsLabel": "审阅{title}",
  "ds.reviewNeedsWorkEllipsis": "需要修改...",
  "ds.reviewEditFile": "编辑 {file}",
  "ds.reviewFeedbackLabel": "告诉 agent 需要改什么",
  "ds.reviewFeedbackPlaceholder":
    "例如：收紧 {title} 的间距，重新生成这个预览...",
  "ds.reviewChangedAfterFeedback":
    "此段落已根据你的反馈发生变化。发布前请再次审阅。",
  "ds.reviewChangedDuringRun": "此段落在最近一次运行中发生变化。发布前请审阅。",
  "ds.reviewLastFeedback": "上次反馈",
  "ds.previewGenerating": "正在生成预览...",
  "ds.creatingProjectTitle": "正在创建你的设计体系...",
  "ds.creatingProjectSubtitle": "请保持此标签页打开。几分钟后可以回来查看。",
  "ds.generationProgressLabel": "设计体系生成进度 {progress}%",
  "ds.publishRepoRequiredTitle": "请先完成 GitHub 仓库导入，再发布。",
  "ds.publishDesignSystem": "发布设计体系",
  "ds.unpublishDesignSystem": "取消发布设计体系",
  "ds.published": "已发布",
  "ds.publish": "发布",
  "ds.extractionRunningTitle": "正在提取设计体系",
  "ds.extractionCompleteTitle": "提取完成",
  "ds.extractionRunningBody": "OpenDesign 正在就地更新此体系。",
  "ds.extractionCompleteBody": "已提取的模块如下所示；空段落会保持为空。",
  "ds.publishCardPublished": "团队的新项目默认可以使用此设计体系作为上下文。",
  "ds.publishCardDraft":
    "你的设计体系已准备好，但反馈可以继续改进它。准备好用于后续项目时再发布。",
  "ds.useSystemTitle": "使用此体系",
  "ds.useSystemBody":
    "新建设计会继承此体系的颜色、字体和组件，并自动保持品牌一致。",
  "ds.createNewDesign": "新建设计",
  "ds.openSourceContext": "打开来源上下文",
  "ds.manifestNeedsAttention": "设计 manifest 需要处理",
  "ds.openManifest": "打开 manifest",
  "ds.workspacePreparing": "正在准备设计体系工作区。",
  "ds.workspaceLoadingLabel": "设计体系工作区正在加载",
  "ds.sectionQueued": "已排队",
  "ds.sectionReviewUpdatedFiles": "审阅已更新文件",
  "ds.reviewNeedsWork": "需要修改",
  "ds.sectionRequiredFileMissing": "缺少 {file}",
  "ds.sectionNoFilesYet": "暂无文件",
  "ds.generationSourceTitle": "探索已提供资源",
  "ds.generationSourceDetail":
    "公司背景、GitHub 仓库、本地代码文件夹、Figma 文件、字体、Logo 和备注。",
  "ds.generationGuidanceTitle": "创建 DESIGN.md",
  "ds.generationGuidanceDetail": "作为项目上下文使用的规范指南。",
  "ds.generationTokensTitle": "创建 tokens",
  "ds.generationTokensDetail": "颜色、字体、间距和圆角证据。",
  "ds.generationPreviewsTitle": "创建预览卡片",
  "ds.generationPreviewsDetail": "用于设计体系标签页的 HTML 审阅卡片。",
  "ds.generationUiKitTitle": "创建 UI kit",
  "ds.generationUiKitDetail": "可复用的界面示例。",
  "ds.generationAssetsTitle": "登记资产",
  "ds.generationAssetsDetail": "Logo、图标、字体和品牌文件。",
  "ds.phaseQueuedTypography": "字体已排队",
  "ds.phaseQueuedTokens": "Token 已排队",
  "ds.phaseQueuedSpacing": "间距已排队",
  "ds.phaseQueuedUiKit": "UI kit 已排队",
  "ds.phaseQueuedAssets": "资产已排队",
  "ds.phaseReadingTypography": "正在读取字体",
  "ds.phaseReadingTokens": "正在读取 tokens",
  "ds.phaseReadingSpacing": "正在读取间距",
  "ds.phaseReadingUiKit": "正在读取 UI kit",
  "ds.phaseReadingAssets": "正在读取资产",
  "ds.phaseWritingTypography": "正在写入字体",
  "ds.phaseWritingTokens": "正在写入 tokens",
  "ds.phaseWritingSpacing": "正在写入间距",
  "ds.phaseBuildingUiKit": "正在构建 UI kit",
  "ds.phaseUpdatingAssets": "正在更新资产",
  "ds.phaseNeedsAttention": "需要处理",
  "ds.phaseUpdated": "已更新",
  "ds.sectionActivityFromTodo": "{phase}，来自待办：{todo}",
  "ds.sectionActivityReadFiles": "已读取 {files}",
  "ds.sectionActivityPhaseFiles": "{phase}：{files}",
  "ds.sectionRunningReadingContext":
    "OpenDesign 正在读取 {title} 的段落上下文。",
  "ds.sectionRunningNow": "{phase}中。",
  "ds.reviewLastReviewed": "上次审阅 {time}",
  "ds.agentFeedbackQueued": "反馈已保存。当前运行结束后，agent 会继续处理。",
  "ds.agentFeedbackSent": "已发送给 agent。",
  "ds.agentFeedbackSentAt": "已于 {time} 发送给 agent。",
  "ds.agentFeedbackFailedWithError": "Agent 任务失败：{error}",
  "ds.agentFeedbackFailed": "Agent 任务失败。",
  "ds.agentFeedbackUnknown": "Agent 任务状态未知。",
  "ds.repoConnectBannerTitle": "连接你的仓库，以提取设计体系信息",
  "ds.repoConnectCardTitle": "连接仓库",
  "ds.repoConnectPendingBody": "正在检查 GitHub 连接...",
  "ds.repoConnectPendingButton": "正在检查 GitHub...",
  "ds.repoConnectedTitle": "GitHub 已连接",
  "ds.repoConnectedBody": "重新导入此仓库，把文件拉入你的设计体系。",
  "ds.repoImportButton": "导入仓库",
  "ds.repoConnectBannerBody":
    "连接 GitHub 后，OpenDesign 可以读取你的仓库，并把颜色、字体和组件提取到此设计体系中。",
  "ds.repoConnectCardBody": "从仓库中提取颜色、字体和组件到此设计体系。",
  "ds.repoConnectButton": "连接 GitHub",
  // Settings > Workspace region (E-frontend, D4.3): role-gated shell for
  // other-lane workspace destinations (members / billing / team space).
  'settings.workspace': '工作区',
  'settings.workspaceHint': '成员、订阅与团队空间',
  'settings.workspaceLede': '该工作区的团队级设置。以下区域由团队服务提供，点击任一入口继续。',
  'settings.workspaceBack': '返回工作区',
  'settings.workspaceMembers': '成员与邀请',
  'settings.workspaceMembersHint': '管理谁可以访问该工作区，并发送邀请。',
  'settings.workspaceBilling': '订阅与席位',
  'settings.workspaceBillingHint': '该工作区的套餐、席位与付款。',
  'settings.workspaceAutoRecharge': '自动充值',
  'settings.workspaceAutoRechargeHint': '余额不足时自动充值额度。',
  'settings.workspaceTeamSpace': '团队空间',
  'settings.workspaceTeamSpaceHint': '团队的共享项目与可见性。',
  // Full-page Settings (`/settings`): sidebar nav head above the section list.
  'settings.pageBackToHome': '返回首页',
  'settings.pageNavGroupPersonal': '个人',
  "newproj.startFromLabel": "起点",
  "newproj.startBlank": "空白",
  "newproj.startBlankHint": "从零开始",
  "workspace.pages": "页面",
  "workspace.allProjectFiles": "全部项目文件",
  "workspace.newBlankPage": "新建空白页面",
  "workspace.noPagesYet": "还没有页面",
  "workspace.pageCreateFailed": "无法创建页面。",
  "workspace.pageCreatorTitle": "新建页面",
  "workspace.pageCreatorSearch": "搜索模板",
  "workspace.pageCreatorCategoryAll": "全部场景",
  "workspace.pageCreatorEmpty": "没有匹配的页面类型。",
  "workspace.pageCreatorPreview": "预览",
  "workspace.pageCreatorUse": "使用",
  "fileViewer.presentInTabDeckHint": "演讲者备注会在弹窗中打开",
  "fileViewer.presentEscHint": "按 Esc 退出演示",
  "fileViewer.presenterPause": "暂停",
  "fileViewer.presenterResume": "继续",
  "fileViewer.presenterPrevious": "上一页",
  "fileViewer.presenterNext": "下一页",
  "questions.uploadingFiles": "正在上传文件…",
  "questions.uploadNeedsProject": "文件上传需要一个活跃的项目。",
  "questions.uploadPartialFailed": "已上传 {uploaded} 个文件，{failed} 个失败。",
  "questions.uploadFailed": "有 {failed} 个文件上传失败。",
  'chat.messageRail.aria': '用户消息导航',
  'chat.messageRail.jumpAria': '跳转到第 {index} 条用户消息',
  'chat.messageRail.empty': '（无内容）',
  'fileViewer.editScreenshotToChat': '截图发送到对话输入框',
  'manualEdit.textAlignLeft': '左对齐',
  'manualEdit.textAlignCenter': '居中对齐',
  'manualEdit.textAlignRight': '右对齐',
  'manualEdit.parameters': "参数",
  'manualEdit.fontFamily': "字体",
  'manualEdit.borderColor': "边框颜色",
  'manualEdit.borderWidth': "边框宽度",
  'manualEdit.height': "高度",
  'manualEdit.sideTop': "上",
  'manualEdit.sideBottom': "下",
  'manualEdit.sideLeft': "左",
  'manualEdit.sideRight': "右",
  'manualEdit.layoutDirection': "布局方向",
  'manualEdit.distribution': "分布",
  'manualEdit.gap': "间距",
  'manualEdit.layoutUnavailable': "布局控件仅适用于 flex 或 grid 容器。",
  'manualEdit.directionRow': "水平",
  'manualEdit.directionRowReverse': "水平反向",
  'manualEdit.directionColumn': "垂直",
  'manualEdit.directionColumnReverse': "垂直反向",
  'manualEdit.justifyStart': "开始",
  'manualEdit.justifyCenter': "居中",
  'manualEdit.justifyEnd': "结束",
  'manualEdit.justifyBetween': "两端对齐",
  'manualEdit.justifyAround': "四周留白",
  'manualEdit.justifyEvenly': "均匀分布",
  'manualEdit.alignStart': "起始",
  'manualEdit.alignEnd': "结束",
  'manualEdit.alignStretch': "拉伸",
  'manualEdit.alignBaseline': "基线",
  // #5517 media-providers redesign: pill selector + single detail card.
  'settings.mediaProviderModelProviders': '提供商',
  'settings.mediaProviderModel': '模型',
  'settings.mediaProviderModelPlaceholder': '使用提供商默认值',
  'settings.mediaProviderDocsTitle': '文档',
  'settings.mediaProviderDocsHint': '查看此提供商的配置说明。',
  'settings.mediaProviderSaveHint': '选择“保存”前，更改不会保存。',
  'settings.mediaProviderNoKeyRequired': '无需密钥',
  'settings.mediaProviderNoKeyHint': '该提供商使用本地登录或内置运行时。',
  'manualEdit.sectionImage': '图片',
  'manualEdit.sectionContent': '内容',
  'manualEdit.sectionPage': '页面',
  'manualEdit.pageBackground': '背景',
  'manualEdit.pageBaseSize': '基准字号',
  'manualEdit.pageStylesHtmlOnly': '页面样式仅适用于完整的 HTML 文档。',
  'pluginsView.createKindPlugin': '插件',
  'pluginsView.createKindSkill': '技能',
  'pluginsView.importUrlLabel': '链接',
  'pluginsView.shareActionBadge': '动作插件',
  'pluginsView.shareCloseAria': '关闭分享确认',
  'pluginsView.shareWhatStarts': '将会启动什么',
  'pluginsView.shareSourcePlugin': '来源插件',
  'pluginsView.shareFactPlugin': '插件',
  'pluginsView.shareFactId': '标识',
  'pluginsView.shareFactCopiedTo': '复制到',
  'pluginsView.shareFactTrust': '信任级别',
  'pluginsView.shareActionPrompt': '动作提示词',
  'pluginsView.shareStarting': '正在启动…',
  'community.title': '社区',
  'community.searchPlaceholder': '搜索',
  'community.searchAria': '搜索',
  'community.filtersAria': '模板筛选',
  'community.closePreview': '关闭预览',
  'community.typePrototype': '原型',
  'community.typeLiveArtifact': '实时产物',
  'community.typeSlides': '幻灯片',
  'community.typeDocument': '文档',
  'community.typeImage': '图片',
  'community.typeVideo': '视频',
  'community.typeHyperFrames': 'HyperFrames',
  'community.typeAudio': '音频',
  'community.typeWebGL': 'WebGL',
  'community.usePrompt': '做同款',
  'community.emptyTitle': '还没有{type}模板',
  'community.emptyBody': '社区发布的模板会出现在这里。',
  'marketplace.title': '插件市场',
  'marketplace.filterTrusted': '受信任',
  'marketplace.filterRestricted': '受限',
  'marketplace.emptyBefore': '还没有安装任何插件。可以试试',
  'marketplace.emptyAfter': '，或在下方注册一个市场源。',
  'marketplace.trustPrefix': '信任级别：',
  'marketplace.catalogsTitle': '已配置的目录源',
  'marketplace.catalogsEmpty': '尚未注册任何目录源。可以用以下命令添加：',
  'marketplace.pluginCount': '{count} 个插件',
  'genui.continue': '继续',
  'genui.authorize': '授权',
  'genui.skip': '跳过',
  'genui.acceptAll': '全部接受',
  'genui.rejectAll': '全部拒绝',
  'genui.submit': '提交',
  'genui.submitPartial': '提交部分决定',
  'genui.patchNotesPlaceholder': '给补丁作者的备注（可选）',
  'inspect.close': '关闭检查器',
  'inspect.colors': '颜色',
  'inspect.text': '文字',
  'inspect.background': '背景',
  'inspect.typography': '排版',
  'inspect.size': '字号',
  'inspect.weight': '字重',
  'inspect.align': '对齐',
  'inspect.padding': '内边距',
  'inspect.radius': '圆角',
  'inspect.resetElement': '重置元素',
  'library.title': '素材库',
  'library.headerHint': '一键把任意网页、设计系统、截图、图片或 Figma 导入的 JSON 收藏进素材库 —— 本地优先，无需登录。',
  'library.getClipper': '获取 OpenDesign 网页剪藏插件',
  'library.searchPlaceholder': '搜索说明、标签、标题…',
  'library.filterByKind': '按类型筛选',
  'library.filterBySource': '按来源筛选',
  'library.kindAll': '全部类型',
  'library.kindImages': '图片',
  'library.kindElements': '元素',
  'library.kindDesignSystems': '设计系统',
  'library.kindVideo': '视频',
  'library.kindFonts': '字体',
  'library.kindColors': '颜色',
  'library.kindText': '文本',
  'library.kindLinks': '链接',
  'library.sourceAll': '全部来源',
  'library.sourceClipper': '剪藏插件',
  'library.sourceAgent': '智能体',
  'library.sourceDesignSystem': '设计系统',
  'library.sourceGenerated': 'AI 生成',
  'library.viewMode': '视图模式',
  'library.viewGrid': '网格',
  'library.viewGridTooltip': '以网格方式展示素材',
  'library.viewTimeline': '时间线',
  'library.viewTimelineTooltip': '按日期分组，最新的排在前面',
  'library.refresh': '刷新',
  'library.refreshTooltip': '按当前筛选条件重新加载列表',
  'library.sync': '同步',
  'library.syncing': '同步中…',
  'library.syncTooltip': '把你的设计系统和智能体生成的产物拉取到素材库',
  'library.upload': '上传',
  'library.uploadTooltip': '把图片、字体或文件上传到素材库',
  'library.selectedCount': '已选 {count} 项',
  'library.selectAll': '全选',
  'library.clear': '清除',
  'library.chatToDesign': '对话生成设计',
  'library.chatToDesignTitle': '发起对话，把这 {count} 项变成设计',
  'library.working': '处理中…',
  'library.useInDesignSystem': '用于设计系统',
  'library.createDesignSystem': '新建设计系统',
  'library.createDesignSystemSub': '带着这 {count} 项素材进入创建流程',
  'library.refineExisting': '优化已有的',
  'library.noEditableDesignSystems': '还没有可编辑的设计系统。',
  'library.addAssetsAndRefine': '添加素材并打开优化',
  'library.deleteCount': '删除 {count} 项',
  'library.loading': '加载中…',
  'library.emptyTitle': '还没有任何素材。',
  'library.emptyHintBefore': '用 OpenDesign 网页剪藏插件从任意网页收藏，运行',
  'library.emptyHintAfter': '，或者在项目里上传 —— 所有内容都会汇集到这里。',
  'library.dropToUpload': '松开即可上传到素材库',
  'library.confirmDeleteTitleOne': '确定删除这 {count} 项素材吗？',
  'library.confirmDeleteTitleMany': '确定删除这 {count} 项素材吗？',
  'library.confirmDeleteBodyOne': '该素材将从素材库中永久删除，且无法恢复。',
  'library.confirmDeleteBodyMany': '这些素材将从素材库中永久删除，且无法恢复。',
  'library.cancel': '取消',
  'library.today': '今天',
  'library.yesterday': '昨天',
  'library.previewAsset': '预览 {title}',
  'library.selectAsset': '选择素材',
  'library.deselectAsset': '取消选择素材',
  'library.openDesignSystem': '打开设计系统',
  'library.openProject': '打开项目',
  'library.opening': '正在打开…',
  'library.editAsPage': '作为页面编辑',
  'library.viewSource': '来源',
  'library.remove': '移除',
  'mcp.aboutTemplate': '关于 {name}',
  'mcp.approvedRefresh': '我已授权 — 刷新',
  'mcp.approveInBrowserHint': '请在打开的浏览器标签页中授权。我们会自动接收回调 — 如果你已经完成授权，也可以点击下方的刷新。',
  'mcp.argsPlaceholder': '以空格分隔',
  'mcp.authModeNone': '不使用托管 OAuth',
  'mcp.authModeOAuth': '托管 OAuth',
  'mcp.browserDidntOpen': '浏览器没有打开？',
  'mcp.categoryDataViz': '数据可视化',
  'mcp.categoryDataVizHint': '将图表和示意图输出为规范的图片产物。',
  'mcp.categoryDesignSystems': '设计系统',
  'mcp.categoryDesignSystemsHint': 'Figma 读写、设计令牌转换、品牌灵感。',
  'mcp.categoryImageEditing': '图像编辑',
  'mcp.categoryImageEditingHint': '本地后处理、OCR 以及基于计算机视觉的编辑。',
  'mcp.categoryImageGeneration': '图像生成',
  'mcp.categoryImageGenerationHint': '生成位图、矢量图或视频素材的模型。',
  'mcp.categoryPublishing': '发布',
  'mcp.categoryPublishingHint': '将生成的产物推送到公开 URL。',
  'mcp.categoryUiComponents': 'UI 组件',
  'mcp.categoryUiComponentsHint': '设计师级别的组件、区块和落地页素材。',
  'mcp.categoryUtilities': '实用工具',
  'mcp.categoryUtilitiesHint': '文件系统、网络请求、GitHub 等通用工具。',
  'mcp.categoryWebCapture': '网页截取',
  'mcp.categoryWebCaptureHint': '把 URL 渲染成图片，让智能体看到自己做出来的东西。',
  'mcp.checking': '检查中…',
  'mcp.clickConnectHint': '点击「连接」，通过服务商的 OAuth 流程授予 OpenDesign 访问权限。',
  'mcp.closePicker': '关闭选择器',
  'mcp.collapse': '收起',
  'mcp.collapseServerAria': '收起此 MCP 服务器',
  'mcp.commandPlaceholder': '例如 npx、node、/path/to/binary',
  'mcp.commandRequired': 'stdio 传输方式必须填写命令。',
  'mcp.completedAuthTitle': '我已完成授权 — 立即检查连接状态',
  'mcp.connect': '连接',
  'mcp.connected': '已连接。',
  'mcp.connecting': '连接中…',
  'mcp.customServer': '自定义服务器',
  'mcp.customServerDesc': '空白表单。自行选择 stdio 或 SSE / HTTP 并填写各字段。',
  'mcp.disabled': '已禁用',
  'mcp.disconnect': '断开连接',
  'mcp.disconnectFailed': '断开连接失败。请检查守护进程日志。',
  'mcp.disconnecting': '断开中…',
  'mcp.displayNamePlaceholder': '显示名称（可选）',
  'mcp.enabled': '已启用',
  'mcp.enableServerAria': '启用此 MCP 服务器',
  'mcp.expand': '展开',
  'mcp.expandServerAria': '展开此 MCP 服务器',
  'mcp.expandToEdit': '展开以编辑',
  'mcp.fieldArgs': '参数',
  'mcp.fieldCommand': '命令',
  'mcp.fieldEnv': '环境变量（KEY=VALUE）',
  'mcp.fieldEnvShort': '环境变量',
  'mcp.fieldHeaders': '请求头（KEY=VALUE）',
  'mcp.fieldId': 'ID',
  'mcp.fieldOAuthMode': 'OAuth 模式',
  'mcp.fieldTransport': '传输方式',
  'mcp.fieldUrl': 'URL',
  'mcp.homepage': '主页',
  'mcp.idInvalid': 'ID 必须以字母或数字开头，且只能包含字母、数字、短横线或下划线（最多 64 个字符）。',
  'mcp.jsonHelperExampleHead': 'MCP JSON 示例',
  'mcp.jsonHelperHttpNote': '使用 url + headers，而不是 command / args',
  'mcp.jsonHelperToggle': '需要帮助？参照下面的示例，把你的 MCP 服务器 JSON 配置对应过来。',
  'mcp.moveDown': '下移',
  'mcp.moveUp': '上移',
  'mcp.noManagedOAuth': '不使用托管 OAuth。',
  'mcp.noManagedOAuthSaveDirect': '保存此服务器后，OpenDesign 会直接使用它。',
  'mcp.noManagedOAuthUseAsConfigured': 'OpenDesign 会按你的配置使用此服务器。如果服务器需要令牌，请在下方添加请求头。',
  'mcp.nonExpiringToken': '令牌永不过期。',
  'mcp.notConnected': '未连接。',
  'mcp.openAuthorizationPage': '打开授权页面',
  'mcp.pickerFilterPlaceholder': '按名称、传输方式、能力筛选…',
  'mcp.pickerHint': '会预填表单。之后你仍然可以修改任意字段。',
  'mcp.pickerNoMatch': '没有模板匹配“{query}”。可以清除筛选条件，或使用下方的自定义服务器选项。',
  'mcp.pickTemplate': '选择模板',
  'mcp.reauthenticateTitle': '重新认证（会替换现有令牌）',
  'mcp.recheckTokenTitle': '向守护进程重新检查令牌状态',
  'mcp.reconnect': '重新连接',
  'mcp.refresh': '刷新',
  'mcp.removeServer': '移除此 MCP 服务器',
  'mcp.saveFirstThenClick': '先保存，然后点击',
  'mcp.starting': '启动中…',
  'mcp.toGrantOAuthAccess': '通过服务商的 OAuth 流程授予 OpenDesign 访问权限。',
  'mcp.tokenExpires': '令牌将于 {time} 过期。',
  'mcp.transportAria': '传输方式：{transport}',
  'mcp.tryLabel': '试试：',
  'mcp.tryPromptTitle': '把这段提示词粘贴到聊天输入框，端到端试用该服务器',
  'mcp.unnamedServer': '未命名的 MCP 服务器',
  'mcp.urlMalformed': 'URL 格式不正确。',
  'mcp.urlProtocolInvalid': 'URL 必须使用 http:// 或 https://。',
  'mcp.urlRequired': 'SSE / HTTP 传输方式必须填写 URL。',
  'mcp.waitingForAuthorization': '等待授权…',
  'memory.connectorReadFailed': '无法读取 {name}。',
  'memory.connectorNoReadableContent': '{name} 中没有可读取的内容。',
  'memory.providerLocalCli': '本地 CLI',
  'memory.providerFallbackName': '记忆模型',
  'memory.extractionSourceConnector': '已读取已连接的应用，但 OpenDesign 无法将这些上下文转化为记忆。',
  'memory.extractionSourceChat': 'OpenDesign 无法为这次对话运行记忆提取。',
  'memory.failureAuthExpiredTitle': '{provider} 身份验证已过期',
  'memory.failureAuthActionCli': '请登录所选的本地 CLI，或改选其他记忆模型。',
  'memory.failureAuthActionKey': '请更新记忆提取模型的密钥，或重新登录。',
  'memory.failureQuotaTitle': '已触及 {provider} 的配额或速率限制',
  'memory.failureQuotaAction': '请稍后重试，或更换记忆提取模型。',
  'memory.failureRequestTitle': '{provider} 请求失败',
  'memory.failureRequestActionCli': '请检查所选的本地 CLI 后重试。',
  'memory.failureRequestActionProvider': '请检查模型服务商的连接后重试。',
  'memory.failureGenericTitle': '记忆提取失败',
  'memory.failureGenericActionCli': '检查所选的本地 CLI 之后再试一次。',
  'memory.failureGenericActionSettings': '检查记忆提取模型的设置之后再试一次。',
  'memory.noData': '无数据',
  'memory.attemptReadTitle': '已读取 {name}',
  'memory.attemptFailedTitle': '无法读取 {name}',
  'memory.attemptSkippedTitle': '已跳过 {name}',
  'memory.skipChatDisabled': '对话学习已关闭。',
  'memory.kindConnectedApps': '已连接的应用',
  'memory.timeAgo': '{time}前',
  'memory.scanRunningTitle': '正在扫描已连接的应用',
  'memory.scanFailedTitle': '已连接应用扫描失败',
  'memory.scanSkippedTitle': '已跳过已连接应用扫描',
  'memory.scanSavedOne': '已保存 {count} 条记忆',
  'memory.scanSavedOther': '已保存 {count} 条记忆',
  'memory.scanNoNewMemories': '未发现新的记忆',
  'memory.scanTitle': '已连接应用扫描',
  'memory.scanMetaChecking': '正在检查所选应用',
  'memory.scanMetaNeedsAttention': '需要处理',
  'memory.scanMetaFromConnectedApps': '来自已连接的应用',
  'memory.scanMetaCheckedApps': '已检查所选应用',
  'memory.scanBusyLabel': '正在扫描应用',
  'memory.scanSelectPrompt': '选择要扫描的应用',
  'memory.scanSelectedApps': '扫描所选应用',
  'memory.connectorReadFailedRetry': '无法读取已连接的应用。请在「连接器」标签页中重试。',
  'memory.appCountOne': '{count} 个应用',
  'memory.appCountOther': '{count} 个应用',
  'memory.foundSuggestionsOne': '从 {apps} 中找到 {count} 条建议记忆。请先确认再保存。',
  'memory.foundSuggestionsOther': '从 {apps} 中找到 {count} 条建议记忆。请先确认再保存。',
  'memory.noSuggestionsFound': '未找到记忆建议。OpenDesign 暂时无法从所选应用中读取到有用的内容。',
  'memory.checkedNoSuggestionsOne': '已检查 {count} 个所选应用，但没有发现新的记忆建议。',
  'memory.checkedNoSuggestionsOther': '已检查 {count} 个所选应用，但没有发现新的记忆建议。',
  'memory.savedFromConnectedAppsOne': '已从已连接的应用中保存 {count} 条记忆。',
  'memory.savedFromConnectedAppsOther': '已从已连接的应用中保存 {count} 条记忆。',
  'memory.savedPartial': '已保存所选 {total} 条记忆中的 {saved} 条。请对剩余项目重试。',
  'memory.tabManual': '手动添加',
  'memory.tabManualCaption': '写下一条事实或偏好',
  'memory.tabConnected': '从应用导入',
  'memory.tabConnectedCaption': '扫描已连接的工具',
  'memory.storagePathAria': '记忆存储路径 — 点击复制',
  'memory.flowOnboarding': '引导设置',
  'memory.flowBrandContext': '品牌上下文',
  'memory.flowChatSignals': '对话信号',
  'memory.flowSavedMemory': '已保存的记忆',
  'memory.howCopy': '记忆会自动来自个人资料设置、项目与品牌提取、已连接的应用，以及对话中学到的有用事实。下方的已保存列表是复核界面；除非你打开「添加」或「高级设置」，其余部分都保持安静。',
  'memory.areasAria': '记忆分区',
  'memory.manualPanelHint': '自行添加事实、偏好或项目上下文。固定的助手行为请写在「指令 / 规则」中。',
  'memory.connectedPanelHint': '选择要扫描的应用，以获取设计偏好、项目上下文和视觉参考。在你选择应用之前不会扫描任何内容。',
  'memory.loading': '加载中',
  'memory.connectedCount': '已连接 {count} 个',
  'memory.manage': '管理',
  'memory.chooseSources': '选择来源',
  'memory.chooseSourcesHint': '请先选择已连接的应用。OpenDesign 只会扫描你选中的应用。',
  'memory.selectedCount': '已选 {count} 个',
  'memory.connectorListAria': '已连接的记忆应用',
  'memory.readToolsCount': '{count} 个读取工具',
  'memory.checkingConnectionStatus': '正在检查连接状态…',
  'memory.finishAuthorization': '请在浏览器中完成授权，然后返回此处',
  'memory.connectBeforeExtraction': '请先连接此应用再进行提取',
  'memory.useConnectorAria': '使用 {name} 进行记忆提取',
  'memory.selected': '已选择',
  'memory.select': '选择',
  'memory.reconnectConnectorAria': '重新连接 {name}',
  'memory.connectConnectorAria': '连接 {name}',
  'memory.connectStateChecking': '检查中',
  'memory.connectStateWaiting': '等待中',
  'memory.connectStateConnecting': '连接中',
  'memory.reconnect': '重新连接',
  'memory.selectedOfConnectedOne': '已在 {total} 个已连接应用中选择 {count} 个。',
  'memory.selectedOfConnectedOther': '已在 {total} 个已连接应用中选择 {count} 个。',
  'memory.suggestedMemories': '建议的记忆',
  'memory.suggestedMemoriesHint': '保存前请先复核与设计相关的记忆。',
  'memory.saving': '保存中',
  'memory.saveSelected': '保存所选',
  'memory.discard': '丢弃',
  'memory.diagnosticsAria': '已连接应用读取状态',
  'memory.lastScan': '上次扫描',
  'memory.bytesRead': '已读取 {bytes}',
  'memory.recentScans': '最近的扫描',
  'memory.runHistoryAria': '已连接应用记忆运行状态',
  'memory.savedMemoryHint': '已保存的事实、偏好和项目上下文，可供后续对话使用。',
  'memory.savedCount': '已保存 {count} 条',
  'memory.extractionCountOne': '{count} 次提取',
  'memory.extractionCountOther': '{count} 次提取',
  'memory.emptyHintBefore': '在对话中告诉助手一条事实 — 例如',
  'memory.emptyHintAfter': '— 它就会自动保存到这里。',
  'memory.advancedHint': '查看或编辑底层的记忆索引。',
  'memory.memoryTree': '记忆树',
  'memory.memoryTreeHint': '同一批已保存记忆的技术视图。大多数用户只需要上方的已保存记忆列表。',
  'memory.nodeCountOne': '{count} 个节点',
  'memory.nodeCountOther': '{count} 个节点',
  'dsCreate.addingSourceMaterial': '正在添加素材…',
  'dsCreate.browseFolder': '浏览文件夹',
  'dsCreate.confirmBody': '你将进入一个实时填充的项目 —— 随着我们分析你的品牌，标志、配色、字体和图像会逐步出现。请保持标签页打开。',
  'dsCreate.confirmTitle': 'OpenDesign 将提取你的设计系统。',
  'dsCreate.designMdPreviewFallbackName': '设计系统',
  'dsCreate.dropZoneSelections': '{label} 已选内容',
  'dsCreate.extractDesignSystem': '提取设计系统',
  'dsCreate.extractionAlreadyStarting': '提取已在启动中，请等待当前请求完成。',
  'dsCreate.figmaFileFallbackLabel': 'Figma 文件',
  'dsCreate.figmaUrlInvalid': '请输入 Figma 文件链接（https://figma.com/file/… 或 /design/…）。',
  'dsCreate.githubAccessAutoBody': 'GitHub 仓库链接会使用第一个可用的访问方式；其他网站链接会保存为来源引用。',
  'dsCreate.githubAccessAutoTitle': 'GitHub 访问：自动',
  'dsCreate.githubAccessMethodsAria': 'GitHub 仓库访问方式',
  'dsCreate.githubAuthorizeFailed': '无法启动 GitHub 授权。',
  'dsCreate.githubBadgeAutomatic': '自动',
  'dsCreate.githubBadgeChecking': '检查中',
  'dsCreate.githubBadgeComingSoon': '即将推出',
  'dsCreate.githubBadgeConnected': '已连接',
  'dsCreate.githubBadgeNeedsAttention': '需要处理',
  'dsCreate.githubBadgeNotConfigured': '未配置',
  'dsCreate.githubBadgeOptional': '可选',
  'dsCreate.githubBadgePending': '待处理',
  'dsCreate.githubComposioCheckingDesc': '正在后台检查连接器状态；链接录入不受影响。',
  'dsCreate.githubComposioConnectedAsDesc': 'Composio GitHub 连接器已以 {account} 身份连接；当本机无法读取仓库时可作为后备方式。',
  'dsCreate.githubComposioConnectedDesc': '当本机无法读取仓库时，可使用 Composio GitHub 连接器作为后备方式。',
  'dsCreate.githubComposioDefaultDesc': '为智能体工具提供 Composio GitHub 连接器访问；仓库链接仍可通过本地 git 或 GitHub CLI 使用。',
  'dsCreate.githubComposioErrorDesc': '请重新连接 Composio GitHub 连接器，或继续使用本地 git/GitHub CLI。',
  'dsCreate.githubComposioNotConfiguredDesc': '仅当此项目需要基于连接器的 GitHub 工具时，才添加 Composio API 密钥。',
  'dsCreate.githubComposioPendingDesc': '请在 Composio 授权窗口中完成操作；本地 GitHub 录入仍然可用。',
  'dsCreate.githubConfigureComposio': '配置 Composio',
  'dsCreate.githubConnecting': '连接中…',
  'dsCreate.githubConnectorCheckFailed': '无法检查 GitHub 连接器。',
  'dsCreate.githubConnectorCheckTimeout': '无法完成 GitHub 连接器检查。你仍然可以添加仓库链接或手动连接 GitHub。',
  'dsCreate.githubConnectViaComposio': '通过 Composio 连接',
  'dsCreate.githubDisconnect': '断开连接',
  'dsCreate.githubDisconnectFailed': '无法断开 GitHub 连接。',
  'dsCreate.githubDisconnecting': '断开连接中…',
  'dsCreate.githubHideAccessMethods': '隐藏访问方式',
  'dsCreate.githubMethodConnectorPlatform': '连接器平台',
  'dsCreate.githubMethodOdAccount': 'OpenDesign 账号',
  'dsCreate.githubMethodOdAccountDesc': '由 OpenDesign 管理的原生 GitHub 登录；此版本尚未使用 OD 托管的 GitHub 令牌。',
  'dsCreate.githubMethodThisDevice': '本机',
  'dsCreate.githubMethodThisDeviceDesc': '使用公开的 git clone、本机 git 凭据，或本机可用的 GitHub CLI 认证。',
  'dsCreate.githubOpenAuthorization': '打开授权页面',
  'dsCreate.githubShowAccessMethods': '显示访问方式',
  'dsCreate.libraryPartiallyAdded': '已从素材库添加 {total} 项中的 {added} 项。',
  'dsCreate.localCodeFilesSelected': '已选择 {count} 个本地代码文件',
  'dsCreate.prepareProjectFailed': '无法准备设计系统项目。',
  'dsCreate.removeFile': '移除 {name}',
  'dsCreate.startingExtraction': '正在开始提取…',
  'dsFlow.activityDetailFailed': '运行详情在聊天消息中。你可以调整请求后重试。',
  'dsFlow.activityDetailReady': '请查看已更新的「设计系统」和「设计文件」标签页。',
  'dsFlow.activityDetailRunning': '正在监听项目文件并准备评审草稿。',
  'dsFlow.activityFailedTitle': '工作区更新需要处理',
  'dsFlow.activityProgressAria': '工作区更新进度 {progress}%',
  'dsFlow.activityReadyTitle': '工作区更新已就绪',
  'dsFlow.activityRunningTitle': 'OpenDesign 正在更新此设计系统',
  'dsFlow.addBrandFonts': '添加品牌字体文件',
  'dsFlow.agentMsgCapturedDirection': '已捕获的方向：{summary}',
  'dsFlow.agentMsgCreating': '我正在根据你提供的上下文创建设计系统工作区、预览卡片和配套文件。',
  'dsFlow.agentMsgReady': '你的设计系统草稿已就绪。你可以查看「设计系统」标签页、检查生成的文件、发布它，或在这里让我做修改。',
  'dsFlow.agentMsgRevision': '我正在把你的反馈应用到设计系统上。修订进行期间，你可以继续查看当前草稿。',
  'dsFlow.agentMsgTokenRebuild': '我正在准备一份供评审的令牌契约重建。在修订被接受之前，当前生效的契约不会改变。',
  'dsFlow.agentPushLayer': '智能体推送层',
  'dsFlow.assetsLabel': '资源',
  'dsFlow.auditNeedsRepair': '{summary} 请在执行修复前查看审计详情。',
  'dsFlow.brandFontsMissingBody': '在添加品牌字体文件之前，排版预览将使用替代的网页字体。',
  'dsFlow.brandFontsMissingTitle': '缺少品牌字体文件',
  'dsFlow.chatCreateRequest': '创建设计系统',
  'dsFlow.chatSeedUpdateSystem': '更新这个设计系统：',
  'dsFlow.composerPlaceholder': '后续操作：使用 AI 提取来完善这个系统。耗时较长，更新会显示在这里。',
  'dsFlow.conversationCreateFailed': '无法创建设计系统会话。',
  'dsFlow.evidenceFallbackTokens': '回退令牌',
  'dsFlow.evidenceFonts': '字体',
  'dsFlow.evidenceIndexes': '证据索引',
  'dsFlow.evidenceScannedFiles': '已扫描文件',
  'dsFlow.evidenceSnippets': '代码片段',
  'dsFlow.evidenceSourceTokens': '来源令牌',
  'dsFlow.fileDraftPreview': '文件草稿预览',
  'dsFlow.filesTouched': '涉及的文件',
  'dsFlow.forceRebuild': '强制执行',
  'dsFlow.generalRevision': '通用修订',
  'dsFlow.generationCompleted': '生成已完成',
  'dsFlow.generationProgressAria': '生成进度 {progress}%',
  'dsFlow.generationStopped': '生成已停止',
  'dsFlow.generationStoppedWithError': '生成已停止：{error}',
  'dsFlow.jobCompleted': '{noun}已完成',
  'dsFlow.jobDetailGeneration': '正在准备剩余文件。',
  'dsFlow.jobDetailReady': '评审工作区已就绪。',
  'dsFlow.jobDetailRevision': '正在应用你的反馈。',
  'dsFlow.jobDetailTokenRebuild': '正在准备可评审的令牌契约草稿。',
  'dsFlow.jobNeedsAttention': '{noun}需要处理',
  'dsFlow.jobNounGeneration': '生成',
  'dsFlow.jobNounRevision': '修订',
  'dsFlow.jobNounTokenRebuild': '令牌重建',
  'dsFlow.jobRebuildingTokens': 'OpenDesign 正在重建令牌',
  'dsFlow.jobRevising': 'OpenDesign 正在修订',
  'dsFlow.jobStillWorking': 'OpenDesign 仍在处理中',
  'dsFlow.loadingDesignSystem': '正在加载设计系统…',
  'dsFlow.metaEvidenceNotes': '证据笔记',
  'dsFlow.metaScannedInventory': '已扫描文件清单',
  'dsFlow.metaSnippetIndex': '片段索引',
  'dsFlow.metaTokenExtraction': '令牌提取证据',
  'dsFlow.metaTokenReport': '令牌契约质量报告',
  'dsFlow.movedBackToDraft': '已退回草稿状态',
  'dsFlow.needsWorkSeed': '{title} 需要修改：',
  'dsFlow.no': '否',
  'dsFlow.openingDesignSystemWorkspace': '正在打开设计系统工作区…',
  'dsFlow.openingWorkspace': '正在打开工作区…',
  'dsFlow.packageFallbackMeta': '{source} · 仅 DESIGN.md 回退方案',
  'dsFlow.packageLegacy': '旧版设计系统',
  'dsFlow.packageManifestMeta': '{source} · {mode} 模式 · 清单已建立索引',
  'dsFlow.packagePillFallback': '回退',
  'dsFlow.packagePillReady': '混合模式就绪',
  'dsFlow.packageStructured': '结构化导入包',
  'dsFlow.pendingRevision': '待处理的修订',
  'dsFlow.pickLocalAgentFirst': '请先选择一个本地智能体，然后让 OpenDesign 更新这个设计系统。',
  'dsFlow.previewPages': '预览页面',
  'dsFlow.proposedChanges': '建议的改动',
  'dsFlow.publishCardReady': 'OpenDesign 已可供评审。请对目前的成果给出反馈，确认它对后续项目有用后再发布。',
  'dsFlow.publishCardRevision': 'OpenDesign 正在应用你的反馈。在准备更新草稿期间，你可以继续评审。',
  'dsFlow.publishCardTokenRebuild': 'OpenDesign 正在准备一份供评审的令牌契约重建。在你接受之前，当前生效的契约保持不变。',
  'dsFlow.publishCardWorking': 'OpenDesign 仍在处理中，但你已经可以对目前的成果给出反馈。',
  'dsFlow.pullLayer': '拉取层',
  'dsFlow.rebuildTokenContract': '重建令牌契约',
  'dsFlow.reviewDraftTitle': '评审设计系统草稿',
  'dsFlow.revisionAccept': '接受',
  'dsFlow.revisionAccepted': '修订已接受',
  'dsFlow.revisionAcceptFailed': '无法接受修订',
  'dsFlow.revisionHistory': '修订历史',
  'dsFlow.revisionMsgAccepted': '已接受。设计系统草稿现在包含了这次更新。',
  'dsFlow.revisionMsgPending': '我准备了一份更新提案。请查看右侧的差异卡片，然后接受它或提出其他修改。',
  'dsFlow.revisionMsgRejected': '已拒绝。当前的设计系统保持不变。',
  'dsFlow.revisionProgressUnavailable': '无法读取修订进度',
  'dsFlow.revisionReady': '修订已可供评审',
  'dsFlow.revisionReject': '拒绝',
  'dsFlow.revisionRejected': '修订已拒绝',
  'dsFlow.revisionRejectFailed': '无法拒绝修订',
  'dsFlow.revisionStopped': '修订已停止',
  'dsFlow.revisionStoppedWithError': '修订已停止：{error}',
  'dsFlow.saveChangesFailed': '无法保存更改',
  'dsFlow.savedDesignMd': '已保存 DESIGN.md',
  'dsFlow.sectionDraftBody': '草稿正文',
  'dsFlow.sectionFallbackTitle': '章节',
  'dsFlow.sectionMarkedLooksGood': '{title} 已标记为「看起来不错」',
  'dsFlow.sectionNoContent': '暂无内容。',
  'dsFlow.sectionNoDetails': '暂无详情。',
  'dsFlow.setDefaultAction': '设为新对话的默认项',
  'dsFlow.setDefaultTitle': '在新对话和新项目中预先选中这个设计系统。',
  'dsFlow.sourceEvidence': '来源证据',
  'dsFlow.sourceTypeBundled': '内置',
  'dsFlow.sourceTypeDefault': '设计系统',
  'dsFlow.sourceTypeGithub': 'GitHub 导入',
  'dsFlow.sourceTypeInstalled': '已安装',
  'dsFlow.sourceTypeLocal': '本地导入',
  'dsFlow.sourceTypeUser': '用户工作区',
  'dsFlow.statusUpdateFailed': '无法更新状态',
  'dsFlow.stepReadCurrentSystem': '读取当前系统',
  'dsFlow.stepRefreshReview': '刷新评审',
  'dsFlow.stepUpdateDesignFiles': '更新设计文件',
  'dsFlow.subtitleBrand': '标志、语调与使用规范',
  'dsFlow.subtitleColor': '配色与语义角色',
  'dsFlow.subtitleComponents': '可复用的界面模式',
  'dsFlow.subtitleDefault': '设计指引',
  'dsFlow.subtitleSpacing': '间距体系与圆角令牌',
  'dsFlow.subtitleTypography': '文字层级与样式',
  'dsFlow.tabDesignFiles': '设计文件',
  'dsFlow.tabDesignSystem': '设计系统',
  'dsFlow.tokenContractLabel': '令牌契约',
  'dsFlow.tokenContractRebuildRecommended': '建议重建',
  'dsFlow.tokenContractReportAvailable': '已有质量报告',
  'dsFlow.tokenContractScore': '得分 {score}',
  'dsFlow.tokenRebuildStarted': '令牌契约重建已开始',
  'dsFlow.tokenRebuildStartFailed': '无法启动令牌契约重建',
  'dsFlow.workspaceOpenFailed': '无法打开设计系统工作区。',
  'dsFlow.workspaceUpdatedReview': '工作区已更新。请查看这些文件，或提出其他修改。',
  'dsFlow.workspaceUpdatedSynced': '工作区已更新，DESIGN.md 已同步以供评审。',
  'dsFlow.workspaceUpdatedWithAudit': '工作区已更新。{summary}',
  'dsFlow.yes': '是',
  'pluginDetail.backToList': '返回列表',
  'pluginDetail.quickCommands': '快捷命令',
  'pluginDetail.noQuickCommands': '暂无可用的快捷命令。',
  'pluginDetail.dataConnections': '数据连接',
  'pluginDetail.noDataConnections': '此套件不需要外部数据连接。',
  'pluginDetail.knowledgeSkills': '知识技能',
  'pluginDetail.noKnowledgeSkills': '此套件暂无独立知识技能。',
  'pluginDetail.officialBadge': 'OpenDesign 官方',
  'pluginDetail.loadFailed': '插件加载失败：{error}',
  'pluginDetail.applyFailed': '应用失败，请确认守护进程可访问。',
  'pluginDetail.examples': '示例',
  'skillDetail.providedBy': '由 {author} 提供',
  'skillDetail.markdownNotice': '以下内容来自该技能的 SKILL.md 原文',
  'skillDetail.loadFailed': '无法加载此技能的 SKILL.md。',
  'skillDetail.previewAria': '{title} SKILL.md 预览',
  'common.dismiss': '关闭',
  'campaign.deepseekV4Flash.headline': '这次，顶级智能无限用。',
  'campaign.deepseekV4Flash.description': '落地页、网站、幻灯片、图片，无限做，做到满意',
  'campaign.deepseekV4Flash.benefit': 'DeepSeek V4 Pro 与 V4 Flash 无限使用',
  'campaign.deepseekV4Flash.timing': '8 月 13 日至 8 月 27 日，活动期间免费使用',
  'campaign.deepseekV4Flash.ruleSummary': '8 月 13 日至 8 月 27 日，付费用户可在产品内免费使用 DeepSeek V4 Pro 与 V4 Flash；大规模盗刷等违规行为将暂停活动权益。',
  'campaign.deepseekV4Flash.windowLabel': '8 月 13 日—8 月 27 日',
  'campaign.deepseekV4Flash.weekFreeSuffix': '两周免费用',
  'campaign.deepseekV4Flash.boundary': '套餐内的无限制模型额度与免费生成次数，仅可通过OpenDesign使用；无法在MCP/CLI/API及其他场景使用。解释权归官方所有。部分模型高峰期需要排队。',
  'campaign.deepseekV4Flash.countdownLabel': '活动倒计时',
  'campaign.deepseekV4Flash.countdownEnded': '活动已结束',
  'campaign.deepseekV4Flash.countdownRemaining': '{days}天 {hms}',
  'campaign.deepseekV4Flash.closeAria': '关闭',
  'campaign.deepseekV4Flash.unlocked': '已解锁',
  'campaign.deepseekV4Flash.locked': '待解锁',
  'campaign.deepseekV4Flash.later': '稍后再说',
  'campaign.deepseekV4Flash.paid.eyebrow': '两周免费开放',
  'campaign.deepseekV4Flash.paid.status': '已解锁 · 8 月 13 日—8 月 27 日',
  'campaign.deepseekV4Flash.paid.cta': '立即使用',
  'campaign.deepseekV4Flash.paid.modelBadge': '无限使用',
  'campaign.deepseekV4Flash.unpaid.eyebrow': '付费用户免费开放',
  'campaign.deepseekV4Flash.unpaid.status': '升级后可用 · 截止 8 月 27 日',
  'campaign.deepseekV4Flash.unpaid.cta': '升级套餐，立即使用',
  'campaign.deepseekV4Flash.unpaid.modelBadge': '升级可用',
  'campaign.deepseekV4Flash.unpaid.tooltip': '活动窗口内订阅付费套餐后可用，统一于 8 月 27 日结束。',
  'campaign.deepseekV4Flash.restricted.modelBadge': '已暂停',
  'campaign.deepseekV4Flash.restricted.tooltip': '检测到异常的大规模使用，本活动权益已暂停；如有疑问请联系支持。',
  'campaign.deepseekV4Flash.workbenchBadge': 'DeepSeek V4 Pro + V4 Flash 无限免费用',
  'campaign.deepseekV4Flash.workbenchBadgeAria': 'DeepSeek V4 Pro 与 V4 Flash 无限免费用，查看官网 Pricing',

  'experienceSurvey.tag': "期待您的反馈，与我们一起完善 OpenDesign",
  'experienceSurvey.close': "关闭",
  'experienceSurvey.recommendation': "你有多大可能把 OpenDesign 推荐给同事或朋友？",
  'experienceSurvey.recommendationLow': "完全不会",
  'experienceSurvey.recommendationHigh': "一定会",
  'experienceSurvey.improvement': "你最希望我们优先改进哪一项？",
  'experienceSurvey.improvement.wrongOutput': "做的不是我要的东西",
  'experienceSurvey.improvement.falseDone': "说做好了，但没变化",
  'experienceSurvey.improvement.hardToUse': "用起来不顺手",
  'experienceSurvey.improvement.upgradePrompts': "付费弹窗太多",
  'experienceSurvey.improvement.stuck': "中途卡住或失败",
  'experienceSurvey.improvement.slow': "太慢，等太久",
  'experienceSurvey.improvement.looks': "做出来不好看",
  'experienceSurvey.improvement.regression': "改坏了别的地方",
  'experienceSurvey.improvement.other': "其他",
  'experienceSurvey.otherPlaceholder': "说说你遇到的情况",
  'experienceSurvey.submit': "提交",
  'experienceSurvey.skip': "跳过",
  'experienceSurvey.thanksTitle': "感谢反馈！",
  'experienceSurvey.thanksBody': "你的反馈会直接同步给团队。",
  'chat.record.verb.read': "读取",
  'chat.record.verb.write': "新建",
  'chat.record.verb.edit': "改写",
  'chat.record.verb.search': "搜索",
  'chat.record.verb.exec': "执行",
  'chat.record.failed': "失败",
  'chat.record.hits': "{count} 处",
  'chat.record.slowUpstream': '上游响应慢，已等 {seconds} 秒',
  'chat.record.running': "进行中",
  'chat.record.thinking': "思考中",
  'chat.record.thinkingTokens': "{count} tokens",
  'chat.record.thoughts': "思考过程",
  'chat.record.done': "已完成",
  'chat.record.failedTurn': "运行失败",
  'chat.record.plan': "执行计划 · {count} 步",
  'chat.record.planStep': "第 {current} / {total} 步",
  'chat.record.imageBatch': "生成配套插图",
  'chat.record.imageCount': "{count} 张",
  'chat.record.retry': "重试",
  'chat.record.viewImage': "查看第 {index} 张大图",
  'chat.record.viewLarge': "查看大图",
  'chat.record.imagePending': "配图生成中",
  'chat.record.audioBatch': "生成配套音频",
  'chat.record.videoBatch': "生成配套视频",
  'chat.record.audioCount': "{count} 段",
  'chat.record.videoCount': "{count} 条",
  'chat.record.audioPending': "音频生成中",
  'chat.record.videoPending': "视频生成中",
  'chat.record.viewAudio': "播放第 {index} 段音频",
  'chat.record.viewVideo': "播放第 {index} 条视频",
  'chat.designSystemStatus.title': "正在创建设计系统工作区",
  'chat.designSystemStatus.description': "Open Design 正在使用设置的来源生成此项目。",
  'labs.title': "Open Design 实验室",
  'labs.itemAbout': "关于 {name}",
  'labs.navHint': "抢先体验尚未正式发布的能力。",
  'labs.pageDesc': "抢先体验尚未正式发布的能力，通常已优于当前版本；随时关闭即可恢复现状。",
  'labs.harnessName': "Design Harness",
  'labs.harnessHint': "开启后，下次生成将使用 OpenDesign 最新生成策略，生成效果更精美（内测中）",
  'labs.harnessTooltip': "开启后改用 Open Design 为设计场景专门打造的 agent harness，产物在版式、结构和完成度上会明显更好。",
  'labs.harnessScope': "目前覆盖原型、PPT、营销物料与 Hyperframes；部分 agent 暂不支持。",
  'labs.envOverrideNotice': "当前由环境变量接管，无法在此修改。",
  'labs.loadFailedNotice': "读取不到这项设置，请确认本地 daemon 正在运行。",
  'labs.optOutPrompt': "已切回原来的生成方式。哪里不合适？",
  'labs.optOutWorseOutput': "产物变差",
  'labs.optOutTooSlow': "太慢",
  'labs.optOutNotWhatIWanted': "不是我要的",
  'labs.optOutOther': "其他",
  'labs.optOutSkip': "跳过",
  'labs.optOutOtherPlaceholder': "具体是哪里不合适？",
  'labs.optOutSubmit': "提交",
  'chat.conversationsSearchPlaceholder': "搜索会话",
  'chat.conversationsNoMatches': "没有匹配的会话。",
  'chat.attachments.preview': "预览 {name}",
  'chat.record.canceled': "已取消",
  'chat.record.pending': "未开始",
  'chat.record.unfinished': "未完成",
};
